export default {
    getStringFilterQuery(filter, queryProperty) {
        var encodedValue = encodeURIComponent(filter.value || '').replace('\'', '\'\'');
        switch (filter.method) {
            case 'is':
                return `${queryProperty} eq '${encodedValue}'`;
            case 'is not':
                return `${queryProperty} ne '${encodedValue}'`;
            case 'contains':
                return `contains(${queryProperty}, '${encodedValue}')`;
            case 'doesn\'t contain':
                return `not contains(${queryProperty}, '${encodedValue}')`;
            case 'starts with':
                return `startswith(${queryProperty}, '${encodedValue}')`;
            case 'ends with':
                return `endswith(${queryProperty}, '${encodedValue}')`;
            case 'is defined':
                return `(${queryProperty} ne null and ${queryProperty} ne '')`;
            case 'is not defined':
                return `(${queryProperty} eq null or ${queryProperty} eq '')`;
        }

        return null;
    },

    getMatchFilterQuery(filter, queryProperty) {
        switch (filter.method) {
            case 'is':
                return `${queryProperty} eq ${filter.value.id}`;
            case 'is not':
                return `${queryProperty} ne ${filter.value.id}`;
            case 'is defined':
                return `${queryProperty} ne null`;
            case 'is not defined':
                return `${queryProperty} eq null`;
        }

        return null;
    },

    getNumberFilterQuery(filter, queryProperty) {
        switch (filter.method) {
            case 'greater than':
                return `${queryProperty} gt ${filter.value}`;
            case 'less than':
                return `${queryProperty} lt ${filter.value}`;
            case 'equal to':
                return `${queryProperty} eq ${filter.value}`;
        }

        return null;
    },

    getJourneyCategoryFilterQuery(filter, queryProperty) {
        switch (filter.method) {
            case 'is': 
                return `${queryProperty}/any(j: contains(j, '${filter.value.name}'))`;
            case 'is not':
                return `not ${queryProperty}/any(j: contains(j, '${filter.value.name}'))`;
            case 'is defined':
                return `${queryProperty}/any()`;
            case 'is not defined':
                return `not ${queryProperty}/any()`;
        }

        return null;
    },

    getCollateralCategoryFilterQuery(filter) {
        switch (filter.method) {
            case 'is':
                return `Categories/any(c: c/Name eq '${filter.value.name}')`;
            case 'is not':
                return `not Categories/any(c: c/Name eq '${filter.value.name}')`;
            case 'is defined':
                return 'Categories/any()';
            case 'is not defined':
                return 'not Categories/any()';
        }

        return null;
    },

    getJourneyTemplateCategoryFilterQuery(filter, queryProperty) {
        switch (filter.method) {
            case 'is': 
                return `${queryProperty}/any(j: contains(j/Name, '${filter.value.name}'))`;
            case 'is not':
                return `not ${queryProperty}/any(j: contains(j/Name, '${filter.value.name}'))`;
            case 'is defined':
                return `${queryProperty}/any()`;
            case 'is not defined':
                return `not ${queryProperty}/any()`;
        }

        return null;
    },

    getLandingPageCategoryFilter(filter){
        switch(filter.method){
            case 'is':
                return `Categories/any(c: c/Name eq '${filter.value.name}')`;
            case 'is not':
                return `not Categories/any(c: c/Name eq '${filter.value.name}')`;
            case 'is defined':
                return 'Categories/any()';
            case 'is not defined':
                return 'not Categories/any()';
        }
    },

    getDateFilterQuery(filter, queryProperty) {
        switch (filter.method) {
            case 'before':
                return `${queryProperty} lt ${filter.value}`;
            case 'after':
                return `${queryProperty} gt ${filter.value}`;
        }

        return null;
    },

    getPercentFilterQuery(filter, queryProperty) {
        switch (filter.method) {
            case 'greater than':
                return `${queryProperty} gt ${filter.value / 100}`;
            case 'less than':
                return `${queryProperty} lt ${filter.value / 100} or ${queryProperty} eq null`;
            case 'equal to':
                return `${queryProperty} eq ${filter.value / 100}`;
        }

        return null;
    },

    getContactNameFilterQuery(filter) {
        switch (filter.method) {
            case 'is':
                return `concat(concat(FirstName, ' '), LastName) eq '${filter.value}'`;
            case 'is not':
                return `concat(concat(FirstName, ' '), LastName) ne '${filter.value}'`;
            case 'contains':
                return `contains(concat(concat(FirstName, ' '), LastName), '${filter.value}')`;
            case 'doesn\'t contain':
                return `not contains(concat(concat(FirstName, ' '), LastName), '${filter.value}')`;
            case 'starts with':
                return `startswith(concat(concat(FirstName, ' '), LastName), '${filter.value}')`;
            case 'ends with':
                return `endswith(concat(concat(FirstName, ' '), LastName), '${filter.value}')`;
            case 'is defined':
                return '(concat(concat(FirstName, \' \'), LastName) ne null and concat(concat(FirstName, \' \'), LastName) ne \'\')';
            case 'is not defined':
                return '(concat(concat(FirstName, \' \'), LastName) eq null or concat(concat(FirstName, \' \'), LastName) eq \'\')';
        }

        return null;
    },

    getContactStatusFilterQuery(filter) {
        switch (filter.method) {
            case 'is':
                return `ContactStatusId eq ${filter.value.id}`;
            case 'is not':
                return `ContactStatusId ne ${filter.value.id}`;
            case 'contains':
                return `contains(ContactStatus/Name, '${filter.value}')`;
            case 'doesn\'t contain':
                return `not contains(ContactStatus/Name, '${filter.value}')`;
            case 'starts with':
                return `startswith(ContactStatus/Name, '${filter.value}')`;
            case 'ends with':
                return `endswith(ContactStatus/Name, '${filter.value}')`;
            case 'is defined':
                return 'ContactStatusId ne null';
            case 'is not defined':
                return 'ContactStatusId eq null';
        }

        return null;
    },

    getPartnerFilterQuery(filter) {
        switch (filter.method) {
            case 'is':
                return `Client/Id eq ${filter.value.id}`;
            case 'is not':
                return `Client/Id ne ${filter.value.id}`;
        }

        return null;
    },

    getCustomCompanyFilterQuery(filter, customFieldId, customFieldType) {
        const customFieldIdMatch = `CompanyCustomFieldValues/any(v: v/CustomCompanyFieldId eq ${customFieldId}`;
        return this.getCustomFieldFilterQuery(customFieldIdMatch, filter, customFieldId, customFieldType);
    },

    getCustomContactFilterQuery(filter, customFieldId, customFieldType) {
        const customFieldIdMatch = `ContactCustomFieldValues/any(v: v/CustomContactFieldId eq ${customFieldId}`;
        return this.getCustomFieldFilterQuery(customFieldIdMatch, filter, customFieldId, customFieldType);
    },

    getCustomPartnerFilterQuery(filter, customFieldId, customFieldType) {
        const customFieldIdMatch = `CustomAgencyClientFieldValues/any(v: v/CustomAgencyClientFieldId eq ${customFieldId}`;
        return this.getCustomFieldFilterQuery(customFieldIdMatch, filter, customFieldId, customFieldType);
    },

    getCustomOpportunityFilterQuery(filter, customFieldId, customFieldType) {
        const customFieldIdMatch = `CustomOpportunityFieldValues/any(v: v/CustomOpportunityFieldId eq ${customFieldId}`;
        return this.getCustomFieldFilterQuery(customFieldIdMatch, filter, customFieldId, customFieldType);
    },

    getCustomFieldFilterQuery(customFieldIdMatch, filter, customFieldId, customFieldType) {
        let customFieldFilterType = this.getCustomFieldFilterType(customFieldType);
        if (customFieldFilterType) {
            const isDate = customFieldFilterType === 'DateTimeValue';
            const isDouble = customFieldFilterType === 'DoubleValue';
            const isCheckboxOrDropdown = customFieldFilterType === 'ObjectValueJson';

            let comparisonSource = `v/${customFieldFilterType}`;
            let filterValue = filter.value;
            if (isDouble) {
                if (isNaN(filter.value)) {
                    return null; // abort early
                }
            } else if (!isDate && !isCheckboxOrDropdown) {
                comparisonSource = `tolower(${comparisonSource})`;
                if (filter.value) {
                    filterValue = filter.value.toLowerCase();
                }
            }

            if (isDate) {
                filterValue = encodeURIComponent(filterValue || '').replace(/'/g, "''");
                switch (filter.method) {
                    case 'before':
                        return `${customFieldIdMatch} and ${comparisonSource} lt ${filterValue})`;
                    case 'after':
                        return `${customFieldIdMatch} and ${comparisonSource} gt ${filterValue})`;
                }
            } else if (isDouble) {
                filterValue = encodeURIComponent(filterValue || '').replace(/'/g, "''");
                switch (filter.method) {
                    case 'greater than':
                        return `${customFieldIdMatch} and ${comparisonSource} gt ${filterValue})`;
                    case 'less than':
                        return `${customFieldIdMatch} and ${comparisonSource} lt ${filterValue})`;
                    case 'equal to':
                        return `${customFieldIdMatch} and ${comparisonSource} eq ${filterValue})`;
                }
            } else if (isCheckboxOrDropdown) {
                const methodIs = filter.method === 'is';
                const methodIsNot = filter.method === 'is not';
                const hasSelection = filter.value.includes(`"selected":true`);

                let jsonValue = JSON.parse(filterValue);
                if (hasSelection) {
                    jsonValue = jsonValue.filter(c => c.selected);
                }

                const logicalOperator = methodIs && !hasSelection ? 'and' : 'or';
                const negationOperator = methodIsNot && !hasSelection ? 'not' : '';
                const conditions = jsonValue.map((item, index) => {
                    delete item.id;
                    item.name = item.name.replace(/'/g, "''");
                    // slice is to remove braces
                    let searchString = JSON.stringify(item).slice(1, -1); 
                    return `${index === 0 ? '' : logicalOperator} ${negationOperator} contains(${comparisonSource}, '${searchString}')`;
                });

                const negationOperatorForSelection = (methodIsNot && hasSelection) ? 'not' : '';
                let containsFilter = conditions.length > 0 ? `and ${negationOperatorForSelection} (${conditions.join(' ')})` : '';
                containsFilter = encodeURIComponent(containsFilter);

                let orMissingCustomField = '';
                // There are scenarios where we need to show the missing custom fields
                if ((methodIs && !hasSelection) || (methodIsNot && hasSelection)) {
                    orMissingCustomField = ` or not ${customFieldIdMatch})`;
                }
                
                switch (filter.method) {
                    case 'is':
                        return `(${customFieldIdMatch} ${containsFilter})${orMissingCustomField})`;
                    case 'is not':
                        return `(${customFieldIdMatch} ${containsFilter})${orMissingCustomField})`;
                }
            } else {
                filterValue = encodeURIComponent(filterValue || '').replace(/'/g, "''");
                filterValue = `'${filterValue}'`;
                switch (filter.method) {
                    case 'is':
                        return `${customFieldIdMatch} and ${comparisonSource} eq ${filterValue})`;
                    case 'is not':
                        return `not (${customFieldIdMatch} and ${comparisonSource} eq ${filterValue}))`;
                    case 'contains':
                        return `${customFieldIdMatch} and contains(${comparisonSource},${filterValue}))`;
                    case 'doesn\'t contain':
                        return `not (${customFieldIdMatch} and contains(${comparisonSource},${filterValue})))`;
                    case 'starts with':
                        return `${customFieldIdMatch} and startswith(${comparisonSource},${filterValue}))`;
                    case 'ends with':
                        return `${customFieldIdMatch} and endswith(${comparisonSource},${filterValue}))`;
                    case 'is defined':
                        return `${customFieldIdMatch} and ${comparisonSource} ne '')`;
                    case 'is not defined':
                        return `not (${customFieldIdMatch} and ${comparisonSource} ne ''))`;
                }
            }
        }
        return null;
    },

    getCustomFieldFilterType(customFieldType) {
        switch (customFieldType) {
            case 'single-line text':
            case 'url':
                return 'ShortStringValue';
            case 'multi-line text':
                return 'LongStringValue';
            case 'number':
                return 'DoubleValue';
            case 'date picker':
                return 'DateTimeValue';
            case 'single checkbox':
            case 'multiple checkboxes':
            case 'single dropdown':
                return 'ObjectValueJson';
            default:
                return null;
        }
    },

    getSalespersonFilterQuery(filter) {
        switch (filter.method) {
            case 'is':
                return `SalesPersonId eq '${filter.value.id}'`;
            case 'is not':
                return `SalesPersonId ne '${filter.value.id}'`;
            case 'contains':
                return `contains(concat(concat(SalesPerson/FirstName, ' '), SalesPerson/LastName), '${filter.value}')`;
            case 'doesn\'t contain':
                return `not contains(concat(concat(SalesPerson/FirstName, ' '), SalesPerson/LastName), '${filter.value}')`;
            case 'starts with':
                return `startswith(concat(concat(SalesPerson/FirstName, ' '), SalesPerson/LastName), '${filter.value}')`;
            case 'ends with':
                return `endswith(concat(concat(SalesPerson/FirstName, ' '), LastName), '${filter.value}')`;
            case 'is defined':
                return 'SalesPersonId ne null';
            case 'is not defined':
                return 'SalesPersonId eq null ';
        }

        return null;
    },

    getOpportunitySalespersonFilterQuery(filter) {
        switch (filter.method) {
            case 'is':
                return `CreatedByUserId eq '${filter.value.id}'`;
            case 'is not':
                return `CreatedByUserId ne '${filter.value.id}'`;
            case 'is defined':
                return 'CreatedByUserId ne null';
            case 'is not defined':
                return 'CreatedByUserId eq null';
        }

        return null;
    },

    getOpportunityTypeFilterQuery(filter) {
        switch (filter.method) {
            case 'is':
                return `DealTypeId eq ${filter.value.id}`;
            case 'is not':
                return `DealTypeId ne ${filter.value.id}`;
            case 'is defined':
                return 'DealTypeId ne null';
            case 'is not defined':
                return 'DealTypeId eq null';
        }

        return null;
    },

    getCompanyNameFilterQuery(filter) {
        switch (filter.method) {
            case 'is':
                return `Contact/CompanyId eq ${filter.value.id}`;
            case 'is not':
                return `Contact/CompanyId ne ${filter.value.id}`;
            case 'is defined':
                return 'Contact/CompanyId ne null';
            case 'is not defined':
                return 'Contact/CompanyId eq null';
        }

        return null;
    },


    getCompanyFilterQuery(filter) {
        switch (filter.method) {
            case 'is':
                return `CompanyId eq ${filter.value.id}`;
            case 'is not':
                return `CompanyId ne ${filter.value.id}`;
            case 'is defined':
                return 'CompanyId ne null';
            case 'is not defined':
                return 'CompanyId eq null';
        }

        return null;
    },

    getOpportunityContactCompanyFilterQuery(filter) {
        switch (filter.method) {
            case 'is':
                return `Contact/CompanyId eq ${filter.value.id}`;
            case 'is not':
                return `Contact/CompanyId ne ${filter.value.id}`;
            case 'is defined':
                return 'Contact/CompanyId ne null';
            case 'is not defined':
                return 'Contact/CompanyId eq null';
        }

        return null;
    },

    getSharedTemplateAgencyFilterQuery(filter) {
        switch (filter.method) {
            case 'is':
                return `Agency/Id eq ${filter.value.id}`;
            case 'is not':
                return `Agency/Id ne ${filter.value.id}`;
            case 'is defined':
                return 'Agency/Id ne null';
            case 'is not defined':
                return 'Agency/Id eq null';
        }

        return null;
    },

    getOpportunityStatusFilterQuery(filter) {
        switch (filter.method) {
            case 'is':
                return `DealStatusId eq ${filter.value.id}`;
            case 'is not':
                return `DealStatusId ne ${filter.value.id}`;
            case 'is defined':
                return 'DealStatusId ne null';
            case 'is not defined':
                return 'DealStatusId eq null';
        }

        return null;
    },

    getStringMatchFilterQuery(filter, queryProperty) {
        switch (filter.method) {
            case 'is':
                return `${queryProperty} eq '${filter.value}'`;
            case 'is not':
                return `${queryProperty} ne '${filter.value}'`;
            case 'is defined':
                return `${queryProperty} ne null`;
            case 'is not defined':
                return `${queryProperty} eq null`;
        }

        return null;
    },

    getUserFilterQuery(filter, queryProperty) {
        switch (filter.method) {
            case 'is':
                return `${queryProperty} eq '${filter.value.id}'`;
            case 'is not':
                return `${queryProperty} ne '${filter.value.id}'`;
            case 'is defined':
                return `${queryProperty} ne null`;
            case 'is not defined':
                return `${queryProperty} eq null`;
        }

        return null;
    },

    getListLeadFilterQuery(filter) {
        switch (filter.method) {
            case 'is true':
                return 'IsMarketable eq true';
            case 'is false':
                return 'IsMarketable eq false';
        }

        return null;
    },

    getListFilterQuery(filter) {
        switch (filter.method) {
            case 'is':
                return `ListContacts/any(c: c/ListId eq ${filter.value.id})`;
            case 'is not':
                return `not ListContacts/any(c: c/ListId eq ${filter.value.id})`;
            case 'is defined':
                return 'ListContacts/any()';
            case 'is not defined':
                return 'not ListContacts/any()';
        }

        return null;
    },

    getCompanyUserFilterQuery(filter) {
        switch (filter.method) {
            case 'is':
                return `CompanyUsers/any(c: c/User/Id eq '${filter.value.id}')`;
            case 'is not':
                return `not CompanyUsers/any(c: c/User/Id eq '${filter.value.id}')`;
            case 'is defined':
                return 'CompanyUsers/any()';
            case 'is not defined':
                return 'not CompanyUsers/any()';
        }

        return null;
    },

    getPartnerAssignedUserFilterQuery(filter) {
        switch (filter.method) {
            case 'is':
                return `AssignedUserContacts/any(c: c/UserId eq '${filter.value.id}')`;
            case 'is not':
                return `not AssignedUserContacts/any(c: c/UserId eq '${filter.value.id}')`;
            case 'is defined':
                return 'AssignedUserContacts/any()';
            case 'is not defined':
                return 'not AssignedUserContacts/any()';
        }

        return null;
    },

    getAgencyPartnerAssignedUserFilterQuery(filter) {
        switch (filter.method) {
            case 'is':
                return `AgencyClientUsers/any(c: c/UserId eq '${filter.value.id}')`;
            case 'is not':
                return `not AgencyClientUsers/any(c: c/UserId eq '${filter.value.id}')`;
            case 'is defined':
                return 'AgencyClientUsers/any()';
            case 'is not defined':
                return 'not AgencyClientUsers/any()';
        }
        return null;
    },

    getLandingPageNameFilter(filter) {
        switch (filter.method) {
            case 'is':
                return `Name eq '${filter.value}'`;
            case 'is not':
                return `Name ne '${filter.value}'`;
            case 'contains':
                return `contains(Name, '${filter.value}')`;
            case 'doesn\'t contain':
                return `not contains(Name, '${filter.value}')`;
            case 'starts with':
                return `startswith(Name, '${filter.value}')`;
            case 'ends with':
                return `endswith(Name, '${filter.value}')`;
            case 'is defined':
                return 'Name eq null';
            case 'is not defined':
                return 'Name ne null';
        }

        return null;
    },

    getLandingPageUrlFilter(filter) {
        switch (filter.method) {
            case 'is':
                return `concat(concat(Domain/DomainName, '/'), Slug) eq '${filter.value}'`;
            case 'is not':
                return `concat(concat(Domain/DomainName, '/'), Slug) ne '${filter.value}'`;
            case 'contains':
                return `contains(concat(concat(Domain/DomainName, '/'), Slug), '${filter.value}')`;
            case 'doesn\'t contain':
                return `not contains(concat(concat(Domain/DomainName, '/'), Slug), '${filter.value}')`;
            case 'starts with':
                return `startswith(concat(concat(Domain/DomainName, '/'), Slug), '${filter.value}')`;
            case 'ends with':
                return `endswith(concat(concat(Domain/DomainName, '/'), Slug), '${filter.value}')`;
            case 'is defined':
                return 'concat(concat(Domain/DomainName, \'/\'), Slug) ne null';
            case 'is not defined':
                return 'concat(concat(Domain/DomainName, \'/\'), Slug) eq null';
        }

        return null;
    },

    getDomainFilterQuery(filter) {
        switch (filter.method) {
            case 'is':
                return `DomainName eq '${filter.value}'`;
            case 'is not':
                return `DomainName ne '${filter.value}'`;
            case 'contains':
                return `contains(DomainName, '${filter.value}')`;
            case 'doesn\'t contain':
                return `not contains(DomainName, '${filter.value}')`;
            case 'starts with':
                return `startswith(DomainName, '${filter.value}')`;
            case 'ends with':
                return `endswith(DomainName, '${filter.value}')`;
            case 'is defined':
                return 'DomainName ne null';
            case 'is not defined':
                return 'DomainName eq null';
        }

        return null;
    },

    getSocialPostNameFilter(filter) {
        switch (filter.method) {
            case 'is':
                return `{"PostName": {"$eq": "${filter.value}"}}`;
            case 'is not':
                return `{"PostName": {"$ne": "${filter.value}"}}`;
            case 'contains':
                return `{"PostName": {"$like": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'doesn\'t contain':
                return `{"PostName": {"$notLike": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'starts with':
                return `{"PostName": {"$startsWith": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'ends with':
                return `{"PostName": {"$endsWith": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'is defined':
                return '{"PostName": {"$ne": null}}';
            case 'is not defined':
                return '{"PostName": {"$eq": null}}';
        }

        return null;
    },

    getSocialCategoriesFilter(filter) {
        switch (filter.method) {
            case 'is':
                return `{"Categories": {"$eq": "${filter.value.name}"}}`;
            case 'is not':
                return `{"Categories": {"$ne": "${filter.value.name}"}}`;
            case 'is defined':
                return '{"Categories": {"$ne": null}}';
            case 'is not defined':
                return '{"Categories": {"$eq": null}}';
        }

        return null;
    },

    getConnectWiseMemberFilter(filter) {
        switch (filter.method) {
            case 'is':
                return `{"FirstName": {"$eq": "${filter.value}"}}`;
            case 'is not':
                return `{"FirstName": {"$ne": "${filter.value}"}}`;
            case 'contains':
                return `{"FirstName": {"$like": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'doesn\'t contain':
                return `{"FirstName": {"$notLike": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'starts with':
                return `{"FirstName": {"$startsWith": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'ends with':
                return `{"FirstName": {"$endsWith": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'is defined':
                return '{"FirstName": {"$ne": null}}';
            case 'is not defined':
                return '{"FirstName": {"$eq": null}}';
        }

        return null;
    },

    getConnectWiseWorkRoleFilter(filter) {
        switch (filter.method) {
            case 'is':
                return `{"ThirdPartyUserTypeName": {"$eq": "${filter.value}"}}`;
            case 'is not':
                return `{"ThirdPartyUserTypeName": {"$ne": "${filter.value}"}}`;
            case 'contains':
                return `{"ThirdPartyUserTypeName": {"$like": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'doesn\'t contain':
                return `{"ThirdPartyUserTypeName": {"$notLike": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'starts with':
                return `{"ThirdPartyUserTypeName": {"$startsWith": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'ends with':
                return `{"ThirdPartyUserTypeName": {"$endsWith": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'is defined':
                return '{"ThirdPartyUserTypeName": {"$ne": null}}';
            case 'is not defined':
                return '{"ThirdPartyUserTypeName": {"$eq": null}}';
        }

        return null;
    },

    getConnectWiseRoleIdFilter(filter) {
        switch (filter.method) {
            case 'is':
                return `{"ThirdPartyUserRoleName": {"$eq": "${filter.value}"}}`;
            case 'is not':
                return `{"ThirdPartyUserRoleName": {"$ne": "${filter.value}"}}`;
            case 'contains':
                return `{"ThirdPartyUserRoleName": {"$like": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'doesn\'t contain':
                return `{"ThirdPartyUserRoleName": {"$notLike": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'starts with':
                return `{"ThirdPartyUserRoleName": {"$startsWith": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'ends with':
                return `{"ThirdPartyUserRoleName": {"$endsWith": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'is defined':
                return '{"ThirdPartyUserRoleName": {"$ne": null}}';
            case 'is not defined':
                return '{"ThirdPartyUserRoleName": {"$eq": null}}';
        }

        return null;
    },

    getSocialPostTemplateNameFilter(filter) {
        switch (filter.method) {
            case 'is':
                return `{"TemplateName": {"$eq": "${filter.value}"}}`;
            case 'is not':
                return `{"TemplateName": {"$ne": "${filter.value}"}}`;
            case 'contains':
                return `{"TemplateName": {"$like": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'doesn\'t contain':
                return `{"TemplateName": {"$notLike": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'starts with':
                return `{"TemplateName": {"$startsWith": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'ends with':
                return `{"TemplateName": {"$endsWith": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'is defined':
                return '{"TemplateName": {"$ne": null}}';
            case 'is not defined':
                return '{"TemplateName": {"$eq": null}}';
        }
    },

    getSocialPostTemplateVendorFilter(filter) {
        switch (filter.method) {
            case 'is':
                return `{"SharingVendorName": {"$eq": "${filter.value.name}"}}`;
            case 'is not':
                return `{"SharingVendorName": {"$ne": "${filter.value.name}"}}`;
            case 'is defined':
                return '{"SharingVendorName": {"$ne": null}}';
            case 'is not defined':
                return '{"SharingVendorName": {"$eq": null}}';
        }
    },

    getReportTypeFilterQuery(filter) {
        switch (filter.method) {
            case 'is':
                return `ReportType/Name eq '${filter.value}'`;
            case 'is not':
                return `ReportType/Name ne '${filter.value}'`;
            case 'contains':
                return `contains(ReportType/Name, '${filter.value}')`;
            case 'doesn\'t contain':
                return `not contains(ReportType/Name, '${filter.value}')`;
            case 'starts with':
                return `startswith(ReportType/Name, '${filter.value}')`;
            case 'ends with':
                return `endswith(ReportType/Name, '${filter.value}')`;
            case 'is defined':
                return 'ReportType/Name ne null';
            case 'is not defined':
                return 'ReportType/Name eq null';
        }
        return null;
    },

    getReportFrequencyTypeFilterQuery(filter) {
        switch (filter.method) {
            case 'is':
                return `ReportFrequencyType/Name eq '${filter.value}'`;
            case 'is not':
                return `ReportFrequencyType/Name ne '${filter.value}'`;
            case 'contains':
                return `contains(ReportFrequencyType/Name, '${filter.value}')`;
            case 'doesn\'t contain':
                return `not contains(ReportFrequencyType/Name, '${filter.value}')`;
            case 'starts with':
                return `startswith(ReportFrequencyType/Name, '${filter.value}')`;
            case 'ends with':
                return `endswith(ReportFrequencyType/Name, '${filter.value}')`;
            case 'is defined':
                return 'ReportFrequencyType/Name ne null';
            case 'is not defined':
                return 'ReportFrequencyType/Name eq null';
        }
        return null;
    },

    getCustomFieldNameFilterQuery(filter) {
        switch (filter.method) {
            case 'is':
                return `{"Name": {"$eq": "${filter.value}"}}`;
            case 'is not':
                return `{"Name": {"$ne": "${filter.value}"}}`;
            case 'contains':
                return `{"Name": {"$like": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'doesn\'t contain':
                return `{"Name": {"$notLike": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'starts with':
                return `{"Name": {"$startsWith": "${filter.value}"}}`
            case 'ends with':
                return `{"Name": {"$endsWith": "${filter.value}"}}`
            case 'is defined':
                return '{"Name": {"$ne": null}}';
            case 'is not defined':
                return '{"Name": {"$eq": null}}';
        }
        return null;
    },

    getCustomFieldDescriptionFilterQuery(filter) {
        switch (filter.method) {
            case 'is':
                return `{"Description": {"$eq": "${filter.value}"}}`;
            case 'is not':
                return `{"Description": {"$ne": "${filter.value}"}}`;
            case 'contains':
                return `{"Description": {"$like": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'doesn\'t contain':
                return `{"Description": {"$notLike": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'starts with':
                return `{"Description": {"$startsWith": "${filter.value}"}}`
            case 'ends with':
                return `{"Description": {"$endsWith": "${filter.value}"}}`
            case 'is defined':
                return '{"Description": {"$ne": null}}';
            case 'is not defined':
                return '{"Description": {"$eq": null}}';
        }
        return null;
    },

    getFormSubmissionContactNameFilterQuery(filter){
        switch (filter.method) {
            case 'is':
                return `concat(concat(Contact/FirstName, ' '), Contact/LastName) eq '${filter.value}'`;
            case 'is not':
                return `concat(concat(Contact/FirstName, ' '), Contact/LastName) ne '${filter.value}'`;
            case 'contains':
                return `contains(concat(concat(Contact/FirstName, ' '), Contact/LastName), '${filter.value}')`;
            case 'doesn\'t contain':
                return `not contains(concat(concat(Contact/FirstName, ' '), Contact/LastName), '${filter.value}')`;
            case 'starts with':
                return `startswith(concat(concat(Contact/FirstName, ' '), Contact/LastName), '${filter.value}')`;
            case 'ends with':
                return `endswith(concat(concat(Contact/FirstName, ' '), Contact/LastName), '${filter.value}')`;
            case 'is defined':
                return 'concat(concat(Contact/FirstName, \' \'), Contact/LastName) ne null';
            case 'is not defined':
                return 'concat(concat(Contact/FirstName, \' \'), Contact/LastName) eq null';
        }

        return null;
    },

    getFormSubmissionLandingPageFilterQuery(filter){
        switch (filter.method) {
            case 'is':
                return `LandingPage/Name eq '${filter.value}'`;
            case 'is not':
                return `LandingPage/Name ne '${filter.value}'`;
            case 'contains':
                return `contains(LandingPage/Name, '${filter.value}')`;
            case 'doesn\'t contain':
                return `not contains(LandingPage/Name, '${filter.value}')`;
            case 'starts with':
                return `startswith(LandingPage/Name, '${filter.value}')`;
            case 'ends with':
                return `endswith(LandingPage/Name, '${filter.value}')`;
            case 'is defined':
                return 'LandingPage/Name ne null';
            case 'is not defined':
                return 'LandingPage/Name eq null';
        }

        return null;
    },

    getLandingPageFormNameFilterQuery(filter){
        switch (filter.method) {
            case 'is':
                return `LandingPage/Name eq '${filter.value}'`;
            case 'is not':
                return `LandingPage/Name ne '${filter.value}'`;
            case 'contains':
                return `contains(LandingPage/Name, '${filter.value}')`;
            case 'doesn\'t contain':
                return `not contains(LandingPage/Name, '${filter.value}')`;
            case 'starts with':
                return `startswith(LandingPage/Name, '${filter.value}')`;
            case 'ends with':
                return `endswith(LandingPage/Name, '${filter.value}')`;
            case 'is defined':
                return 'LandingPage/Name ne null';
            case 'is not defined':
                return 'LandingPage/Name eq null';
        }

        return null;
    },

    getHeaderFooterNameFilterQuery(filter) {
        switch (filter.method) {
            case 'is':
                return `Name eq '${filter.value}'`;
            case 'is not':
                return `Name ne '${filter.value}'`;
            case 'contains':
                return `contains(Name, '${filter.value}')`;
            case 'doesn\'t contain':
                return `not contains(Name, '${filter.value}')`;
            case 'starts with':
                return `startswith(Name, '${filter.value}')`;
            case 'ends with':
                return `endswith(Name, '${filter.value}')`;
            case 'is defined':
                return 'Name ne null';
            case 'is not defined':
                return 'Name eq null';
        }

        return null;
    },

    getPartnerSurveyNameFilter(filter) {
        switch (filter.method) {
            case 'is':
                return `{"Name": {"$eq": "${filter.value}"}}`;
            case 'is not':
                return `{"Name": {"$ne": "${filter.value}"}}`;
            case 'contains':
                return `{"Name": {"$like": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'doesn\'t contain':
                return `{"Name": {"$notLike": "${encodeURIComponent(`%${filter.value}%`)}"}}`
            case 'starts with':
                return `{"Name": {"$startsWith": "${filter.value}"}}`
            case 'ends with':
                return `{"Name": {"$endsWith": "${filter.value}"}}`
            case 'is defined':
                return '{"Name": {"$ne": null}}';
            case 'is not defined':
                return '{"Name": {"$eq": null}}';
        }
        return null;
    },

    getLandingPageFormUrlFilter(filter) {
        switch (filter.method) {
            case 'is':
                return `concat(concat(LandingPage/Domain/DomainName, '/'), LandingPage/Slug) eq '${filter.value}'`;
            case 'is not':
                return `concat(concat(LandingPage/Domain/DomainName, '/'), LandingPage/Slug) ne '${filter.value}'`;
            case 'contains':
                return `contains(concat(concat(LandingPage/Domain/DomainName, '/'), LandingPage/Slug), '${filter.value}')`;
            case 'doesn\'t contain':
                return `not contains(concat(concat(LandingPage/Domain/DomainName, '/'), LandingPage/Slug), '${filter.value}')`;
            case 'starts with':
                return `startswith(concat(concat(LandingPage/Domain/DomainName, '/'), LandingPage/Slug), '${filter.value}')`;
            case 'ends with':
                return `endswith(concat(concat(LandingPage/Domain/DomainName, '/'), LandingPage/Slug), '${filter.value}')`;
            case 'is defined':
                return 'concat(concat(LandingPage/Domain/DomainName, \'/\'), LandingPage/Slug) ne null';
            case 'is not defined':
                return 'concat(concat(LandingPage/Domain/DomainName, \'/\'), LandingPage/Slug) eq null';
        }

        return null;
    },

    getDesignStudioCategoryAdvancedFilter(filter) {
        const isArray   = Array.isArray(filter.value) && filter.value.length > 0
        const mapper = () => {
            const values = filter.value.map((value) => `"${value.name || value}"`).join(',');
            return values
        }
        const orMapper = (method) => {
            const values = filter.value.map((value) => `{"$Categories.Category$": {"${method}": "${value.name || value}"}}`).join(',');
            return values;
        }
        switch (filter.method) {
            case 'is':
                if (isArray) {
                    const values = mapper();
                    return `{"$Categories.Category$": {"$in": [${values}]}}`;
                }
                break;
            case 'is not':
                if (isArray) {
                    const values = mapper();
                    return `{"$Categories.Category$": {"$notIn": [${values}]}}`;
                }
                break;
            case 'contains':
                if (isArray) {
                    const values = filter.value.map((value) => `{"$Categories.Category$": {"$like": "${encodeURIComponent(`%${value.name || value}%`)}"}}`).join(',');
                    return `{"$or": [${values}]}`;
                }
                break;
            case 'doesn\'t contain':
                if (isArray) {
                    const values = filter.value.map((value) => `{"$Categories.Category$": {"$notLike": "${encodeURIComponent(`%${value.name || value}%`)}"}}`).join(',');
                    return `{"$and": [${values}]}`;
                }
                break;
            case 'starts with':
                if (isArray) {
                    const values =  orMapper('$startsWith');
                    return `{"$or": [${values}]}`;
                }
                break;
            case 'ends with':
                if (isArray) {
                    const values = orMapper('$endsWith');
                    return `{"$or": [${values}]}`;
                }
                break;
            case 'is defined':
                return '{"$Categories.Category$": {"$ne": null}}';
            case 'is not defined':
                return '{"$Categories.Category$": {"$eq": null}}';
        }

    },

    getDesignStudioTypeAdvancedFilter(filter) {
        const isArray   = Array.isArray(filter.value) && filter.value.length > 0
        const mapper = () => {
            const values = filter.value.map((value) => `"${value.name || value}"`).join(',');
            return values
        }
        switch (filter.method) {
            case 'is':
                if (isArray) {
                    const values = mapper();
                    return `{"Type": {"$in": [${values}]}}`;
                }
                break;
            case 'is not':
                if (isArray) {
                    const values = mapper();
                    return `{"Type": {"$notIn": [${values}]}}`;
                }
                break;
        }

    },

    getDesignStudioNameAdvancedFilter(filter) {
        const isArray   = Array.isArray(filter.value) && filter.value.length > 0
        const mapper = () => {
            const values = filter.value.map((value) => `"${value.name || value}"`).join(',');
            return values
        }
        const orMapper = (method) => {
            const values = filter.value.map((value) => `{"Name": {"${method}": "${value.name || value}"}}`).join(',');
            return values;
        }
        switch (filter.method) {
            case 'is':
                if (isArray) {
                    const values = mapper();
                    return `{"Name": {"$in": [${values}]}}`;
                }
                break;
            case 'is not':
                if (isArray) {
                    const values = mapper();
                    return `{"Name": {"$notIn": [${values}]}}`;
                }
                break;
            case 'contains':
                if (isArray) {
                    const values = filter.value.map((value) => `{"Name": {"$like": "${encodeURIComponent(`%${value.name || value}%`)}"}}`).join(',');
                    return `{"$or": [${values}]}`;
                }
                break;
            case 'doesn\'t contain':
                if (isArray) {
                    const values = filter.value.map((value) => `{"Name": {"$notLike": "${encodeURIComponent(`%${value.name || value}%`)}"}}`).join(',');
                    return `{"$and": [${values}]}`;
                }
                break;
            case 'starts with':
                if (isArray) {
                    const values =  orMapper('$startsWith');
                    return `{"$or": [${values}]}`;
                }
                break;
            case 'ends with':
                if (isArray) {
                    const values = orMapper('$endsWith');
                    return `{"$or": [${values}]}`;
                }
                break;
            case 'is defined':
                return '{"Name": {"$ne": null}}';
            case 'is not defined':
                return '{"Name": {"$eq": null}}';
        }

    },

    getDesignStudioVendorAdvancedFilter(filter) {
        const isArray   = Array.isArray(filter.value) && filter.value.length > 0
        const mapper = () => {
            const values = filter.value.filter((value) => value.id).map((value) => value.id).join(',');
            return values
        }
        switch (filter.method) {
            case 'is':
                if (isArray) {
                    const values = mapper();
                    return `{"$Agencies.Id$":{"$in":[${values}]}}`;
                }
                break;
            case 'is not':
                if (isArray) {
                    const values = mapper();
                    return `{"$Agencies.Id$":{"$notIn":[${values}]}}`;
                }
                break;
            case 'is defined':
                return '{"$Agencies.Id$": {"$ne": null}}';
            case 'is not defined':
                return '{"$Agencies.Id$": {"$eq": null}}';
        }
    },

    getMdfVendorAdvancedFilter({ method, value }) {
        if (value && value.id !== undefined && value.id !== null) {
            const filterMap = {
                'is': `{"AgencyId":[${value.id}]}`,
                'is not': `{"AgencyId":{"$notIn":[${value.id}]}}`,
            };
    
            return filterMap[method] || '';
        } else {
            const filterMap = {
                'is defined': '{"AgencyId": {"$ne": null}}',
                'is not defined': '{"AgencyId": {"$eq": null}}',
            };
            return filterMap[method] || '';
        }
    },    
    
    getDocumentNameFilter(filter) {
        switch (filter.method) {
            case 'is':
                return `Name eq '${filter.value}'`;
            case 'is not':
                return `Name ne '${filter.value}'`;
            case 'contains':
                return `contains(Name, '${filter.value}')`;
            case 'doesn\'t contain':
                return `not contains(Name, '${filter.value}')`;
            case 'starts with':
                return `startswith(Name, '${filter.value}')`;
            case 'ends with':
                return `endswith(Name, '${filter.value}')`;
            case 'is defined':
                return 'Name eq null';
            case 'is not defined':
                return 'Name ne null';
        }

        return null;
    },

    getDocumentStatusFilter(filter) {
        switch (filter.method) {
            case 'is':
                return `Status eq ${filter.value}`;
            case 'is not':
                return `Status ne ${filter.value}`;
        }

        return null;
    },

    getCategoryFilter(filter){
        switch(filter.method){
            case 'is':
                return `Categories/any(c: c/Name eq '${filter.value.name}')`;
            case 'is not':
                return `not Categories/any(c: c/Name eq '${filter.value.name}')`;
            case 'is defined':
                return 'Categories/any()';
            case 'is not defined':
                return 'not Categories/any()';
        }
    },

    getDocumentCategoryFilter(filter){
        switch(filter.method){
            case 'is':
                return `Categories/any(c: c/Category eq '${filter.value.name}')`;
            case 'is not':
                return `not Categories/any(c: c/Category eq '${filter.value.name}')`;
            case 'is defined':
                return 'Categories/any()';
            case 'is not defined':
                return 'not Categories/any()';
        }
    },

    getCustomFieldStringFilterQuery(queryProperty, filter) {
        const encodedValue = encodeURIComponent(filter.value || '').replace('\'', '\'\'');

        switch (filter.method) {
            case 'is':
                return `{"${queryProperty}": {"$eq": "${encodedValue}"}}`;
            case 'is not':
                return `{"${queryProperty}": {"$ne": "${encodedValue}"}}`;
            case 'contains':
                return `{"${queryProperty}": {"$like": "%25${encodedValue}%25"}}`
            case 'doesn\'t contain':
                return `{"${queryProperty}": {"$notLike": "%25${encodedValue}%25"}}`
            case 'starts with':
                return `{"${queryProperty}": {"$startsWith": "${encodedValue}"}}`
            case 'ends with':
                return `{"${queryProperty}": {"$endsWith": "${encodedValue}"}}`
            case 'is defined':
                return `{"${queryProperty}": {"$ne": null}}`;
            case 'is not defined':
                return `{"${queryProperty}": {"$eq": null}}`;
        }
        return null;
    },

    getCustomFieldBooleanFilterQuery(queryProperty, filter) {
        switch (filter.method) {
            case 'is true':
                return `{"${queryProperty}": {"$eq": true }}`;
            case 'is false':
                return `{"${queryProperty}": {"$eq": false }}`;
        }

        return null;
    },

    getCustomFieldAmountFilterQuery(queryProperty, filter) {
        switch (filter.method) {
            case 'greater than':
                return `{"${queryProperty}": {"$gt": ${filter.value}}}`;
            case 'less than':
                return `{"${queryProperty}": {"$lt": ${filter.value}}}`;
            case 'equal to':
                return `{"${queryProperty}": {"$eq": ${filter.value}}}`;
        }

        return null;
    },

    getCustomFieldAgencyFilterQuery(filter) {
        const encodedValue = encodeURIComponent(filter.value.name || '').replace('\'', '\'\'');

        switch (filter.method) {
            case 'is':
                return `{"AgencyName": {"$eq": "${encodedValue}"}}`;
            case 'is not':
                return `{"AgencyName": {"$ne": "${encodedValue}"}}`;
            case 'is defined':
                return '{"AgencyName": {"$ne": null}}';
            case 'is not defined':
                return '{"AgencyName": {"$eq": null}}';
        }
        return null;
    },

    getCustomFieldPartnerFilterQuery(filter){
        const encodedValue = encodeURIComponent(filter.value.name || '').replace('\'', '\'\'');

        switch (filter.method) {
            case 'is':
                return `{"Name": {"$eq": "${encodedValue}"}}`;
            case 'is not':
                return `{"Name": {"$ne": "${encodedValue}"}}`;
        }
        return null;
    },

    getHeaderDefinitions(type) {
        switch (type) {
            case 'form-submission':
                return this.getFormSubmissionHeaderDefinitions();
            case 'contact':
                return this.getContactHeaderDefinitions();
            case 'company':
                return this.getCompanyHeaderDefinitions();
            case 'company-files':
                return this.getCompanyFilesHeaderDefinitions();
            case 'all-accounts':
                return this.getCompanyAccountsHeaderDefinitions();
            case 'my-accounts':
                return this.getCompanyAccountsHeaderDefinitions();
            case 'unassigned-accounts':
                return this.getCompanyAccountsHeaderDefinitions();
            case 'phone-numbers':
                return this.getPhoneNumbersPageHeaderDefinitions();
            case 'lead':
                return this.getContactHeaderDefinitions();
            case 'list-details':
                return this.getContactHeaderDefinitions();
            case 'sales-team':
                return this.getSalesTeamHeaderDefinitions();
            case 'individual-quotas':
                return this.getIndividualQuotasHeaderDefinitions();
            case 'list':
                return this.getListHeaderDefinitions();
            case 'opportunity-contact':
                return this.getOpportunityHeaderDefinitions();
            case 'opportunity-company':
                return this.getOpportunityHeaderDefinitions();
            case 'opportunity-salesperson':
                return this.getOpportunityHeaderDefinitions();
            case 'opportunity-progress':
                return this.getOpportunityHeaderDefinitions();
            case 'opportunity-won':
                return this.getOpportunityHeaderDefinitions();
            case 'opportunity-lost':
                return this.getOpportunityHeaderDefinitions();
            case 'line-items':
                return this.getLineItemsHeaderDefinitions();
            case 'landing-page-form':
                return this.getFormLandingPageHeaderDefinitions();
            case 'landing-page-published':
                return this.getPublishedLandingPageHeaderDefinitions();
            case 'landing-page-unpublished':
                return this.getUnPublishedLandingPageHeaderDefinitions();
            case 'scheduled-email':
                return this.getScheduledEmailHeaderDefinitions();
            case 'vendor':
                return this.getVendorHeaderDefinitions();
            case 'campaign':
                return this.getCampaignHeaderDefinitions();
            case 'campaign-sent':
                return this.getCampaignSentHeaderDefinitions();
            case 'campaign-draft':
                return this.getCampaignDraftHeaderDefinitions();
            case 'campaign-scheduled':
                return this.getCampaignScheduledHeaderDefinitions();
            case 'master-agency':
                return this.getMasterAgencyHeaderDefinitions();
            case 'campaign-ab':
                return this.getCampaignABHeaderDefinitions();
            case 'client':
                return this.getClientHeaderDefinitions();
            case 'subscription-plan':
                return this.getSubscriptionPlanHeaderDefinitions();
            case 'contact-status':
                return this.getContactStatusHeaderDefinitions();
            case 'user':
                return this.getUserHeaderDefinitions();
            case 'client-adoption-free':
                return this.getClientAdoptionFreeHeaderDefinitions();
            case 'client-adoption-paying':
                return this.getClientAdoptionPayingHeaderDefinitions();
            case 'client-adoption-partnered':
                return this.getClientAdoptionPartneredHeaderDefinitions();
            case 'client-adoption-churn':
                return this.getClientAdoptionChurnedHeaderDefinitions();
            case 'dkim-integration':
                return this.getDkimIntegrationHeaderDefinitions();
            case 'link-branding':
                return this.getLinkBrandingHeaderDefinitions();
            case 'global-category':
                return  this.getGlobalCategoryHeaderDefinitions();
            case 'opportunity-type':
                return this.getOpportunityTypeHeaderDefinitions();
            case 'opportunity-status':
                return this.getOpportunityStatusHeaderDefinitions();
            case 'opportunity-stages':
                return this.getOpportunityStagesHeaderDefinitions();  
            case 'top-performers':
                return this.getTopPerformersHeaderDefinitions();
                case 'client-top-performers':
                    return this.getClientTopPerformersHeaderDefinitions();    
            case 'journey-category':
                return this.getJourneyCategoryHeaderDefinitions();
            case 'agency-partner':
                return this.getAgencyPartnerHeaderDefinitions();
            case 'my-partners':
                return this.getAgencyPartnerHeaderDefinitions();
            case 'unassigned-partners':
                return this.getAgencyPartnerHeaderDefinitions();
            case 'contact-partner-lead':
                return this.getContactPartnerLeadHeaderDefinitions();
            case 'vertical':
                return this.getVerticalDefinitions();
            case 'company-type':
                return this.getCompanyTypeHeaderDefinitions();
            case 'client-meetings':
                return this.getMeetingsHeaderDefinitions();    
            case 'service':
                return this.getServiceHeaderDefinitions();
            case 'solution':
                return this.getSolutionHeaderDefinitions();
            case 'solution-shared':
                return this.getSolutionSharedHeaderDefinitions();
            case 'solution-agency-published':
                return this.getSolutionAgencyPublishedHeaderDefinitions();
            case 'solution-agency-unpublished':
                return this.getSolutionAgencyUnpublishedHeaderDefinitions();  
            case 'registered-deal':
                return this.getRegisteredDealHeaderDefinitions();
            case 'registered-deal-report':
                return this.getRegisteredDealReportHeaderDefinitions();
            case 'post-template':
                return this.getPostTemplateHeaderDefinitions();
            case 'post-subscription':
                return this.getPostTemplateSubscriptionHeaderDefinitions();
            case 'post-template-shared':
                return this.getPostTemplateSharedHeaderDefinitions();
            case 'post-template-published':
                return this.getPostTemplatePublishedHeaderDefinitions();
            case 'post-template-unpublished':
                return this.getPostTemplateUnpublishedHeaderDefinitions();
            case 'post-template-organization-published':
                return this.getPostTemplateOrganizationPublishedHeaderDefinitions();
            case 'post-template-organization-unpublished':
                return this.getPostTemplateOrganizationUnpublishedHeaderDefinitions();
            case 'template':
                return this.getTemplateHeaderDefinitions();
            case 'template-subscription':
                return this.getTemplateSubscriptionHeaderDefinitions();
            case 'shared-template':
                return this.getSharedTemplateHeaderDefinitions();
            case 'landing-page-template':
                return this.getLandingPageTemplateHeaderDefinitions();
            case 'landing-page-template-subscription':
                return this.getLandingPageTemplateSubscriptionHeaderDefinitions();
            case 'landing-page-template-shared':
                return this.getLandingPageTemplateSharedHeaderDefinitions();
            case 'landing-page-template-published':
                return this.getLandingPageTemplatePublishedHeaderDefinitions();
            case 'landing-page-template-unpublished':
                return this.getLandingPageTemplateUnpublishedHeaderDefinitions();
            case 'landing-page-template-organization-published':
                return this.getLandingPageTemplateOrganizationPublishedHeaderDefinitions();
            case 'landing-page-template-organization-unpublished':
                return this.getLandingPageTemplateOrganizationUnpublishedHeaderDefinitions();
            case 'document':
                return this.getDocumentHeaderDefinitions();
            case 'document-template':
                return this.getDocumentTemplateHeaderDefinitions();
            case 'document-template-subscription':
                return this.getDocumentTemplateSubscriptionHeaderDefinitions();
            case 'document-template-shared':
                return this.getDocumentTemplateSharedHeaderDefinitions();
            case 'document-template-agency-published':
                return this.getDocumentTemplateAgencyPublishedHeaderDefinitions();
            case 'document-template-agency-unpublished':
                return this.getDocumentTemplateAgencyUnpublishedHeaderDefinitions();
            case 'document-template-organization-published':
                return this.getDocumentTemplateOrganizationPublishedHeaderDefinitions();
            case 'document-template-organization-unpublished':
                return this.getDocumentTemplateOrganizationUnpublishedHeaderDefinitions();
            case 'non-graphical-template':
                return this.getNonGraphicalTemplateHeaderDefinitions();
            case 'email-template-subscription':
                return this.getEmailTemplateSubscriptionHeaderDefinitions();
            case 'email-template-shared':
                return this.getEmailTemplateSharedHeaderDefinitions();
            case 'journey-active':
                return this.getJourneyActiveHeaderDefinitions();
            case 'journey-inactive':
                return this.getJourneyInctiveHeaderDefinitions();
            case 'journey-template':
                return this.getJourneyTemplateHeaderDefinitions();
            case 'journey-template-published':
                return this.getJourneyTemplatePublishedHeaderDefinitions();
            case 'journey-template-unpublished':
                return this.getJourneyTemplateUnpublishedHeaderDefinitions();
            case 'journey-template-subscription':
                return this.getJourneyTemplateSubscriptionHeaderDefinitions();
            case 'journey-template-shared':
                return this.getJourneyTemplateSharedHeaderDefinitions();
            case 'journey-step-contacts':
                return this.getJourneyStepContactHeaderDefinitions();
            case 'journey-email-step-contacts':
                return this.getJourneyEmailStepContactHeaderDefinitions();
            case 'domains':
                return this.getDomainsPageHeaderDefinitions();
            case 'marketing-plan-template':
                return this.getMarketingPlanTemplateHeaderDefinitions();
            case 'collateral':
                return this.getCollateralHeaderDefinitions();
            case 'collateral-published':
                return this.getCollateralPublishedHeaderDefinitions();
            case 'collateral-unpublished':
                return this.getCollateralUnpublishedHeaderDefinitions();
            case 'resource':
                return this.getResourceHeaderDefinitions();
            case 'collateral-subscription':
                return this.getCollateralSubscriptionHeaderDefinitions();
            case 'collateral-shared':
                return this.getCollateralSharedHeaderDefinitions();
            case 'marketing-plan':
                return this.getMarketingPlanHeaderDefinitions();
            case 'marketing-plan-template-subscription':
                return this.getMarketingPlanTemplateSubscriptionHeaderDefinitions();
            case 'marketing-plan-template-shared':
                return this.getMarketingPlanTemplateSharedHeaderDefinitions();
            case 'leads':
                return this.getContactHeaderDefinitions();
            case 'social-media-manage':
                return this.getSocialMediaManagePlanHeaderDefinitions();
            case 'collateral-build':
                return this.getCollateralBuildHeaderDefinitions();
            case 'vendor-collateral-build':
                return this.getVendorCollateralBuildHeaderDefinitions();
            case 'vendor-collateral-build-unpublished':
                return this.getVendorCollateralBuildUnpublishedHeaderDefinitions();   
            case 'collateral-build-shared':
                return this.getCollateralBuildSharedHeaderDefinitions();
            case 'collateral-build-subscription':
                return this.getCollateralBuildSubscriptionHeaderDefinitions();
            case 'graphical-template-published':
                return this.getGraphicalTemplatePublishedHeaderDefinitions();
            case 'marketing-plan-template-published':
                return this.getMarketingPlanTemplatePublishedHeaderDefinitions();  
            case 'org-email-template-published':
                return this.getOrgEmailTemplatePublishedHeaderDefinitions(); 
            case 'org-email-template-unpublished':
                return this.getOrgEmailTemplateUnpublishedHeaderDefinitions();        
            case 'marketing-plan-template-unpublished':
                return this.getMarketingPlanTemplateUnpublishedHeaderDefinitions();  
            case 'all-users':
                return this.getAllUserHeaderDefinitions();
            case 'social-media-managed-posts':
                return this.getSocialMediaManagedPostsHeaderDefinitions();
            case 'graphical-template-unpublished':
                return this.getGraphicalTemplateUnpublishedHeaderDefinitions();
            case 'custom-contact-fields':
                return this.getCustomContactFieldsHeaderDefinitions();
            case 'custom-company-fields':
                return this.getCustomCompanyFieldsHeaderDefinitions();
            case 'custom-log-activities':
                return this.getCustomLogActivitiesHeaderDefinitions();
            case 'custom-opportunity-fields':
                return this.getCustomOpportunityFieldsHeaderDefinitions();
            case 'custom-partner-fields':
                return this.getCustomPartnerFieldsHeaderDefinitions();
            case 'updates':
                return this.getUpdatesHeaderDefinitions();
            case 'forms':
                return this.getFormsPageHeaderDefinitions();
            case 'forms-subscription':
                return this.getFormsSubscriptionPageHeaderDefinitions();
            case 'forms-shared':
                return this.getFormsSharedPageHeaderDefinitions();
            case 'forms-published':
                return this.getFormsAgencyPublishedPageHeaderDefinitions();
            case 'forms-unpublished':
                return this.getFormsAgencyUnpublishedPageHeaderDefinitions();
            case 'forms-organization-published':
                return this.getFormsOrganizationPublishedPageHeaderDefinitions();
            case 'vendor-email-template-build':
                return this.getVendorEmailTemplateBuildHeaderDefinitions();
            case 'vendor-email-template-unpublished-build':
                return this.getVendorEmailTemplateUnpublishedBuildHeaderDefinitions();
            case 'forms-organization-unpublished':
                return this.getFormsOrganizationUnpublishedPageHeaderDefinitions();
            case 'form-submissions':
                return this.getFormSubmissionsHeaderDefinitions();
            case 'agency-access':
                return this.getAgencyAccessHeaderDefinitions();
            case 'partner-requests':
                return this.getPartnerRequestsHeaderDefinitions();
            case 'reports-scheduled':
                return this.getReportsScheduledHeaderDefinitions();
            case 'invoices':
                return this.getInvoicesHeaderDefinitions();
            case 'mdf-invoices':
                return this.getMDFInvoicesHeaderDefinitions();
            case 'template-organization-published':
                return this.getTemplateOrganizationPublishedHeaderDefinitions();
            case 'marketing-plan-template-organization-published':
                return this.getMarketingPlanTemplateOrganizationPublishedHeaderDefinitions(); 
            case 'marketing-plan-template-organization-unpublished':
                return this.getMarketingPlanTemplateOrganizationUnpublishedHeaderDefinitions();     
            case 'journey-template-organization-published':
                return this.getJourneyTemplateOrganizationPublishedHeaderDefinitions();  
            case 'journey-template-organization-unpublished':
                return this.getJourneyTemplateOrganizationUnpublishedHeaderDefinitions();  
            case 'template-organization-unpublished':
                return this.getTemplateOrganizationUnpublishedHeaderDefinitions();
            case 'design-studio-my-creations':
                return this.getMyCreationsHeaderDefinitions()
            case 'general-studio-library':
                return this.getGeneralStudioLibraryHeaderDefinitions();
            case 'open-api-keys':
                return this.getOpenApiHeaderDefinitions();
            case 'storefront-request':
                return this.getStorefrontRequestHeaderDefinitions();
            case 'marketplace-application':
                return this.getMarketplaceApplicationHeaderDefinitions();
            case 'marketplace-partner-request':
                return this.getMarketplacePartnerRequestHeaderDefinitions();
            case 'mdf-management':
                return this.getMDFManagementHeaderDefinitions();
            case 'mdf-management-pending':
                return this.getMDFManagementPendingHeaderDefinitions();
            case 'mdf-management-funds-allocated':
                return this.getMDFManagementFundsAllocatedHeaderDefinitions();
            case 'mdf-management-pop-submitted':
                return this.getMDFManagementPopSubmittedHeaderDefinitions();
            case 'mdf-management-funds-pending-payment':
                return this.getMDFManagementFundsPendingPaymentHeaderDefinitions();
            case 'mdf-management-funds-in-transit':
                return this.getMDFManagementFundsInTransitHeaderDefinitions();
            case 'mdf-management-funds-paid':
                return this.getMDFManagementFundsPaidHeaderDefinitions();
            case 'mdf-management-expired':
                return this.getMDFManagementExpiredHeaderDefinitions();
            case 'mdf-management-denied':
                return this.getMDFManagementDeniedHeaderDefinitions();
            case 'mdf-management-pop-denied':
                return this.getMDFManagementPopDeniedHeaderDefinitions();
            case 'mdf-report-management':
                return this.getMDFReportManagementHeaderDefinitions();
            case 'mdf-report-management-pending':
                return this.getMDFReportManagementPendingHeaderDefinitions();
            case 'mdf-report-management-funds-allocated':
                return this.getMDFReportManagementFundsAllocatedHeaderDefinitions();
            case 'mdf-report-management-pop-submitted':
                return this.getMDFReportManagementPopSubmittedHeaderDefinitions();
            case 'mdf-report-management-funds-pending-payment':
                return this.getMDFReportManagementFundsPendingPaymentHeaderDefinitions();
            case 'mdf-report-management-funds-in-transit':
                return this.getMDFReportManagementFundsInTransitHeaderDefinitions();
            case 'mdf-report-management-funds-paid':
                return this.getMDFReportManagementFundsPaidHeaderDefinitions();
            case 'mdf-report-management-expired':
                return this.getMDFReportManagementExpiredHeaderDefinitions();
            case 'mdf-report-management-denied':
                return this.getMDFReportManagementDeniedHeaderDefinitions();
            case 'mdf-report-management-pop-denied':
                return this.getMDFReportManagementPopDeniedHeaderDefinitions();
            case 'mdf-agency-budget':
                return this.getMDFAgencyBudgetHeaderDefinitions();   
            case 'agency-mdf-partner-request':
                return this.getAgencyMDFPartnersHeaderDefinitions()
            case 'mdf-agency-activity-pop':
                return this.getMDFAgencyActivityPOPHeaderDefinitions();
            case 'mdf-client-pending-request':
                return this.getMDFClientPendingRequestDefinitions()
            case 'mdf-dashboard-partners-request':
                return this.getMDFDashboardPartnersHeaderDefinitions();
            case 'mdf-preapproved-funds-request':
                return this.getMDFPreapprovedFundsHeaderDefinitions();
            case 'mdf-dashboard-allocations-request':
                    return this.getMDFDashboardAllocationsHeaderDefinitions();
            case 'mdf-available-vendors-request':
                return this.getMDFAvailableVendorsHeaderDefinitions();
            case 'mdf-partner-management':
                return this.getMDFPartnerManagementHeaderDefinitions();
            case 'mdf-partner-management-pending':
                return this.getMDFPartnerManagementPendingHeaderDefinitions();
            case 'mdf-partner-management-funds-allocated':
                return this.getMDFPartnerManagementFundsAllocatedHeaderDefinitions();
            case 'mdf-partner-management-pop-submitted':
                return this.getMDFPartnerManagementPopSubmittedHeaderDefinitions();
            case 'mdf-partner-management-funds-pending-payment':
                return this.getMDFPartnerManagementFundsPendingPaymentHeaderDefinitions();
            case 'mdf-partner-management-funds-in-transit':
                return this.getMDFPartnerManagementFundsInTransitHeaderDefinitions();
            case 'mdf-partner-management-funds-paid':
                return this.getMDFPartnerManagementFundsPaidHeaderDefinitions();
            case 'mdf-partner-management-expired':
                return this.getMDFPartnerManagementExpiredHeaderDefinitions();
            case 'mdf-partner-management-denied':
                return this.getMDFPartnerManagementDeniedHeaderDefinitions();
            case 'mdf-partner-management-pop-denied':
                return this.getMDFPartnerManagementPopDeniedHeaderDefinitions();
            case 'custom-insert-tags':
                return this.getCustomInsertTagsHeaderDefinitions();
            case 'my-headers':
                return this.getHeadersPageHeaderDefinitions();
            case 'headers-shared':
                return this.getHeadersSharedHeaderDefinitions();
            case 'headers-subscription':
                return this.getHeadersSubscriptionHeaderDefinitions();
            case 'headers-published':
                return this.getHeadersAgencyPublishedHeaderDefinitions();
            case 'headers-unpublished':
                return this.getHeadersAgencyUnpublishedHeaderDefinitions();
            case 'headers-organization-published':
                return this.getHeadersOrganizationPublishedPageHeaderDefinitions();
            case 'headers-organization-unpublished':
                return this.getHeadersOrganizationUnpublishedPageHeaderDefinitions();
            case 'my-footers':
                return this.getFootersPageHeaderDefinitions();
            case 'footers-shared':
                return this.getFootersSharedPageHeaderDefinitions();
            case 'footers-subscription':
                return this.getFootersSubscriptionPageHeaderDefinitions();
            case 'footers-published':
                return this.getFootersAgencyPublishedHeaderDefinitions();
            case 'footers-unpublished':
                return this.getFootersAgencyUnpublishedHeaderDefinitions();
            case 'footers-organization-published':
                return this.getFootersOrganizationPublishedPageHeaderDefinitions();
            case 'footers-organization-unpublished':
                return this.getFootersOrganizationUnpublishedPageHeaderDefinitions();
            case'partner-survey-header-definition':
                return this.getPartnerSurveysHeaderDefinition()
            case 'partner-survey-text-field-definition':
                return this.getSimpleBoardHeaderDefinition();
            case 'partner-survey-file-field-definition':
                return this.getSimpleBoardFileHeaderDefinition();
            case 'partner-survey-published':
                return this.getPartnerSurveyPublishedHeaderDefinitions();
            case 'partner-survey-unpublished':
                return this.getPartnerSurveyUnpublishedHeaderDefinitions();
            case 'partner-survey':
                return this.getPartnerSurveyHeaderDefinitions();
            case 'opportunity-report':
                return this.getOpportunityReportHeaderDefinition();
            case 'transactions':
                return this.getTransactionsHeaderDefinition();
            case 'payments-received':
                return this.getPaymentsReceivedHeaderDefinitions();
            case 'collateral-organization-unpublished-board':
                return this.getCollateralOrgUnpublishedBoardHeaderDefinition();
            case 'collateral-organization-published-board':
                return this.getCollateralOrgPublishedBoardHeaderDefinition();
            case 'collateral-build-organization-published-board':
                return this.getCollateralBuildOrgPublishedBoardHeaderDefinition();      
            case 'collateral-build-organization-unpublished-board':
                return this.getCollateralBuilOrgUnpublishedBoardHeaderDefinition();   
            case 'partner-vendor-resources-social-media':
                return this.getPartnerVendorResourcesSocialMediaHeaderDefinition();    
            case 'report-solutions-table':
                return this.getReportSolutionHeaders();
            case 'report-company-table': 
                return this.getReportCompanyHeaders();
            case 'appointment-request': 
                return this.getAppointmentRequestHeaders();
            case 'exit-survey': 
                return this.getExitSurveyHeaders(); 
        }
    },

    getPartnerVendorResourcesSocialMediaHeaderDefinition(){
        return [
            {
                key: 'name',
                type: 'preview-name',
                label: 'Post Name',
                property: 'postTemplate',
                width: 300,
                sortable: false,
                sortProperty: 'TemplateName',
                editable: false,
                filterable: false,
            },
            {
                key: 'publishedTo',
                type: 'social-media-posts',
                label: 'Published To',
                property: 'publishedSocialNetworks',
                width: 200,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
                description: 'The Social Media platforms that partners using this template have published it to.'
            },
            {
                key: 'clicks',
                type: 'string',
                label: 'Clicks',
                property: 'clicks',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
                description: 'Number of times this content has been clicked on.'
            },
            {
                key: 'impressions',
                type: 'string',
                label: 'Impressions',
                property: 'impressions',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
                description: 'Number of times this content is displayed, no matter if it was clicked or not.'
            },
            {
                key: 'reach',
                type: 'string',
                label: 'Reach',
                property: 'reach',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
                description:'Number of unique people that saw this content.'
            },
            {
                key: 'shares',
                type: 'string',
                label: 'Shares',
                property: 'shares',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
                description: 'Number of times this content has been shared across various social media platforms.'
            },
            {
                key: 'engagement',
                type: 'completion',
                label: 'Engagement',
                property: 'engagement',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
                description: 'Measures how much your audience interacts with your content (likes, comments and shares).'
            },
            {
                key: 'partnersPublishedTo',
                type: 'string',
                label: 'Partners Published To',
                property: 'partnersPublishedTo',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
                description: 'Number of partners you’ve published this Social Media to.'
            },
            {
                key: 'addedToTemplates',
                type: 'string',
                label: 'Added To Templates',
                property: 'addedToTemplates',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
                description: 'Number of times your partners have added this Social Media to their templates.'
            },
            {
                key: 'previewed',
                type: 'string',
                label: 'Previewed',
                property: 'previewed',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
                description: 'Number of times this Social Media has been previewed by your partners.'
            },
            {
                key: 'sent',
                type: 'string',
                label: 'Sent',
                property: 'sent',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
                description: 'Number of posts that have been sent out.'
            },
        ]
    },

    getGeneralStudioLibraryHeaderDefinitions(){
        return [
            {
                key: 'name',
                type: 'design-studio-name',
                label: 'Name',
                property: 'preview',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: true,
                multiSelectChip: true,
                filterOptions:[],
                getFilterOptions: () => {},
            },
            {
                key: 'type',
                type: 'string',
                label: 'Type',
                property: 'nameType',
                width: 250,
                sortable: false,
                sortProperty: 'Type',
                editable: true,
                filterable: true,
                multiSelectChip: true,
                secondMethodVersion: true,
                filterOptions:[],
                getFilterOptions: () => {},
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
                multiSelectChip: true,
                filterOptions:[],
                getFilterOptions: () => {},
            },
            {
                key: 'vendor',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'vendor',
                width: 300,
                sortable: false,
                sortProperty: 'Agency/Name',
                editable: false,
                filterable: true,
                multiSelectChip: true,
                secondMethodVersion: true,
                filterOptions:[],
                getFilterOptions: () => {},
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'date-time',
                label: 'Date Modified',
                property: 'updatedAt',
                width: 250,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ]
    },

    getCollateralOrgUnpublishedBoardHeaderDefinition() {
        return [
            {
                key: 'name',
                type:'collateral-name',
                label: 'Name',
                property: 'collateral',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Uploaded On',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'file-size',
                type: 'file-size',
                label: 'File Size',
                property: 'fileSizeInBytes',
                width: 200,
                sortable: true,
                sortProperty: 'FileSizeInBytes',
                editable: false,
                filterable: false,
            },
            {
                key: 'file-type',
                type: 'file-type',
                label: 'File Type',
                property: 'fileType',
                width: 150,
                sortable: true,
                sortProperty: 'FileType',
                editable: false,
                filterable: true,
            },
            {
                key: 'uploaded-by',
                type: 'user',
                label: 'Uploaded By',
                property: 'uploadedByUser',
                width: 200,
                sortable: true,
                sortProperty: 'UploadedByUser/LastName',
                editable: false,
                filterable: true,
            },
            
        ]
    },

    getTemplateOrganizationUnpublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'organization-email-template',
                label: 'Name',
                property: 'template',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'emails-sent',
                type: 'number',
                label: 'Emails Sent',
                property: 'timesUsed',
                width: 150,
                sortable: true,
                sortProperty: 'TimesUsed',
                editable: false,
                filterable: false,
            },
            {
                key: 'opens',
                type: 'completion',
                label: 'Avg Open',
                property: 'openRate',
                width: 200,
                sortable: true,
                sortProperty: 'OpenRate',
                editable: false,
                filterable: false,
            },
            {
                key: 'clicks',
                type: 'completion',
                label: 'Avg Click',
                property: 'clickRate',
                width: 200,
                sortable: true,
                sortProperty: 'ClickRate',
                editable: false,
                filterable: false,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 250,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ];
    },

    getJourneyTemplateOrganizationUnpublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'link',
                label: 'Name',
                property: 'name',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'trigger',
                type: 'string',
                label: 'Trigger',
                property: 'journeyTriggerName',
                width: 200,
                sortable: true,
                sortProperty: 'JourneyTrigger/Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'steps',
                type: 'number',
                label: 'Total Steps',
                property: 'totalSteps',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'email-steps',
                type: 'number',
                label: 'Email Steps',
                property: 'emailSteps',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'task-steps',
                type: 'number',
                label: 'Email Steps',
                property: 'taskSteps',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },

        ];
    },
    getMarketingPlanTemplateOrganizationUnpublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'marketing-plan-template-name',
                label: 'Name',
                property: 'template',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'duration',
                type: 'string',
                label: 'Duration',
                property: 'duration',
                width: 180,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'templates',
                type: 'number',
                label: 'Campaigns',
                property: 'templatesTotal',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            
            {
                key: 'created',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
        ];
    },
    getMarketingPlanTemplateOrganizationPublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'marketing-plan-template-name',
                label: 'Name',
                property: 'template',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'duration',
                type: 'string',
                label: 'Duration',
                property: 'duration',
                width: 180,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'templates',
                type: 'number',
                label: 'Campaigns',
                property: 'templatesTotal',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            
            {
                key: 'created',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'plans-published',
                type: 'number',
                label: 'Plans Published To',
                property: 'published',
                width: 180,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            
        ];
    },
    getJourneyTemplateOrganizationPublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'link',
                label: 'Name',
                property: 'name',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'trigger',
                type: 'string',
                label: 'Trigger',
                property: 'journeyTriggerName',
                width: 200,
                sortable: true,
                sortProperty: 'JourneyTrigger/Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'steps',
                type: 'number',
                label: 'Total Steps',
                property: 'totalSteps',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'email-steps',
                type: 'number',
                label: 'Email Steps',
                property: 'emailSteps',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'task-steps',
                type: 'number',
                label: 'Email Steps',
                property: 'taskSteps',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },

            {
                key: 'plans-published',
                type: 'number',
                label: 'Plans Published To',
                property: 'published',
                width: 180,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
        ];
    },

    getTemplateOrganizationPublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'organization-email-template',
                label: 'Name',
                property: 'template',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'plans-published',
                type: 'number',
                label: 'Plans Published To',
                property: 'published',
                width: 180,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'emails-sent',
                type: 'number',
                label: 'Emails Sent',
                property: 'timesUsed',
                width: 150,
                sortable: true,
                sortProperty: 'TimesUsed',
                editable: false,
                filterable: false,
            },
            {
                key: 'opens',
                type: 'completion',
                label: 'Avg Open',
                property: 'openRate',
                width: 200,
                sortable: true,
                sortProperty: 'OpenRate',
                editable: false,
                filterable: false,
            },
            {
                key: 'clicks',
                type: 'completion',
                label: 'Avg Click',
                property: 'clickRate',
                width: 200,
                sortable: true,
                sortProperty: 'ClickRate',
                editable: false,
                filterable: false,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 250,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ];
    },

    getGraphicalTemplateUnpublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'vendor-email-template',
                label: 'Name',
                property: 'template',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'emails-sent',
                type: 'number',
                label: 'Emails Sent',
                property: 'timesUsed',
                width: 150,
                sortable: true,
                sortProperty: 'TimesUsed',
                editable: false,
                filterable: false,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'autoPublished',
                width: 200,
                sortable: true,
                sortProperty: 'IsAutoPublished',
                editable: false,
                filterable: false,
            },
            {
                key: 'opens',
                type: 'completion',
                label: 'Avg Open',
                property: 'openRate',
                width: 200,
                sortable: true,
                sortProperty: 'OpenRate',
                editable: false,
                filterable: false,
            },
            {
                key: 'clicks',
                type: 'completion',
                label: 'Avg Click',
                property: 'clickRate',
                width: 200,
                sortable: true,
                sortProperty: 'ClickRate',
                editable: false,
                filterable: false,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 250,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ];
    },

    getCollateralBuildOrgPublishedBoardHeaderDefinition() {
        return [
            {
                key: 'name',
                type: 'collateral-build-name',
                label: 'Name',
                property: 'collateral',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: true,
            },
            {
                key: 'updated',
                type: 'date-time',
                label: 'Last Updated',
                property: 'updatedAt',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'plans-published',
                type: 'number',
                label: 'Plans Published To',
                property: 'published',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'file-size',
                type: 'string',
                label: 'Page Size',
                property: 'pageSize',
                width: 200,
                sortable: true,
                sortProperty:'PageSize',
                editable: false,
                filterable: false,
            },
            {
                key: 'page-count',
                type: 'number',
                label: 'Page Count',
                property: 'pageCount',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            
        ]
    },

    getCollateralBuilOrgUnpublishedBoardHeaderDefinition() {
        return [
            {
                key: 'name',
                type: 'collateral-build-name',
                label: 'Name',
                property: 'collateral',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: true,
            },
            {
                key: 'updated',
                type: 'date-time',
                label: 'Last Updated',
                property: 'updatedAt',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'file-size',
                type: 'string',
                label: 'Page Size',
                property: 'pageSize',
                width: 200,
                sortable: true,
                sortProperty:'PageSize',
                editable: false,
                filterable: false,
            },
            {
                key: 'page-count',
                type: 'number',
                label: 'Page Count',
                property: 'pageCount',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            
        ]
    },

    getCollateralOrgPublishedBoardHeaderDefinition() {
        return [
            {
                key: 'name',
                type:'collateral-name',
                label: 'Name',
                property: 'collateral',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'plans-published',
                type: 'number',
                label: 'Plans Published To',
                property: 'published',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Uploaded On',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'file-size',
                type: 'file-size',
                label: 'File Size',
                property: 'fileSizeInBytes',
                width: 200,
                sortable: true,
                sortProperty: 'FileSizeInBytes',
                editable: false,
                filterable: false,
            },
            {
                key: 'file-type',
                type: 'file-type',
                label: 'File Type',
                property: 'fileType',
                width: 150,
                sortable: true,
                sortProperty: 'FileType',
                editable: false,
                filterable: true,
            },
            {
                key: 'uploaded-by',
                type: 'user',
                label: 'Uploaded By',
                property: 'uploadedByUser',
                width: 200,
                sortable: true,
                sortProperty: 'UploadedByUser/LastName',
                editable: false,
                filterable: true,
            },
            
        ]
    },

    getOrgEmailTemplateUnpublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type:'organization-template-name',
                label: 'Name',
                property: 'template',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            
        ]
    }, 

    getOrgEmailTemplatePublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type:'organization-template-name',
                label: 'Name',
                property: 'template',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'plans-published',
                type: 'number',
                label: 'Plans Published To',
                property: 'published',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ]
    },

    getMarketingPlanTemplatePublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type:'vendor-marketing-plan-template-name',
                label: 'Name',
                property: 'template',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'emails-sent',
                type: 'number',
                label: 'Campaigns',
                property: 'timesUsed',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'template',
                width: 200,
                sortable: true,
                sortProperty: 'IsAutoPublished',
                editable: false,
                filterable: false,
            },
           
            {
                key: 'date',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            
        ];
    },

    getMarketingPlanTemplateUnpublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type:'vendor-marketing-plan-template-name',
                label: 'Name',
                property: 'template',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'emails-sent',
                type: 'number',
                label: 'Campaigns',
                property: 'timesUsed',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'template',
                width: 200,
                sortable: true,
                sortProperty: 'IsAutoPublished',
                editable: false,
                filterable: false,
            },
           
            {
                key: 'date',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            
        ];
    },

    getGraphicalTemplatePublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'vendor-email-template',
                label: 'Name',
                property: 'template',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'emails-sent',
                type: 'number',
                label: 'Emails Sent',
                property: 'timesUsed',
                width: 150,
                sortable: true,
                sortProperty: 'TimesUsed',
                editable: false,
                filterable: false,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'autoPublished',
                width: 200,
                sortable: true,
                sortProperty: 'IsAutoPublished',
                editable: false,
                filterable: false,
            },
            {
                key: 'clients-published',
                type: 'client-published',
                label: 'Partners Published To',
                property: 'asset',
                width: 200,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'opens',
                type: 'completion',
                label: 'Avg Open',
                property: 'openRate',
                width: 200,
                sortable: true,
                sortProperty: 'OpenRate',
                editable: false,
                filterable: false,
            },
            {
                key: 'clicks',
                type: 'completion',
                label: 'Avg Click',
                property: 'clickRate',
                width: 200,
                sortable: true,
                sortProperty: 'ClickRate',
                editable: false,
                filterable: false,
            },
            {
                key: 'date',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 250,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ];
    },

    getMarketingPlanTemplateSharedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'marketing-plan-template-name',
                label: 'Name',
                property: 'marketingPlanTemplate',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'vendor',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'vendor',
                width: 300,
                sortable: true,
                sortProperty: 'Agency/Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'duration',
                type: 'string',
                label: 'Duration',
                property: 'duration',
                width: 200,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'campaigns',
                type: 'number',
                label: 'Campaigns',
                property: 'templatesTotal',
                width: 200,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 250,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ];
    },

    getMarketingPlanTemplateSubscriptionHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'marketing-plan-template-name',
                label: 'Name',
                property: 'marketingPlanTemplate',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'duration',
                type: 'string',
                label: 'Duration',
                property: 'duration',
                width: 200,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'campaigns',
                type: 'number',
                label: 'Campaigns',
                property: 'templatesTotal',
                width: 200,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 250,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ];
    },

    getMarketingPlanTemplateHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'marketing-plan-template-name',
                label: 'Name',
                property: 'marketingPlanTemplate',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'duration',
                type: 'string',
                label: 'Duration',
                property: 'duration',
                width: 200,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'campaigns',
                type: 'number',
                label: 'Campaigns',
                property: 'templatesTotal',
                width: 200,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 250,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ];
    },

    getMarketingPlanHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'marketing-plan-name',
                label: 'Name',
                property: 'marketingPlan',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'duration',
                type: 'string',
                label: 'Duration',
                property: 'duration',
                width: 200,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },

            {
                key: 'created',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'campaigns',
                type: 'number',
                label: 'Campaigns',
                property: 'campaignTotal',
                width: 200,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'campaignsSent',
                type: 'number',
                label: 'Campaigns Sent',
                property: 'campaignsSent',
                width: 200,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
        ];
    },

    getSocialMediaManagePlanHeaderDefinitions() {
        return [
            {
                key: 'accountName',
                type: 'social-media-connected',
                label: 'Account Name',
                property: 'socialMediaAccount',
                width: 800,
                sortable: false,
                sortProperty: '',
                editable: true,
                filterable: false,
            },
            {
                key: 'status',
                type: 'social-media-status',
                label: 'Status',
                property: 'socialMediaStatus',
                width: 200,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },

            {
                key: 'manage',
                type: 'social-media-manage',
                label: 'Manage',
                property: 'socialMediaManage',
                width: 200,
                sortable: false,
                sortProperty: '',
                editable: true,
                filterable: false,
            },
        ];
    },

    getJourneyCategoryHeaderDefinitions()  {
        return [
            {
                key: 'category-name',
                type: 'journey-category-name',
                label: 'Name',
                property: 'category',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
        ];
    },

    getGlobalCategoryHeaderDefinitions() {
        return [
            {
                key: 'category-name',
                type: 'category-name',
                label: 'Name',
                property: 'category',
                width: 350,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
        ];
    },

    getClientAdoptionChurnedHeaderDefinitions() {
        return [
            {
                key: 'signUp',
                type: 'date-time',
                label: 'Signed Up',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'name',
                type: 'client-adoption-name',
                label: 'Name',
                property: 'client',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'plan-name',
                type: 'string',
                label: 'Plan',
                property: 'promo',
                width: 150,
                sortable: true,
                sortProperty: 'Promo/Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'reason',
                type: 'string',
                label: 'Reason',
                property: 'reason',
                width: 200,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountSetupProgress',
                type: 'completion',
                label: 'Account Setup Progress',
                property: 'accountSetupProgress',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
        ];
    },

    getClientAdoptionPartneredHeaderDefinitions() {
        return [
            {
                key: 'signUp',
                type: 'date-time',
                label: 'Signed Up',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'name',
                type: 'client-adoption-name',
                label: 'Name',
                property: 'client',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'plan-name',
                type: 'string',
                label: 'Plan',
                property: 'promo',
                width: 150,
                sortable: true,
                sortProperty: 'Promo/Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountSetupProgress',
                type: 'completion',
                label: 'Account Setup Progress',
                property: 'accountSetupProgress',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
        ];
    },

    getAgencyPartnerHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'client-name',
                label: 'Name',
                property: 'client',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'users',
                type: 'number',
                label: 'Users',
                property: 'users',
                width: 150,
                sortable: true,
                sortProperty: 'Users',
                editable: false,
                filterable: false,
            },
            {
                key: 'contacts-managed',
                type: 'number',
                label: 'Contacts Managed',
                property: 'contactsManaged',
                width: 200,
                sortable: true,
                sortProperty: 'ContactsManaged',
                editable: false,
                filterable: false,
            },
            {
                key: 'lists',
                type: 'number',
                label: 'Lists',
                property: 'lists',
                width: 150,
                sortable: true,
                sortProperty: 'Lists',
                editable: false,
                filterable: false,
            },
            {
                key: 'campaigns',
                type: 'number',
                label: 'Campaigns',
                property: 'campaigns',
                width: 150,
                sortable: true,
                sortProperty: 'Campaigns',
                editable: false,
                filterable: false,
            },
            {
                key: 'partner-assigned-users',
                type: 'partners-assigned-users',
                label: 'Assigned Users',
                property: 'assignedUsers',
                width: 250,
                sortable: false,
                sortProperty: null,
                editable: true,
                filterable: true,
            },
            {
                key: 'hasCompletedDKIM',
                type: 'completion-indicator',
                label: 'DKIM',
                property: 'hasDkim',
                width: 150,
                sortable: true,
                sortProperty: 'HasDkim',
                editable: false,
                filterable: false,
            },
            {
                key: 'hasCompletedEmailIntegration',
                type: 'completion-indicator',
                label: 'O365',
                property: 'hasEmailIntegration',
                width: 150,
                sortable: true,
                sortProperty: 'HasEmailIntegration',
                editable: false,
                filterable: false,
            },
            {
                key: 'billedAmount',
                type: 'currency',
                label: 'Billed Amount',
                property: 'billedAmount',
                width: 175,
                sortable: true,
                sortProperty: 'BilledAmount',
                editable: false,
                filterable: false,
            },
            {
                key: 'partnerResources',
                type: 'partner-resources-link',
                label: 'Partner Resources',
                property: 'client',
                width: 200,
                sortable: true,
                sortProperty: 'PartnerResources',
                editable: false,
                filterable: false,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Account Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'Client/CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountSetupProgress',
                type: 'completion',
                label: 'Setup Progress',
                property: 'accountSetupProgress',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'lastUserSession',
                type: 'full-date-time',
                label: 'Last user session',
                property: 'lastUserSession',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'avgDailySessions',
                type: 'number',
                label: 'Avg daily sessions',
                property: 'avgDailySessions',
                width: 200,
                sortable: true,
                sortProperty: 'AvgDailySessions',
                editable: false,
                filterable: false,
            },
            {
                key: 'avgSession',
                type: 'timer',
                label: 'Avg session',
                property: 'avgSession',
                width: 150,
                sortable: true,
                sortProperty: 'AvgSession',
                editable: false,
                filterable: false,
            },
            {
                key: 'salesActivities',
                type: 'number',
                label: 'Sales activities',
                property: 'salesActivities',
                width: 200,
                sortable: true,
                sortProperty: 'SalesActivities',
                editable: false,
                filterable: false,
            },
            {
                key: 'partnershipAccepted',
                type: 'full-date-time',
                label: 'Partnership accepted',
                property: 'partnershipAccepted',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
        ];
    },

    getClientHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'client-name',
                label: 'Name',
                property: 'client',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: true,
            },
            {
                key: 'active',
                type: 'completion-indicator',
                label: 'Active',
                property: 'active',
                width: 200,
                sortable: true,
                sortProperty: 'IsActive',
                editable: false,
                filterable: false,
            },
            {
                key: 'underReview',
                type: 'account-review',
                label: 'In Good Standing',
                property: 'underReview',
                width: 200,
                sortable: true,
                sortProperty: 'UnderReview',
                editable: false,
                filterable: false,
            },
            {
                key: 'signUp',
                type: 'date-time',
                label: 'Signed Up',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
        ];
    },

    getClientAdoptionFreeHeaderDefinitions() {
        return [
            {
                key: 'signUp',
                type: 'date-time',
                label: 'Signed Up',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'name',
                type: 'client-adoption-name',
                label: 'Name',
                property: 'client',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'plan-name',
                type: 'string',
                label: 'Plan',
                property: 'promo',
                width: 150,
                sortable: true,
                sortProperty: 'Promo/Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountSetupProgress',
                type: 'completion',
                label: 'Account Setup Progress',
                property: 'accountSetupProgress',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
        ];
    },

    getClientAdoptionPayingHeaderDefinitions() {
        return [
            {
                key: 'signUp',
                type: 'date-time',
                label: 'Signed Up',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'name',
                type: 'client-adoption-name',
                label: 'Name',
                property: 'client',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'plan-name',
                type: 'string',
                label: 'Plan',
                property: 'promo',
                width: 150,
                sortable: true,
                sortProperty: 'Promo/Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'price',
                type: 'link',
                label: 'Price',
                property: 'billing',
                width: 150,
                sortable: false,
                sortProperty: 'Promo/BasePrice',
                editable: false,
                filterable: false,
            },
            {
                key: 'billing-cycle',
                type: 'string',
                label: 'Billing Cycle',
                property: 'cycle',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountSetupProgress',
                type: 'completion',
                label: 'Account Setup Progress',
                property: 'accountSetupProgress',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'totalUsers',
                type: 'link',
                label: 'Users',
                property: 'totalUsers',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
        ];
    },

    getPhoneNumbersPageHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'user-name',
                label: 'Name',
                property: 'user',
                width: 400,
                sortable: true,
                sortProperty: 'User/FirstName',
                editable: false,
                filterable: false,
            },
            {
                key: 'mobilePhone',
                type: 'contact-mobile-phone',
                label: 'Phone Number',
                property: 'contact',
                width: 200,
                sortable: true,
                sortProperty: 'Number',
                editable: false,
                filterable: false,
            },
            {
                key: 'hasSMS',
                type: 'completion-indicator',
                label: 'SMS',
                property: 'hasSMS',
                width: 200,
                sortable: true,
                sortProperty: 'IsSmsCapable',
                editable: false,
                filterable: false,
            },
            {
                key: 'hasMMS',
                type: 'completion-indicator',
                label: 'MMS',
                property: 'hasMMS',
                width: 200,
                sortable: true,
                sortProperty: 'IsMmsCapable',
                editable: false,
                filterable: false,
            },
            {
                key: 'hasVoice',
                type: 'completion-indicator',
                label: 'Voice',
                property: 'hasVoice',
                width: 200,
                sortable: true,
                sortProperty: 'IsVoiceCapable',
                editable: false,
                filterable: false,
            },
        ];
    },

    getFormLandingPageHeaderDefinitions() {
        return [
            {
                key: 'landingPage',
                type: 'landing-page-name',
                label: 'Landing Page',
                property: 'landingPage',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'published-url',
                type: 'landing-page-url',
                label: 'Published Url',
                property: 'landingPage',
                width: 300,
                sortable: true,
                sortProperty: 'Url',
                editable: false,
                filterable: true,
            },
            {
                key: 'updated-date',
                type: 'date-time',
                label: 'Updated Date',
                property: 'updatedDate',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'created-date',
                type: 'date-time',
                label: 'Created Date',
                property: 'createdDate',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'status',
                type: 'status',
                label: 'Status',
                property: 'status',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'form-submissions',
                type: 'link',
                label: 'Form Submissions',
                property: 'formSubmissions',
                width: 120,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'unique-views',
                type: 'number',
                label: 'Unique Views',
                property: 'uniqueViews',
                width: 120,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
        ];
    },
    getPublishedLandingPageHeaderDefinitions() {
        return [
            {
                key: 'landingPage',
                type: 'landing-page-name',
                label: 'Landing Page',
                property: 'landingPage',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'published-url',
                type: 'landing-page-url',
                label: 'Published Url',
                property: 'landingPage',
                width: 300,
                sortable: true,
                sortProperty: 'Url',
                editable: false,
                filterable: true,
            },
            {
                key: 'updated-date',
                type: 'date-time',
                label: 'Updated Date',
                property: 'updatedDate',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'created-date',
                type: 'date-time',
                label: 'Created Date',
                property: 'createdDate',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 300,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'form-submission',
                type: 'link',
                label: 'Form Submission',
                property: 'formSubmissions',
                width: 120,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'unique-views',
                type: 'number',
                label: 'Unique Views',
                property: 'uniqueViews',
                width: 120,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
        ];
    },

    getUnPublishedLandingPageHeaderDefinitions() {
        return [
            {
                key: 'landingPage',
                type: 'landing-page-name',
                label: 'Landing Page',
                property: 'landingPage',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'updated-date',
                type: 'date-time',
                label: 'Updated Date',
                property: 'updatedDate',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'created-date',
                type: 'date-time',
                label: 'Created Date',
                property: 'createdDate',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 300,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'form-submission',
                type: 'link',
                label: 'Form Submission',
                property: 'formSubmissions',
                width: 120,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'unique-views',
                type: 'number',
                label: 'Unique Views',
                property: 'uniqueViews',
                width: 120,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
        ];
    },

    getDomainsPageHeaderDefinitions() {
        return [
            {
                key: 'domain-name',
                type: 'domain',
                label: 'Domains',
                property: 'domain',
                width: 600,
                sortable: true,
                sortProperty: 'DomainName',
                editable: false,
                filterable: true,
            },
            {
                key: 'domain-validation-status',
                type: 'completion-indicator',
                label: 'Validated',
                property: 'validated',
                width: 157,
                sortable: true,
                sortProperty: 'Validated',
                editable: false,
                filterable: false,
            },
            {
                key: 'domain-creation-date',
                type: 'date-time',
                label: 'Created',
                property: 'createdDate',
                width: 233,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
        ];
    },

    getCollateralHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'collateral-name',
                label: 'Filename',
                property: 'collateral',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'Sent',
                type: 'number',
                label: 'Sent',
                property: 'sent',
                width: 120,
                sortable: true,
                sortProperty: 'Sent',
                editable: false,
                filterable: false,
            },
            {
                key: 'views',
                type: 'number',
                label: 'Views',
                property: 'views',
                width: 120,
                sortable: true,
                sortProperty: 'Views',
                editable: false,
                filterable: false,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Uploaded On',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'updated',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'file-size',
                type: 'file-size',
                label: 'File Size',
                property: 'fileSizeInBytes',
                width: 200,
                sortable: true,
                sortProperty: 'FileSizeInBytes',
                editable: false,
                filterable: false,
            },
            {
                key: 'file-type',
                type: 'file-type',
                label: 'File Type',
                property: 'fileType',
                width: 150,
                sortable: true,
                sortProperty: 'FileType',
                editable: false,
                filterable: true,
            },
            {
                key: 'uploaded-by',
                type: 'user',
                label: 'Uploaded By',
                property: 'uploadedByUser',
                width: 200,
                sortable: true,
                sortProperty: 'UploadedByUser/LastName',
                editable: false,
                filterable: true,
            },
        ];
    },

    getCollateralPublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'collateral-name',
                label: 'Filename',
                property: 'collateral',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'autoPublished',
                width: 160,
                sortable: true,
                sortProperty: 'IsAutoPublished',
                editable: false,
                filterable: false,
            },
            {
                key: 'clientsPublished',
                type: 'client-published',
                label: 'Partners Published To',
                property: 'asset',
                width: 120,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'Sent',
                type: 'number',
                label: 'Sent',
                property: 'sent',
                width: 120,
                sortable: true,
                sortProperty: 'Sent',
                editable: false,
                filterable: false,
            },
            {
                key: 'views',
                type: 'number',
                label: 'Views',
                property: 'views',
                width: 120,
                sortable: true,
                sortProperty: 'Views',
                editable: false,
                filterable: false,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Uploaded On',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'updated',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'file-size',
                type: 'file-size',
                label: 'File Size',
                property: 'fileSizeInBytes',
                width: 200,
                sortable: true,
                sortProperty: 'FileSizeInBytes',
                editable: false,
                filterable: false,
            },
            {
                key: 'file-type',
                type: 'file-type',
                label: 'File Type',
                property: 'fileType',
                width: 150,
                sortable: true,
                sortProperty: 'FileType',
                editable: false,
                filterable: true,
            },
            {
                key: 'uploaded-by',
                type: 'user',
                label: 'Uploaded By',
                property: 'uploadedByUser',
                width: 200,
                sortable: true,
                sortProperty: 'UploadedByUser/LastName',
                editable: false,
                filterable: true,
            },
        ];
    },

    getCollateralUnpublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'collateral-name',
                label: 'Filename',
                property: 'collateral',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'autoPublished',
                width: 160,
                sortable: true,
                sortProperty: 'IsAutoPublished',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'Sent',
                type: 'number',
                label: 'Sent',
                property: 'sent',
                width: 120,
                sortable: true,
                sortProperty: 'Sent',
                editable: false,
                filterable: false,
            },
            {
                key: 'views',
                type: 'number',
                label: 'Views',
                property: 'views',
                width: 120,
                sortable: true,
                sortProperty: 'Views',
                editable: false,
                filterable: false,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Uploaded On',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'updated',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'file-size',
                type: 'file-size',
                label: 'File Size',
                property: 'fileSizeInBytes',
                width: 200,
                sortable: true,
                sortProperty: 'FileSizeInBytes',
                editable: false,
                filterable: false,
            },
            {
                key: 'file-type',
                type: 'file-type',
                label: 'File Type',
                property: 'fileType',
                width: 150,
                sortable: true,
                sortProperty: 'FileType',
                editable: false,
                filterable: true,
            },
            {
                key: 'uploaded-by',
                type: 'user',
                label: 'Uploaded By',
                property: 'uploadedByUser',
                width: 200,
                sortable: true,
                sortProperty: 'UploadedByUser/LastName',
                editable: false,
                filterable: true,
            },
        ];
    },

    getResourceHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'collateral-name',
                label: 'Filename',
                property: 'collateral',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Uploaded On',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'updated',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },

            {
                key: 'type',
                type: 'type',
                label: 'Type',
                property: 'type',
                width: 150,
                sortable: true,
                sortProperty: 'Type',
                editable: false,
                filterable: true,
            },
            {
                key: 'uploaded-by',
                type: 'user',
                label: 'Uploaded By',
                property: 'uploadedByUser',
                width: 200,
                sortable: true,
                sortProperty: 'UploadedByUser/LastName',
                editable: false,
                filterable: false,
            },
        ];
    },

    getCollateralBuildSubscriptionHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'collateral-build-shared',
                label: 'Name',
                property: 'collateral',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: true,
            },
            {
                key: 'updated',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: true,
            },
            {
                key: 'page-size',
                type: 'string',
                label: 'Page Size',
                property: 'pageSize',
                width: 200,
                sortable: true,
                sortProperty: 'PageSize',
                editable: false,
                filterable: false,
            },
        ];
    },

    getCollateralBuildSharedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'collateral-build-shared',
                label: 'Name',
                property: 'collateral',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'agency',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'agency',
                width: 300,
                sortable: true,
                sortProperty: 'Agency/Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'updated',
                type: 'date-time',
                label: 'Last Updated',
                property: 'updatedAt',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: true,
            },

            {
                key: 'created',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: true,
            },

            {
                key: 'pageSize',
                type: 'string',
                label: 'Page Size',
                property: 'pageSize',
                width: 200,
                sortable: true,
                sortProperty: 'PageSize',
                editable: false,
                filterable: false,
            },

            {
                key: 'pageCount',
                type: 'number',
                label: 'Page Count',
                property: 'pageCount',
                width: 200,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
        ];
    },

    getVendorCollateralBuildUnpublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'collateral-build-name',
                label: 'Name',
                property: 'collateral',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'updated',
                type: 'date-time',
                label: 'Last Updated',
                property: 'updatedAt',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'autoPublished',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            
            {
                key: 'page-size',
                type: 'string',
                label: 'Page Size',
                property: 'pageSize',
                width: 200,
                sortable: true,
                sortProperty: 'PageSize',
                editable: false,
                filterable: false,
            },
            {
                key: 'pageCount',
                type: 'number',
                label: 'Page Count',
                property: 'pageCount',
                width: 200,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },

        ];
    },

    getVendorCollateralBuildHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'collateral-build-name',
                label: 'Name',
                property: 'collateral',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'updated',
                type: 'date-time',
                label: 'Last Updated',
                property: 'updatedAt',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'autoPublished',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'clientsPublished',
                type: 'client-published',
                label: 'clients published to',
                property: 'asset',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'page-size',
                type: 'string',
                label: 'Page Size',
                property: 'pageSize',
                width: 200,
                sortable: true,
                sortProperty: 'PageSize',
                editable: false,
                filterable: false,
            },
            {
                key: 'pageCount',
                type: 'number',
                label: 'Page Count',
                property: 'pageCount',
                width: 200,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },

        ];
    },

    getCollateralBuildHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'collateral-build-name',
                label: 'Name',
                property: 'collateral',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'updated',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ];
    },

    getCollateralSubscriptionHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'collateral-name',
                label: 'Filename',
                property: 'collateral',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Uploaded On',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'updated',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'file-size',
                type: 'file-size',
                label: 'File Size',
                property: 'fileSizeInBytes',
                width: 200,
                sortable: true,
                sortProperty: 'FileSizeInBytes',
                editable: false,
                filterable: false,
            },
            {
                key: 'file-type',
                type: 'file-type',
                label: 'File Type',
                property: 'fileType',
                width: 150,
                sortable: true,
                sortProperty: 'FileType',
                editable: false,
                filterable: true,
            },
            {
                key: 'uploaded-by',
                type: 'user',
                label: 'Uploaded By',
                property: 'uploadedByUser',
                width: 200,
                sortable: true,
                sortProperty: 'UploadedByUser/LastName',
                editable: false,
                filterable: false,
            },
        ];
    },

    getCollateralSharedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'collateral-name',
                label: 'Filename',
                property: 'collateral',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'agency',
                type: 'vendor-name',
                label: 'Agency',
                property: 'agency',
                width: 250,
                sortable: true,
                sortProperty: 'Agency/Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Uploaded On',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'updated',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'file-type',
                type: 'file-type',
                label: 'File Type',
                property: 'fileType',
                width: 150,
                sortable: true,
                sortProperty: 'FileType',
                editable: false,
                filterable: true,
            },
        ];
    },

    getFormsPageHeaderDefinitions() {
        return [
            {
                key: 'form-name',
                type: 'link',
                label: 'Forms',
                property: 'form',
                width: 719,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'more-details',
                type: 'form-details',
                label: 'More Details',
                property: 'id',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'unique-views',
                type: 'number',
                label: 'Unique Views',
                property: 'uniqueViews',
                width: 120,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'entries',
                type: 'number',
                label: 'Entries',
                property: 'entries',
                width: 120,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
        ];
    },

    getFormsSubscriptionPageHeaderDefinitions() {
        return [
            {
                key: 'form-name',
                type: 'link',
                label: 'Form Template Name',
                property: 'form',
                width: 280,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'more-details',
                type: 'form-details',
                label: 'More Details',
                property: 'id',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 270,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 270,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ];
    },

    getFormsSharedPageHeaderDefinitions() {
        return [
            {
                key: 'form-name',
                type: 'link',
                label: 'Form Template Name',
                property: 'form',
                width: 280,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'more-details',
                type: 'form-details',
                label: 'More Details',
                property: 'id',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'agency',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'agency',
                width: 250,
                sortable: true,
                sortProperty: 'Agency/Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 270,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 270,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ];
    },

    getFormsAgencyPublishedPageHeaderDefinitions() {
        return [
            {
                key: 'form-name',
                type: 'link',
                label: 'Form Template Name',
                property: 'formBuilder',
                width: 280,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'more-details',
                type: 'form-details',
                label: 'More Details',
                property: 'id',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'autoPublished',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'clientsPublished',
                type: 'client-published',
                label: 'Partners Published To',
                property: 'asset',
                width: 120,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'publishedDate',
                type: 'full-date-time',
                label: 'Published Date',
                property: 'publishedAt',
                width: 270,
                sortable: true,
                sortProperty: 'PublishedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 270,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 270,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'unique-views',
                type: 'number',
                label: 'Unique Views',
                property: 'uniqueViews',
                width: 120,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'entries',
                type: 'number',
                label: 'Entries',
                property: 'entries',
                width: 120,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ];
    },

    getFormsAgencyUnpublishedPageHeaderDefinitions() {
        return [
            {
                key: 'form-name',
                type: 'link',
                label: 'Form Template Name',
                property: 'formBuilder',
                width: 280,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'more-details',
                type: 'form-details',
                label: 'More Details',
                property: 'id',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'autoPublished',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 270,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 270,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
        ];
    },

    getFormsOrganizationPublishedPageHeaderDefinitions() {
        return [
            {
                key: 'form-name',
                type: 'link',
                label: 'Form Template Name',
                property: 'formBuilder',
                width: 280,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'more-details',
                type: 'form-details',
                label: 'More Details',
                property: 'id',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'plans-published',
                type: 'number',
                label: 'Plans Published To',
                property: 'plansPublishedTo',
                width: 120,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 270,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 270,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'unique-views',
                type: 'number',
                label: 'Unique Views',
                property: 'uniqueViews',
                width: 120,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'entries',
                type: 'number',
                label: 'Entries',
                property: 'entries',
                width: 120,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ];
    },

    getFormsOrganizationUnpublishedPageHeaderDefinitions() {
        return [
            {
                key: 'form-name',
                type: 'link',
                label: 'Form Template Name',
                property: 'formBuilder',
                width: 280,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'more-details',
                type: 'form-details',
                label: 'More Details',
                property: 'id',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 270,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 270,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
        ];
    },

    getFormSubmissionsHeaderDefinitions() {
        return [
            {
                key: 'contact',
                type: 'form-submission-contact',
                label: 'Contact',
                property: 'contact',
                width: 300,
                sortable: true,
                sortProperty: 'Contact/LastName',
                editable: true,
                filterable: true,
            },
            {
                key: 'company',
                type: 'form-submission-company',
                label: 'Company',
                property: 'company',
                width: 300,
                sortable: true,
                sortProperty: 'Company/Name',
                editable: true,
                filterable: true,
            },
            {
                key: 'form-submission-details',
                type: 'form-submission-details',
                label: 'Details',
                property: 'id',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'submission-date',
                type: 'date-time',
                label: 'Date',
                property: 'submissionDate',
                width: 300,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'landing-page',
                type: 'landing-page-name',
                label: 'Landing Page',
                property: 'landingPage',
                width: 300,
                sortable: true,
                sortProperty: 'LandingPage/Name',
                editable: false,
                filterable: true,
            },
        ];
    },

    getFormSubmissionHeaderDefinitions() {
        return [
            {
                key: 'contact',
                type: 'contact',
                label: 'Name',
                property: 'contact',
                width: 250,
                sortable: true,
                sortProperty: 'Contact/LastName',
                editable: false,
                filterable: false,
            },
            {
                key: 'email',
                type: 'contact-email',
                label: 'Email',
                property: 'contact',
                width: 200,
                sortable: true,
                sortProperty: 'Contact/Email',
                editable: false,
                filterable: true,
            },
            {
                key: 'form-type',
                type: 'string',
                label: 'Form Type',
                property: 'formType',
                width: 250,
                sortable: true,
                sortProperty: 'FormType',
                editable: false,
                filterable: false,
            },
            {
                key: 'website',
                type: 'string',
                label: 'URL',
                property: 'websiteUrl',
                width: 250,
                sortable: true,
                sortProperty: 'FormWebsiteUrl',
                editable: false,
                filterable: false,
            },
            {
                key: 'comments',
                type: 'string',
                label: 'Comment',
                property: 'comment',
                width: 400,
                sortable: true,
                sortProperty: 'FormComment',
                editable: false,
                filterable: false,
            },
            {
                key: 'status',
                type: 'string',
                label: 'Status',
                property: 'contactStatus',
                width: 200,
                sortable: true,
                sortProperty: 'Contact/ContactStatus/Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'company',
                type: 'contact-company',
                label: 'Company',
                property: 'company',
                width: 250,
                sortable: true,
                sortProperty: 'Contact/Company/Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'temperature',
                type: 'temperature',
                label: 'Temp',
                property: 'temperature',
                width: 100,
                sortable: true,
                sortProperty: 'Contact/TemperatureRating',
                editable: false,
                filterable: false,
            },
            {
                key: 'phone',
                type: 'contact-phone',
                label: 'Phone',
                property: 'contact',
                width: 200,
                sortable: true,
                sortProperty: 'Contact/Phone',
                editable: true,
                filterable: false,
            },
            {
                key: 'activity-date',
                type: 'date',
                label: 'Date',
                property: 'date',
                width: 190,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'assigned-salesperson',
                type: 'contact-salesperson',
                label: 'Salesperson',
                property: 'salesperson',
                width: 250,
                sortable: true,
                sortProperty: 'Contact/SalesPerson/LastName',
                editable: true,
                filterable: false,
            },
            {
                key: 'social-media',
                type: 'social-media',
                label: 'Social',
                property: 'socialMedia',
                width: 150,
                sortable: true,
                sortProperty: 'Contact/LinkedinUrl',
                editable: false,
                filterable: false,
            },
            {
                key: 'form-details',
                type: 'forms-widget',
                label: 'Details',
                property: 'id',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            
        ];
    },

    getOpenApiHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'open-api-name',
                label: 'Name',
                property: 'name',
                width: 200,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'apiKey',
                type: 'open-api-key',
                label: 'Key',
                property: 'apiKey',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdAt',
                type: 'full-date-time',
                label: 'Created',
                property: 'createdAt',
                width: '280',
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
        ]
    },

    getContactHeaderDefinitions() {
        return [
            {
                key: 'email',
                type: 'contact-email',
                label: 'Email',
                property: 'contact',
                width: 200,
                sortable: true,
                sortProperty: 'Email',
                editable: true,
                filterable: true,
            },
            {
                key: 'contact',
                type: 'contact',
                label: 'Name',
                property: 'contact',
                width: 300,
                sortable: true,
                sortProperty: 'LastName',
                editable: true,
                filterable: true,
            },
            {
                key: 'title',
                type: 'contact-title',
                label: 'Title',
                property: 'contact',
                width: 250,
                sortable: true,
                sortProperty: 'Title',
                editable: true,
                filterable: true,
            },
            {
                key: 'buyer-role',
                type: 'contact-buyer-role',
                label: 'Buyer Role',
                property: 'contact',
                width: 200,
                sortable: true,
                sortProperty: 'BuyerRoleId',
                editable: false,
                filterable: false,
            },
            {
                key: 'assigned-contact-status',
                type: 'contact-status',
                label: 'Contact Status',
                property: 'status',
                width: 250,
                sortable: true,
                sortProperty: 'ContactStatus/Name',
                editable: true,
                filterable: true,
            },
            {
                key: 'score',
                type: 'score',
                label: 'Score',
                property: 'score',
                width: 100,
                sortable: true,
                sortProperty: 'Score',
                editable: false,
                filterable: true,
            },
            {
                key: 'temperature',
                type: 'temperature',
                label: 'Temp',
                property: 'temperature',
                width: 100,
                sortable: true,
                sortProperty: 'TemperatureRating',
                editable: false,
                filterable: true,
            },
            {
                key: 'employees',
                type: 'company-employees',
                label: 'Employees',
                property: 'company',
                width: 150,
                sortable: true,
                sortProperty: 'Company/ApproximateEmployeeCount',
                editable: true,
                filterable: false,
            },
            {
                key: 'lists',
                type: 'contact-lists',
                label: 'Lists',
                property: 'contact',
                width: 200,
                sortable: false,
                editable: true,
                filterable: true,
            },
            {
                key: 'journeys',
                type: 'contact-journeys',
                label: 'Active Journeys',
                property: 'contact',
                width: 200,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'company',
                type: 'contact-company',
                label: 'Company',
                property: 'company',
                width: 250,
                sortable: true,
                sortProperty: 'Company/Name',
                editable: true,
                filterable: true,
            },
            {
                key: 'city',
                type: 'contact-city',
                label: 'City',
                property: 'contact',
                width: 150,
                sortable: true,
                sortProperty: 'City',
                editable: true,
                filterable: true,
            },
            {
                key: 'region',
                type: 'contact-region',
                label: 'State',
                property: 'contact',
                width: 150,
                sortable: true,
                sortProperty: 'Region',
                editable: true,
                filterable: true,
            },
            {
                key: 'phone',
                type: 'contact-phone',
                label: 'Work Phone',
                property: 'contact',
                width: 200,
                sortable: true,
                sortProperty: 'Phone',
                editable: true,
                filterable: true,
            },
            {
                key: 'mobile-phone',
                type: 'contact-mobile-phone',
                label: 'Mobile Phone',
                property: 'contact',
                width: 200,
                sortable: true,
                sortProperty: 'MobilePhone',
                editable: true,
                filterable: true,
            },
            {
                key: 'last-lead-activity-date',
                type: 'date',
                label: 'Last Contact Activity',
                property: 'lastLeadActivityDate',
                width: 190,
                sortable: true,
                sortProperty: 'LastLeadActivityDate',
                editable: true,
                filterable: false,
            },
            {
                key: 'last-user-activity-date',
                type: 'date',
                label: 'Last Sales Activity',
                property: 'lastUserActivityDate',
                width: 190,
                sortable: true,
                sortProperty: 'LastUserActivityDate',
                editable: true,
                filterable: false,
            },
            {
                key: 'social-media',
                type: 'social-media',
                label: 'Social',
                property: 'socialMedia',
                width: 150,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'activities',
                type: 'contact-activities',
                label: 'Activities',
                property: 'activities',
                width: 180,
                sortable: false,
                sortProperty: 'Activities',
                editable: true,
                filterable: false,
            },
            {
                key: 'assigned-salesperson',
                type: 'contact-salesperson',
                label: 'Salesperson',
                property: 'salesperson',
                width: 250,
                sortable: true,
                sortProperty: 'SalesPerson/FirstName',
                editable: true,
                filterable: true,
            },
            {
                key: 'createdDate',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 250,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'subscriptionStatus',
                type: 'subscription-status',
                label: 'Subscribed?',
                property: 'contact',
                width: 250,
                sortable: true,
                sortProperty: 'IsSubscribed',
                editable: true,
                filterable: false,
            },
            {
                key: 'bounced',
                type: 'yes-no-indicator',
                label: 'Bounced?',
                property: 'isBounced',
                width: 150,
                sortable: true,
                sortProperty: 'IsBounced',
                editable: false,
                filterable: false,
            },

        ];
    },

    getVendorHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'vendor-name',
                label: 'Name',
                property: 'vendor',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'vendor-clients',
                type: 'number',
                label: 'Partners',
                property: 'clientsCount',
                width: 150,
                sortable: true,
                sortProperty: 'ClientsCount',
                editable: false,
                filterable: false,
            },
            {
                key: 'vendor-contacts',
                type: 'number',
                label: 'Contacts',
                property: 'contactsCount',
                width: 150,
                sortable: true,
                sortProperty: 'ContactsCount',
                editable: false,
                filterable: false,
            },
            {
                key: 'vendor-resources',
                type: 'number',
                label: 'Resources',
                property: 'resourcesCount',
                width: 150,
                sortable: true,
                sortProperty: 'ResourcesCount',
                editable: false,
                filterable: false,
            },
        ];
    },

    getMasterAgencyHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'master-agency-name',
                label: 'Name',
                property: 'masterAgency',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
        ];
    },

    getCompanyHeaderDefinitions() {
        return [
            {
                key: 'company',
                type: 'company-name',
                label: 'Name',
                property: 'company',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: true,
            },
            {
                key: 'phone',
                type: 'company-phone',
                label: 'Work Phone',
                property: 'company',
                width: 200,
                sortable: true,
                sortProperty: 'Phone',
                editable: true,
                filterable: true,
            },
            {
                key: 'website',
                type: 'company-website',
                label: 'Website',
                property: 'company',
                width: 200,
                sortable: true,
                sortProperty: 'Website',
                editable: true,
                filterable: true,
            },
            {
                key: 'assigned-users',
                type: 'assigned-users',
                label: 'Assigned Users',
                property: 'assignedUsers',
                width: 250,
                sortable: false,
                sortProperty: null,
                editable: true,
                filterable: true,
            },
            {
                key: 'account',
                type: 'completion-indicator',
                label: 'Account',
                property: 'isAccount',
                width: 150,
                sortable: true,
                sortProperty: 'IsAccount',
                editable: false,
                filterable: false,
            },
            {
                key: 'employees',
                type: 'number',
                label: 'Employees',
                property: 'employeeCount',
                width: 150,
                sortable: true,
                sortProperty: 'ApproximateEmployeeCount',
                editable: false,
                filterable: false,
            },
            {
                key: 'score',
                type: 'score',
                label: 'Score',
                property: 'score',
                width: 100,
                sortable: true,
                sortProperty: 'Score',
                editable: false,
                filterable: true,
            },
            {
                key: 'temperature',
                type: 'temperature',
                label: 'Temp',
                property: 'temperature',
                width: 100,
                sortable: false,
                sortProperty: 'TemperatureRating',
                editable: false,
                filterable: true,
            },
            {
                key: 'social-media',
                type: 'social-media',
                label: 'Social',
                property: 'socialMedia',
                width: 150,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'region',
                type: 'company-region',
                label: 'State',
                property: 'company',
                width: 150,
                sortable: true,
                sortProperty: 'Region',
                editable: true,
                filterable: true,
            },
            {
                key: 'assigned-company-type',
                type: 'company-type',
                label: 'Company Type',
                property: 'companyType',
                width: 250,
                sortable: true,
                sortProperty: 'CompanyType/Name',
                editable: true,
                filterable: true,
            },
            {
                key: 'assigned-company-vertical',
                type: 'company-vertical',
                label: 'Vertical',
                property: 'vertical',
                width: 250,
                sortable: true,
                sortProperty: 'Vertical/Name',
                editable: true,
                filterable: true,
            },
            {
                key: 'createdDate',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 250,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ];
    },

    getCompanyAccountsHeaderDefinitions() {
        return [
            {
                key: 'company',
                type: 'company-name',
                label: 'Name',
                property: 'company',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: true,
            },
            {
                key: 'phone',
                type: 'company-phone',
                label: 'Work Phone',
                property: 'company',
                width: 200,
                sortable: true,
                sortProperty: 'Phone',
                editable: true,
                filterable: true,
            },
            {
                key: 'website',
                type: 'company-website',
                label: 'Website',
                property: 'company',
                width: 200,
                sortable: true,
                sortProperty: 'Website',
                editable: true,
                filterable: true,
            },
            {
                key: 'assignedUsers',
                type: 'assigned-users',
                label: 'Assigned Users',
                property: 'assignedUsers',
                width: 250,
                sortable: false,
                sortProperty: null,
                editable: true,
                filterable: false,
            },
            {
                key: 'employees',
                type: 'number',
                label: 'Employees',
                property: 'employeeCount',
                width: 150,
                sortable: true,
                sortProperty: 'ApproximateEmployeeCount',
                editable: false,
                filterable: false,
            },
            {
                key: 'score',
                type: 'score',
                label: 'Score',
                property: 'score',
                width: 100,
                sortable: true,
                sortProperty: 'Score',
                editable: false,
                filterable: true,
            },
            {
                key: 'temperature',
                type: 'temperature',
                label: 'Temp',
                property: 'temperature',
                width: 100,
                sortable: true,
                sortProperty: 'TemperatureRating',
                editable: false,
                filterable: true,
            },
            {
                key: 'social-media',
                type: 'social-media',
                label: 'Social',
                property: 'socialMedia',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'region',
                type: 'company-region',
                label: 'State',
                property: 'company',
                width: 150,
                sortable: true,
                sortProperty: 'Region',
                editable: true,
                filterable: true,
            },
            {
                key: 'assigned-company-type',
                type: 'company-type',
                label: 'Company Type',
                property: 'companyType',
                width: 250,
                sortable: true,
                sortProperty: 'CompanyType/Name',
                editable: true,
                filterable: true,
            },
            {
                key: 'assigned-company-vertical',
                type: 'company-vertical',
                label: 'Vertical',
                property: 'vertical',
                width: 250,
                sortable: true,
                sortProperty: 'Vertical/Name',
                editable: true,
                filterable: true,
            },
            {
                key: 'createdDate',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 250,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountStartDate',
                type: 'full-date-time',
                label: 'Account Start Date',
                property: 'accountStartDate',
                width: 250,
                sortable: true,
                sortProperty: 'AccountStartDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'contractStartDate',
                type: 'full-date-time',
                label: 'Contract Start Date',
                property: 'contractStartDate',
                width: 250,
                sortable: true,
                sortProperty: 'ContractStartDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'contractEndDate',
                type: 'full-date-time',
                label: 'Contract End Date',
                property: 'contractEndDate',
                width: 250,
                sortable: true,
                sortProperty: 'ContractEndDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'billingAddress',
                type: 'string',
                label: 'Billing Address',
                property: 'billingAddress',
                width: 400,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
        ];
    },

    getCompanyFilesHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'company-file-name',
                label: 'Filename',
                property: 'companyFile',
                width: 350,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Uploaded On',
                property: 'createdAt',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'updated',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 250,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'file-size',
                type: 'file-size',
                label: 'File Size',
                property: 'fileSizeInBytes',
                width: 200,
                sortable: true,
                sortProperty: 'FileSizeInBytes',
                editable: false,
                filterable: false,
            },
            {
                key: 'file-type',
                type: 'file-type',
                label: 'File Type',
                property: 'fileType',
                width: 150,
                sortable: true,
                sortProperty: 'FileType',
                editable: false,
                filterable: true,
            },
            {
                key: 'uploaded-by',
                type: 'user',
                label: 'Uploaded By',
                property: 'uploadedByUser',
                width: 200,
                sortable: true,
                sortProperty: 'UploadedByUser/LastName',
                editable: false,
                filterable: true,
            },
        ];
    },

    getListHeaderDefinitions() {
        return [
            {
                key: 'leads',
                type: 'list-lead',
                label: 'Leads',
                property: 'list',
                width: 100,
                sortable: false,
                sortProperty: 'IsMarketable',
                editable: true,
                filterable: true,
            },
            {
                key: 'name',
                type: 'list',
                label: 'Name',
                property: 'list',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: true,
            },
            {
                key: 'contacts',
                type: 'number',
                label: 'Contacts',
                property: 'contacts',
                width: 150,
                sortable: true,
                sortProperty: 'SubscriberCount',
                editable: false,
                filterable: true,
            },
            {
                key: 'qualifiedLeads',
                type: 'number',
                label: 'Qualified Leads',
                property: 'qualifiedLeads',
                width: 150,
                sortable: true,
                sortProperty: 'Leads',
                editable: false,
                filterable: true,
            },
            {
                key: 'wins',
                type: 'number',
                label: 'Wins',
                property: 'wins',
                width: 100,
                sortable: true,
                sortProperty: 'Wins',
                editable: false,
                filterable: true,
            },
            {
                key: 'date',
                type: 'date',
                label: 'Date Added',
                property: 'date',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'bounced',
                type: 'number',
                label: 'Bounced',
                property: 'bounced',
                width: 150,
                sortable: false,
                sortProperty: 'BouncedCount',
                editable: false,
                filterable: false,
            },
            {
                key: 'unsubscribed',
                type: 'number',
                label: 'Unsubscribed',
                property: 'unsubscribed',
                width: 150,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'active',
                type: 'number',
                label: 'Active',
                property: 'active',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ];
    },

    getClientTopPerformersHeaderDefinitions() {
        return [
            {
                key: 'clientName',
                type: 'client-name',
                label: 'Name',
                property: 'client',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },

            {
                key: 'leads',
                type: 'number',
                label: 'Qualified Leads',
                property: 'leadCount',
                width: 200,
                sortable: true,
                sortProperty: 'Leads',
                editable: false,
                filterable: false,
            },

            {
                key: 'opportunities',
                type: 'number',
                label: 'Opportunities',
                property: 'opportunityCount',
                width: 150,
                sortable: true,
                sortProperty: 'Opportunities',
                editable: false,
                filterable: false,
            },

            {
                key: 'wins',
                type: 'number',
                label: 'Wins',
                property: 'winCount',
                width: 150,
                sortable: true,
                sortProperty: 'Wins',
                editable: false,
                filterable: false,
            },

            {
                key: 'clientRevenue',
                type: 'currency',
                label: 'Revenue',
                property: 'revenue',
                width: 150,
                sortable: true,
                sortProperty: 'Revenue',
                editable: false,
                filterable: false,
            },
        ];
    },

    getTopPerformersHeaderDefinitions() {
        return [
            {
                key: 'salesperson',
                type: 'salesperson',
                label: 'Name',
                property: 'salesperson',
                width: 300,
                sortable: true,
                sortProperty: 'LastName',
                editable: false,
                filterable: false,
            },

            {
                key: 'rank',
                type: 'ranking',
                label: 'Rank',
                property: 'rank',
                width: 150,
                sortable: true,
                sortProperty: 'Rank',
                editable: false,
                filterable: false,
            },

            {
                key: 'assigned',
                type: 'number',
                label: 'Assigned',
                property: 'assigned',
                width: 150,
                sortable: true,
                sortProperty: 'Assigned',
                editable: false,
                filterable: false,
            },

            {
                key: 'activities',
                type: 'number',
                label: 'Activities',
                property: 'activities',
                width: 150,
                sortable: true,
                sortProperty: 'Activities',
                editable: false,
                filterable: false,
            },

            {
                key: 'meetings',
                type: 'number',
                label: 'Meetings',
                property: 'meetings',
                width: 150,
                sortable: true,
                sortProperty: 'Meetings',
                editable: false,
                filterable: false,
            },

            {
                key: 'opportunities',
                type: 'number',
                label: 'Opportunities',
                property: 'opportunities',
                width: 150,
                sortable: true,
                sortProperty: 'Deals',
                editable: false,
                filterable: false,
            },

            {
                key: 'wins',
                type: 'number',
                label: 'Wins',
                property: 'wins',
                width: 150,
                sortable: true,
                sortProperty: 'Wins',
                editable: false,
                filterable: false,
            },

            {
                key: 'revenue',
                type: 'currency',
                label: 'Revenue',
                property: 'revenue',
                width: 200,
                sortable: true,
                sortProperty: 'Revenue',
                editable: false,
                filterable: false,
            },
        ];
    },

    getSalesTeamHeaderDefinitions() {
        return [
            {
                key: 'salesperson',
                type: 'salesperson',
                label: 'Name',
                property: 'salesperson',
                width: 300,
                sortable: true,
                sortProperty: 'LastName',
                editable: false,
                filterable: false,
            },

            {
                key: 'rank',
                type: 'number',
                label: 'Rank',
                property: 'rank',
                width: 150,
                sortable: true,
                sortProperty: 'Rank',
                editable: false,
                filterable: false,
            },

            {
                key: 'assigned',
                type: 'number',
                label: 'Assigned',
                property: 'assigned',
                width: 150,
                sortable: true,
                sortProperty: 'Assigned',
                editable: false,
                filterable: false,
            },

            {
                key: 'activities',
                type: 'number',
                label: 'Activities',
                property: 'activities',
                width: 150,
                sortable: true,
                sortProperty: 'Activities',
                editable: false,
                filterable: false,
            },

            {
                key: 'meetings',
                type: 'number',
                label: 'Meetings',
                property: 'meetings',
                width: 150,
                sortable: true,
                sortProperty: 'Meetings',
                editable: false,
                filterable: false,
            },

            {
                key: 'opportunities',
                type: 'number',
                label: 'Opportunities',
                property: 'opportunities',
                width: 150,
                sortable: true,
                sortProperty: 'Deals',
                editable: false,
                filterable: false,
            },

            {
                key: 'wins',
                type: 'number',
                label: 'Wins',
                property: 'wins',
                width: 150,
                sortable: true,
                sortProperty: 'Wins',
                editable: false,
                filterable: false,
            },

            {
                key: 'revenue',
                type: 'currency',
                label: 'Revenue',
                property: 'revenue',
                width: 200,
                sortable: true,
                sortProperty: 'Revenue',
                editable: false,
                filterable: false,
            }
        ]
    },

    getIndividualQuotasHeaderDefinitions(){
        return [
            {
                key: 'salesperson',
                type: 'salesperson',
                label: 'Name',
                property: 'salesperson',
                width: 300,
                sortable: true,
                sortProperty: 'LastName',
                editable: false,
                filterable: false,
            },
            {
                key: 'grossRevenue',
                type: 'currency',
                label: 'Gross Revenue',
                property: 'monthlyRevenueQuota',
                width: 200,
                sortable: true,
                sortProperty: 'MonthlyRevenueQuota',
                editable: false,
                filterable: false,
            },
            {
                key: 'grossMargin',
                type: 'currency',
                label: 'Gross Margin',
                property: 'monthlyMarginQuota',
                width: 200,
                sortable: true,
                sortProperty: 'MonthlyMarginQuota',
                editable: false,
                filterable: false,
            },
            {
                key: 'monthlyRecurrentRevenue',
                type: 'currency',
                label: 'MRR',
                property: 'monthlyMrrQuota',
                width: 200,
                sortable: true,
                sortProperty: 'MonthlyMrrQuota',
                editable: false,
                filterable: false,
            },
            {
                key: 'calls',
                type: 'number',
                label: 'Calls',
                property: 'callQuota',
                width: 125,
                sortable: true,
                sortProperty: 'CallQuota',
                editable: false,
                filterable: false,
            },
            {
                key: 'emails',
                type: 'number',
                label: 'Emails',
                property: 'emailQuota',
                width: 125,
                sortable: true,
                sortProperty: 'EmailQuota',
                editable: false,
                filterable: false,
            },
            {
                key: 'meetings',
                type: 'number',
                label: 'Meetings',
                property: 'meetingQuota',
                width: 125,
                sortable: true,
                sortProperty: 'MeetingQuota',
                editable: false,
                filterable: false,
            },
            {
                key: 'opportunities',
                type: 'number',
                label: 'Opportunities',
                property: 'opportunityQuota',
                width: 150,
                sortable: true,
                sortProperty: 'OpportunityQuota',
                editable: false,
                filterable: false,
            },
            {
                key: 'wins',
                type: 'number',
                label: 'Wins',
                property: 'winQuota',
                width: 125,
                sortable: true,
                sortProperty: 'WinQuota',
                editable: false,
                filterable: false,
            },
        ]
    },

    getCampaignHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'campaign',
                label: 'Name',
                property: 'campaign',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'modified',
                type: 'date-time',
                label: 'Last Modified',
                property: 'lastModifiedDate',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'status',
                type: 'campaign-status',
                label: 'Status',
                property: 'status',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'marketingPlan',
                type: 'link',
                label: 'Marketing Plan',
                property: 'marketingPlan',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Created',
                property: 'createDate',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'recipients',
                type: 'number',
                label: 'Recipients',
                property: 'recipients',
                width: 200,
                sortable: true,
                sortProperty: 'TotalRecipients',
                editable: false,
                filterable: false,
            },
            {
                key: 'scheduledDateTime',
                type: 'campaign-scheduled-date',
                label: 'Scheduled Date/Time',
                property: 'scheduledDate',
                width: 200,
                sortable: true,
                sortProperty: 'ScheduledSendDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'stepsCompleted',
                type: 'steps-completed',
                label: 'Steps Completed',
                property: 'steps',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'sentDate',
                type: 'date-time',
                label: 'Sent Date',
                property: 'sentDate',
                width: 200,
                sortable: true,
                sortProperty: 'DateSent',
                editable: false,
                filterable: false,
            },
            {
                key: 'opened',
                type: 'completion',
                label: 'Opened',
                property: 'openRate',
                width: 200,
                sortable: true,
                sortProperty: 'OpenRate',
                editable: false,
                filterable: false,
            },
            {
                key: 'clicked',
                type: 'completion',
                label: 'Clicked',
                property: 'clickRate',
                width: 200,
                sortable: true,
                sortProperty: 'ClickRate',
                editable: false,
                filterable: false,
            },
            {
                key: 'unsubscribes',
                type: 'campaign-unsubscribed',
                label: 'Unsubscribes',
                property: 'campaign',
                width: 200,
                sortable: true,
                sortProperty: 'TotalUnsubscribes',
                editable: false,
                filterable: false,
            },
            {
                key: 'abTestStartDate',
                type: 'date-time',
                label: 'AB Test Started On',
                property: 'abScheduledDate',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'abTestEndDate',
                type: 'date-time',
                label: 'AB Test Ending On',
                property: 'abTestDateEnd',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ];
    },

    getCampaignSentHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'campaign',
                label: 'Name',
                property: 'campaign',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'marketingPlan',
                type: 'link',
                label: 'Marketing Plan',
                property: 'marketingPlan',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'sentDate',
                type: 'date-time',
                label: 'Sent Date',
                property: 'sentDate',
                width: 200,
                sortable: true,
                sortProperty: 'DateSent',
                editable: false,
                filterable: false,
            },
            {
                key: 'recipients',
                type: 'number',
                label: 'Recipients',
                property: 'recipients',
                width: 200,
                sortable: true,
                sortProperty: 'TotalRecipients',
                editable: false,
                filterable: false,
            },
            {
                key: 'opened',
                type: 'completion',
                label: 'Opened',
                property: 'openRate',
                width: 200,
                sortable: true,
                sortProperty: 'OpenRate',
                editable: false,
                filterable: false,
            },
            {
                key: 'clicked',
                type: 'completion',
                label: 'Clicked',
                property: 'clickRate',
                width: 200,
                sortable: true,
                sortProperty: 'ClickRate',
                editable: false,
                filterable: false,
            },
            {
                key: 'uniqueOpens',
                type: 'number',
                label: 'Unique Opens',
                property: 'uniqueOpens',
                width: 200,
                sortable: true,
                sortProperty: 'TotalUniqueOpens',
                editable: false,
                filterable: false,
            },
            {
                key: 'uniqueClicks',
                type: 'number',
                label: 'Unique Clicks',
                property: 'uniqueClicks',
                width: 200,
                sortable: true,
                sortProperty: 'TotalClicks',
                editable: false,
                filterable: false,
            },
            {
                key: 'unopened',
                type: 'number',
                label: 'Not Opened',
                property: 'unopened',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'bounces',
                type: 'number',
                label: 'Bounces',
                property: 'bounces',
                width: 200,
                sortable: true,
                sortProperty: 'Bounces',
                editable: false,
                filterable: false,
            },
            {
                key: 'unsubscribes',
                type: 'number',
                label: 'Unsubscribes',
                property: 'unsubscribes',
                width: 200,
                sortable: true,
                sortProperty: 'TotalUnsubscribes',
                editable: false,
                filterable: false,
            },
        ];
    },

    getCampaignDraftHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'campaign',
                label: 'Name',
                property: 'campaign',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Created',
                property: 'createDate',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'marketingPlan',
                type: 'link',
                label: 'Marketing Plan',
                property: 'marketingPlan',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'stepsCompleted',
                type: 'steps-completed',
                label: 'Steps Completed',
                property: 'steps',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ];
    },

    getCampaignScheduledHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'campaign',
                label: 'Name',
                property: 'campaign',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'marketingPlan',
                type: 'link',
                label: 'Marketing Plan',
                property: 'marketingPlan',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'recipients',
                type: 'number',
                label: 'Recipients',
                property: 'recipients',
                width: 120,
                sortable: true,
                sortProperty: 'TotalRecipients',
                editable: false,
                filterable: false,
            },
            {
                key: 'scheduledDateTime',
                type: 'campaign-scheduled-date',
                label: 'Scheduled Date/Time',
                property: 'scheduledDate',
                width: 200,
                sortable: true,
                sortProperty: 'ScheduledSendDate',
                editable: false,
                filterable: false,
            },
        ];
    },

    getCampaignABHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'campaign',
                label: 'Name',
                property: 'campaign',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'marketingPlan',
                type: 'link',
                label: 'Marketing Plan',
                property: 'marketingPlan',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'recipients',
                type: 'number',
                label: 'Recipients',
                property: 'recipients',
                width: 120,
                sortable: true,
                sortProperty: 'TotalRecipients',
                editable: false,
                filterable: false,
            },
            {
                key: 'abStartDate',
                type: 'date-time',
                label: 'Started On',
                property: 'abScheduledDate',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'abEndDate',
                type: 'date-time',
                label: 'Ending On',
                property: 'abTestDateEnd',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ];
    },

    getOpportunityHeaderDefinitions() {
        return [
            {
                key: 'company',
                type: 'contact-company',
                label: 'Company',
                property: 'company',
                width: 300,
                sortable: true,
                sortProperty: 'Contact/Company/Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'primary-contact',
                type: 'opportunity-contact',
                label: 'Primary Contact',
                property: 'primaryContact',
                width: 300,
                sortable: true,
                sortProperty: 'Contact/LastName',
                editable: true,
                filterable: false,
            },
            {
                key: 'secondary-contacts',
                type: 'opportunity-multi-contacts',
                label: 'Secondary Contacts',
                property: 'secondaryContacts',
                width: 300,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'opportunity-name',
                type: 'opportunity-name',
                label: 'Opportunity Name',
                property: 'opportunity',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'status',
                type: 'opportunity-status',
                label: 'Stage',
                property: 'dealStatus',
                width: 300,
                sortable: true,
                sortProperty: 'DealStatus/Name',
                editable: true,
                filterable: true,
            },
            {
                key: 'opportunity-type',
                type: 'opportunity-type',
                label: 'Type',
                property: 'dealType',
                width: 300,
                sortable: true,
                sortProperty: 'DealType/Name',
                editable: true,
                filterable: true,
            },
            {
                key: 'total-amount',
                type: 'currency',
                label: 'Total Amount',
                property: 'totalAmount',
                width: 200,
                sortable: true,
                sortProperty: 'LifetimeValue',
                editable: false,
                filterable: true,
            },
            {
                key: 'gross-margin',
                type: 'opportunity-gross-margin',
                label: 'Gross Margin',
                property: 'grossMargin',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'approval-status',
                type: 'opportunity-approval-status',
                label: 'Approval Status',
                property: 'status',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'date-opened',
                type: 'date',
                label: 'Date Opened',
                property: 'dateOpened',
                width: 150,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'date-closed',
                type: 'opportunity-date-closed',
                label: 'Date Closed',
                property: 'dateClosed',
                width: 150,
                sortable: true,
                sortProperty: 'CloseDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'days-open',
                type: 'opportunity-days-open',
                label: 'Days Open',
                property: 'daysOpen',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'assigned-salesperson',
                type: 'opportunity-multi-salesperson',
                label: 'Salesperson',
                property: 'salespersons',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'details',
                type: 'opportunity-details',
                label: 'Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'activities',
                type: 'opportunity-activities',
                label: 'Activities',
                property: 'id',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },{
                key: 'registered-deals',
                type: 'opportunity-registered-deals',
                label: 'Registered Deals',
                property: 'id',
                width: 300,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ]
    },

    getOpportunityReportHeaderDefinition() {
        return [
            {
                key: 'company',
                type: 'contact-company',
                label: 'Company',
                property: 'company',
                width: 300,
                sortable: true,
                sortProperty: 'Contact/Company/Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'primary-contact',
                type: 'opportunity-contact',
                label: 'Primary Contact',
                property: 'primaryContact',
                width: 300,
                sortable: true,
                sortProperty: 'Contact/LastName',
                editable: true,
                filterable: false,
            },
            {
                key: 'secondary-contacts',
                type: 'opportunity-multi-contacts',
                label: 'Secondary Contacts',
                property: 'secondaryContacts',
                width: 300,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'opportunity-name',
                type: 'opportunity-name',
                label: 'Opportunity Name',
                property: 'opportunity',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'status',
                type: 'opportunity-status',
                label: 'Stage',
                property: 'dealStatus',
                width: 300,
                sortable: true,
                sortProperty: 'DealStatus/Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'opportunity-type',
                type: 'opportunity-type',
                label: 'Type',
                property: 'dealType',
                width: 300,
                sortable: true,
                sortProperty: 'DealType/Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'total-amount',
                type: 'currency',
                label: 'Total Amount',
                property: 'totalAmount',
                width: 200,
                sortable: true,
                sortProperty: 'LifetimeValue',
                editable: false,
                filterable: true,
            },
            {
                key: 'gross-margin',
                type: 'opportunity-gross-margin',
                label: 'Gross Margin',
                property: 'grossMargin',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'approval-status',
                type: 'opportunity-approval-status',
                label: 'Status',
                property: 'status',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'date-opened',
                type: 'date',
                label: 'Date Opened',
                property: 'dateOpened',
                width: 150,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'date-closed',
                type: 'opportunity-date-closed',
                label: 'Date Closed',
                property: 'dateClosed',
                width: 150,
                sortable: true,
                sortProperty: 'CloseDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'days-open',
                type: 'opportunity-days-open',
                label: 'Days Open',
                property: 'daysOpen',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'assigned-salesperson',
                type: 'opportunity-multi-salesperson',
                label: 'Salesperson',
                property: 'salespersons',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ]
    },

    getLineItemsHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'line-item-name',
                label: 'Name',
                property: 'name',
                width: 220,
                sortable: false,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'sku',
                type: 'string',
                label: 'SKU',
                property: 'sku',
                width: 150,
                sortable: false,
                sortProperty: 'Sku',
                editable: false,
                filterable: false,
            },
            {
                key: 'quantity',
                type: 'numeric-input',
                label: 'Quantity',
                property: 'qty',
                width: 125,
                sortable: false,
                sortProperty: 'Quantity',
                editable: true,
                filterable: false,
            },
            {
                key: 'unit-price',
                type: 'numeric-input',
                label: 'Unit Price',
                property: 'unitPrice',
                width: 150,
                sortable: false,
                sortProperty: 'UnitPrice',
                editable: true,
                filterable: false,
            },
            {
                key: 'unit-cost',
                type: 'numeric-input',
                label: 'Unit Cost',
                property: 'unitCost',
                width: 150,
                sortable: false,
                sortProperty: 'UnitCost',
                editable: true,
                filterable: false,
            },
            {
                key: 'unit-discount',
                type: 'numeric-input',
                label: 'Unit Discount',
                property: 'unitDiscount',
                width: 150,
                sortable: false,
                sortProperty: 'UnitDiscount',
                editable: true,
                filterable: false,
            },
            {
                key: 'billing-cycle',
                type: 'billing-cycle',
                label: 'Billing Cycle',
                property: 'billingCycle',
                width: 200,
                sortable: false,
                sortProperty: 'BillingCycle',
                editable: true,
                filterable: false,
            },
            {
                key: 'term-in-months',
                type: 'term-in-months',
                label: 'Term in months',
                property: 'termInMonths',
                width: 150,
                sortable: false,
                sortProperty: 'TermInMonths',
                editable: true,
                filterable: false,
            },
            {
                key: 'total-margin',
                type: 'currency',
                label: 'Margin',
                property: 'totalMargin',
                width: 150,
                sortable: false,
                sortProperty: 'TotalMargin',
                editable: false,
                filterable: false,
            },
            {
                key: 'created',
                type: 'full-date-time',
                label: 'Created At',
                property: 'createdAt',
                width: 300,
                sortable: false,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'updated',
                type: 'full-date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 300,
                sortable: false,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            }
        ]
    },

    getScheduledEmailHeaderDefinitions() {
        return [
            {
                key: 'schedule-date',
                type: 'date-time',
                label: 'Scheduled Date',
                property: 'scheduledDate',
                width: 200,
                sortable: true,
                sortProperty: 'SendDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'from',
                type: 'user',
                label: 'From',
                property: 'user',
                width: 200,
                sortable: true,
                sortProperty: 'FromName',
                editable: false,
                filterable: false,
            },
            {
                key: 'participants',
                type: 'participants-name',
                label: 'Participants',
                property: 'participants',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'subject',
                type: 'string',
                label: 'Subject',
                property: 'subject',
                width: 200,
                sortable: true,
                sortProperty: 'Subject',
                editable: false,
                filterable: false,
            },
        ];
    },

    getSubscriptionPlanHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'string',
                label: 'Name',
                property: 'name',
                width: 200,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'basePrice',
                type: 'currency',
                label: 'Base Price',
                property: 'basePrice',
                width: 200,
                sortable: true,
                sortProperty: 'BasePrice',
                editable: false,
                filterable: false,
            },
            {
                key: 'userPrice',
                type: 'currency',
                label: 'User Price',
                property: 'userPrice',
                width: 200,
                sortable: true,
                sortProperty: 'UserPrice',
                editable: false,
                filterable: false,
            },
            {
                key: 'billingCycle',
                type: 'number',
                label: 'Billing Cycle Month',
                property: 'billingCycle',
                width: 200,
                sortable: true,
                sortProperty: 'BillingCycle',
                editable: false,
                filterable: false,
            },
            {
                key: 'maxContacts',
                type: 'number',
                label: 'Max Contacts',
                property: 'contactLimit',
                width: 200,
                sortable: true,
                sortProperty: 'ContactLimit',
                editable: false,
                filterable: false,
            },
            {
                key: 'clients',
                type: 'number',
                label: 'Clients',
                property: 'clientCount',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ];
    },

    getAllUserHeaderDefinitions() {
        return [
            {
                key: 'email',
                type: 'user-email',
                label: 'Email',
                property: 'user',
                width: 300,
                sortable: true,
                sortProperty: 'Email',
                editable: false,
                filterable: false,
            },
            {
                key: 'name',
                type: 'user',
                label: 'Name',
                property: 'user',
                width: 300,
                sortable: true,
                sortProperty: 'LastName',
                editable: false,
                filterable: false,
            },
            {
                key: 'title',
                type: 'user-title',
                label: 'Title',
                property: 'user',
                width: 200,
                sortable: true,
                sortProperty: 'Title',
                editable: false,
                filterable: false,
            },
            {
                key: 'account-name',
                type: 'account-name',
                label: 'Account',
                property: 'account',
                width: 300,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'account-type',
                type: 'string',
                label: 'Account Type',
                property: 'type',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'status',
                type: 'user-status',
                label: 'Status',
                property: 'status',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'created',
                type: 'date-time',
                label: 'Created At',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
        ];
    },

    getUserHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'user',
                label: 'Name',
                property: 'user',
                width: 300,
                sortable: true,
                sortProperty: 'LastName',
                editable: true,
                filterable: false,
            },
            {
                key: 'title',
                type: 'user-title',
                label: 'Title',
                property: 'user',
                width: 200,
                sortable: true,
                sortProperty: 'Title',
                editable: true,
                filterable: false,
            },
            {
                key: 'email',
                type: 'user-email',
                label: 'Email',
                property: 'user',
                width: 300,
                sortable: true,
                sortProperty: 'Email',
                editable: true,
                filterable: false,
            },
            {
                key: 'status',
                type: 'user-status',
                label: 'Status',
                property: 'status',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'last-session',
                type: 'full-date-time',
                label: 'Last Session',
                property: 'lastSession',
                width: 275,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ];
    },

    getDkimIntegrationHeaderDefinitions() {
        return [
            {
                key: 'domain',
                type: 'dkim-domain',
                label: 'Domain',
                property: 'dkimIntegration',
                width: 300,
                sortable: true,
                sortProperty: 'DkimDomain',
                editable: false,
                filterable: false,
            },
            {
                key: 'dkim',
                type: 'authenticated',
                label: 'DKIM',
                property: 'authenticated',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'spf',
                type: 'authenticated',
                label: 'SPF',
                property: 'authenticated',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ];
    },

    getLinkBrandingHeaderDefinitions() {
        return [
            {
                key: 'whitelabel',
                type: 'link-branding',
                label: 'Whitelabel',
                property: 'branding',
                width: 300,
                sortable: true,
                sortProperty: 'Domain',
                editable: false,
                filterable: false,
            },
            {
                key: 'validated',
                type: 'authenticated',
                label: 'Validated',
                property: 'valid',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ];
    },

    getContactStatusHeaderDefinitions() {
        return [
            {
                key: 'color',
                type: 'status-color',
                label: 'Color',
                property: 'contactStatus',
                width: 150,
                sortable: false,
                sortProperty: 'Color',
                editable: true,
                filterable: false,
            },
            {
                key: 'name',
                type: 'contact-status-name',
                label: 'Name',
                property: 'contactStatus',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
        ];
    },

    getOpportunityTypeHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'opportunity-type-name',
                label: 'Name',
                property: 'opportunityType',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
        ];
    },

    getOpportunityStagesHeaderDefinitions() {
        return [
            {
                key: 'order',
                type: 'number',
                label: 'Order',
                property: 'order',
                width: 115,
                sortable: true,
                sortProperty: 'Order',
                editable: false,
                filterable: false,
            },
            {
                key: 'status',
                type: 'string',
                label: 'Status',
                property: 'status',
                width: 275,
                sortable: true,
                sortProperty: 'IsWon',
                editable: false,
                filterable: false,
            },
            {
                key: 'color',
                type: 'opportunity-status-color',
                label: 'Color',
                property: 'opportunityStatus',
                width: 225,
                sortable: false,
                sortProperty: 'Color',
                editable: true,
                filterable: false,
            },
            {
                key: 'name',
                type: 'opportunity-status-name',
                label: 'Stage Name',
                property: 'opportunityStatus',
                width: 640,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'probability',
                type: 'string',
                label: 'Probability',
                property: 'probability',
                width: 185,
                sortable: true,
                sortProperty: 'Probability',
                editable: false,
                filterable: false,
            },
            
        ];
    },

    getOpportunityStatusHeaderDefinitions() {
        return [
            {
                key: 'color',
                type: 'opportunity-status-color',
                label: 'Color',
                property: 'opportunityStatus',
                width: 150,
                sortable: false,
                sortProperty: 'Color',
                editable: true,
                filterable: false,
            },
            {
                key: 'name',
                type: 'opportunity-status-name',
                label: 'Name',
                property: 'opportunityStatus',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'status',
                type: 'opportunity-status-status',
                label: 'Status',
                property: 'status',
                width: 200,
                sortable: true,
                sortProperty: 'IsWon',
                editable: true,
                filterable: false,
            },
        ];
    },

    getMeetingsHeaderDefinitions(){
        return [
            {
                key: 'activityDate',
                type: 'date-time',
                label: 'Meeting Date',
                property: 'activityDate',
                width: 225,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'multiple-salesperson',
                type: 'multiple-salesperson',
                label: 'Participants',
                property: 'participants',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'meetingSubject',
                type: 'string',
                label: 'Subject',
                property: 'meetingSubject',
                width: 300,
                sortable: true,
                sortProperty: 'MeetingSubject',
                editable: false,
                filterable: false,
            },
            {
                key: 'meetingLocation',
                type: 'string',
                label: 'Location',
                property: 'meetingLocation',
                width: 300,
                sortable: true,
                sortProperty: 'MeetingLocation',
                editable: false,
                filterable: false,
            },
            {
                key: 'meetingStatus',
                type: 'string',
                label: 'Meeting Status',
                property: 'meetingStatus',
                width: 300,
                sortable: true,
                sortProperty: 'MeetingStatus',
                editable: false,
                filterable: false,
            },

        ];
    },

    getCompanyTypeHeaderDefinitions(){
        return [
            {
                key: 'color',
                type: 'company-type-color',
                label: 'Color',
                property: 'companyType',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'name',
                type: 'company-type-name',
                label: 'Name',
                property: 'companyType',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
        ];
    },

    getServiceHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'service',
                label: 'Name',
                property: 'service',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'billingType',
                type: 'string',
                label: 'Billing Type',
                property: 'serviceBillingType',
                width: 300,
                sortable: true,
                sortProperty: 'ServiceBillingType',
                editable: false,
                filterable: false,
            },
            {
                key: 'billingCycle',
                type: 'string',
                label: 'Billing Cycle',
                property: 'billingCycle',
                width: 300,
                sortable: true,
                sortProperty: 'BillingCycle',
                editable: false,
                filterable: false,
            },
            {
                key: 'price',
                type: 'currency',
                label: 'Price',
                property: 'price',
                width: 300,
                sortable: true,
                sortProperty: 'Price',
                editable: false,
                filterable: false,
            },
        ];
    },
    
    getSolutionHeaderDefinitions() {
        return [
            { 
                key: 'name',
                type: 'solution-name',
                label: 'Name',
                property: 'name',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'sku',
                type: 'string',
                label: 'Sku',
                property: 'sku',
                width: 150,
                sortable: true,
                sortProperty: 'Sku',
                editable: false,
                filterable: false,
            },
            {
                key: 'unitPrice',
                type: 'currency',
                label: 'Unit Price',
                property: 'unitPrice',
                width: 150,
                sortable: true,
                sortProperty: 'UnitPrice',
                editable: false,
                filterable: false,
            },
            {
                key: 'unitCost',
                type: 'currency',
                label: 'Unit Cost',
                property: 'unitCost',
                width: 150,
                sortable: true,
                sortProperty: 'UnitCost',
                editable: false,
                filterable: false,
            },
            {
                key: 'unitMargin',
                type: 'currency',
                label: 'Unit Margin',
                property: 'unitMargin',
                width: 150,
                sortable: true,
                sortProperty: 'UnitMargin',
                editable: false,
                filterable: false,
            },
            {
                key: 'billingCycle',
                type: 'string',
                label: 'Billing Cycle',
                property: 'billingCycle',
                width: 150,
                sortable: false,
                sortProperty: 'BillingCycle',
                editable: false,
                filterable: false,
            },
            {
                key: 'billingType',
                type: 'string',
                label: 'Billing Type',
                property: 'billingType',
                width: 150,
                sortable: false,
                sortProperty: 'BillingType',
                editable: false,
                filterable: false,
            },
            {
                key: 'solutionType',
                type: 'string',
                label: 'Product Type',
                property: 'solutionType',
                width: 150,
                sortable: false,
                sortProperty: 'SolutionType',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created',
                property: 'createdAt',
                width: 275,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Date Modified',
                property: 'updatedAt',
                width: 275,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ]
    },

    getSolutionSharedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'solution-name',
                label: 'Name',
                property: 'name',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'vendor',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'vendor',
                width: 280,
                sortable: true,
                sortProperty: 'Account/Agency/Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'sku',
                type: 'string',
                label: 'Sku',
                property: 'sku',
                width: 150,
                sortable: true,
                sortProperty: 'Sku',
                editable: false,
                filterable: false,
            },
            {
                key: 'unitPrice',
                type: 'currency',
                label: 'Unit Price',
                property: 'unitPrice',
                width: 150,
                sortable: true,
                sortProperty: 'UnitPrice',
                editable: false,
                filterable: false,
            },
            {
                key: 'unitCost',
                type: 'currency',
                label: 'Unit Cost',
                property: 'unitCost',
                width: 150,
                sortable: true,
                sortProperty: 'UnitCost',
                editable: false,
                filterable: false,
            },
            {
                key: 'unitMargin',
                type: 'currency',
                label: 'Unit Margin',
                property: 'unitMargin',
                width: 150,
                sortable: true,
                sortProperty: 'UnitMargin',
                editable: false,
                filterable: false,
            },
            {
                key: 'billingCycle',
                type: 'string',
                label: 'Billing Cycle',
                property: 'billingCycle',
                width: 150,
                sortable: false,
                sortProperty: 'BillingCycle',
                editable: false,
                filterable: false,
            },
            {
                key: 'billingType',
                type: 'string',
                label: 'Billing Type',
                property: 'billingType',
                width: 150,
                sortable: false,
                sortProperty: 'BillingType',
                editable: false,
                filterable: false,
            },
            {
                key: 'solutionType',
                type: 'string',
                label: 'Product Type',
                property: 'solutionType',
                width: 150,
                sortable: false,
                sortProperty: 'SolutionType',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created',
                property: 'createdAt',
                width: 275,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Date Modified',
                property: 'updatedAt',
                width: 275,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ]
    },

    getSolutionAgencyPublishedHeaderDefinitions(){
        return [
            {
                key: 'name',
                type: 'solution-name',
                label: 'Name',
                property: 'name',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'clientsPublished',
                type: 'client-published',
                label: 'Partners Published To',
                property: 'asset',
                width: 120,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'autoPublished',
                width: 160,
                sortable: true,
                sortProperty: 'IsAutoPublished',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'sku',
                type: 'string',
                label: 'Sku',
                property: 'sku',
                width: 150,
                sortable: true,
                sortProperty: 'Sku',
                editable: false,
                filterable: false,
            },
            {
                key: 'unitPrice',
                type: 'currency',
                label: 'Unit Price',
                property: 'unitPrice',
                width: 150,
                sortable: true,
                sortProperty: 'UnitPrice',
                editable: false,
                filterable: false,
            },
            {
                key: 'unitCost',
                type: 'currency',
                label: 'Unit Cost',
                property: 'unitCost',
                width: 150,
                sortable: true,
                sortProperty: 'UnitCost',
                editable: false,
                filterable: false,
            },
            {
                key: 'unitMargin',
                type: 'currency',
                label: 'Unit Margin',
                property: 'unitMargin',
                width: 150,
                sortable: true,
                sortProperty: 'UnitMargin',
                editable: false,
                filterable: false,
            },
            {
                key: 'billingCycle',
                type: 'string',
                label: 'Billing Cycle',
                property: 'billingCycle',
                width: 150,
                sortable: false,
                sortProperty: 'BillingCycle',
                editable: false,
                filterable: false,
            },
            {
                key: 'billingType',
                type: 'string',
                label: 'Billing Type',
                property: 'billingType',
                width: 150,
                sortable: false,
                sortProperty: 'BillingType',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 280,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'publishedDate',
                type: 'full-date-time',
                label: 'Published Date',
                property: 'publishedAt',
                width: 280,
                sortable: true,
                sortProperty: 'PublishedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 275,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'solutionType',
                type: 'string',
                label: 'Product Type',
                property: 'solutionType',
                width: 150,
                sortable: false,
                sortProperty: 'SolutionType',
                editable: false,
                filterable: false,
            }
        ]
    },

    getSolutionAgencyUnpublishedHeaderDefinitions(){
        return [
            {
                key: 'name',
                type: 'solution-name',
                label: 'Name',
                property: 'name',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'autoPublished',
                width: 160,
                sortable: true,
                sortProperty: 'IsAutoPublished',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'sku',
                type: 'string',
                label: 'Sku',
                property: 'sku',
                width: 150,
                sortable: true,
                sortProperty: 'Sku',
                editable: false,
                filterable: false,
            },
            {
                key: 'unitPrice',
                type: 'currency',
                label: 'Unit Price',
                property: 'unitPrice',
                width: 150,
                sortable: true,
                sortProperty: 'UnitPrice',
                editable: false,
                filterable: false,
            },
            {
                key: 'unitCost',
                type: 'currency',
                label: 'Unit Cost',
                property: 'unitCost',
                width: 150,
                sortable: true,
                sortProperty: 'UnitCost',
                editable: false,
                filterable: false,
            },
            {
                key: 'unitMargin',
                type: 'currency',
                label: 'Unit Margin',
                property: 'unitMargin',
                width: 150,
                sortable: true,
                sortProperty: 'UnitMargin',
                editable: false,
                filterable: false,
            },
            {
                key: 'billingCycle',
                type: 'string',
                label: 'Billing Cycle',
                property: 'billingCycle',
                width: 150,
                sortable: false,
                sortProperty: 'BillingCycle',
                editable: false,
                filterable: false,
            },
            {
                key: 'billingType',
                type: 'string',
                label: 'Billing Type',
                property: 'billingType',
                width: 150,
                sortable: false,
                sortProperty: 'BillingType',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 280,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 275,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'solutionType',
                type: 'string',
                label: 'Product Type',
                property: 'solutionType',
                width: 150,
                sortable: false,
                sortProperty: 'SolutionType',
                editable: false,
                filterable: false,
            }
        ]
    },

    getContactPartnerLeadHeaderDefinitions() {
        return [
            {
                key: 'partner',
                type: 'client-name',
                label: 'Partner',
                property: 'partner',
                width: 300,
                sortable: true,
                sortProperty: 'Client/Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'name',
                type: 'contact',
                label: 'Name',
                property: 'contact',
                width: 300,
                sortable: true,
                sortProperty: 'LastName',
                editable: true,
                filterable: false,
            },
            {
                key: 'company',
                type: 'contact-company',
                label: 'Company',
                property: 'company',
                width: 300,
                sortable: true,
                sortProperty: 'Company/Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'employees',
                type: 'company-employees',
                label: 'Employees',
                property: 'company',
                width: 150,
                sortable: true,
                sortProperty: 'Company/ApproximateEmployeeCount',
                editable: true,
                filterable: false,
            },
            {
                key: 'title',
                type: 'contact-title',
                label: 'Title',
                property: 'contact',
                width: 250,
                sortable: true,
                sortProperty: 'Title',
                editable: true,
                filterable: false,
            },
            {
                key: 'temperature',
                type: 'temperature',
                label: 'Temp',
                property: 'temperature',
                width: 100,
                sortable: true,
                sortProperty: 'TemperatureRating',
                editable: false,
                filterable: false,
            },
            {
                key: 'score',
                type: 'score',
                label: 'Score',
                property: 'score',
                width: 100,
                sortable: true,
                sortProperty: 'Score',
                editable: false,
                filterable: false,
            },
            {
                key: 'assigned-contact-status',
                type: 'vendor-contact-status',
                label: 'Contact Status',
                property: 'status',
                width: 250,
                sortable: true,
                sortProperty: 'ContactStatus/Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'email',
                type: 'contact-email',
                label: 'Email',
                property: 'contact',
                width: 200,
                sortable: true,
                sortProperty: 'Email',
                editable: true,
                filterable: false,
            },
            {
                key: 'phone',
                type: 'contact-phone',
                label: 'Phone',
                property: 'contact',
                width: 200,
                sortable: true,
                sortProperty: 'Phone',
                editable: true,
                filterable: false,
            },
            {
                key: 'activities',
                type: 'contact-activities',
                label: 'Activities',
                property: 'activities',
                width: 180,
                sortable: false,
                sortProperty: 'Activities',
                editable: true,
                filterable: false,
            },
            {
                key: 'city',
                type: 'contact-city',
                label: 'City',
                property: 'contact',
                width: 150,
                sortable: true,
                sortProperty: 'City',
                editable: true,
                filterable: false,
            },
            {
                key: 'region',
                type: 'contact-region',
                label: 'State',
                property: 'contact',
                width: 150,
                sortable: true,
                sortProperty: 'Region',
                editable: true,
                filterable: false,
            },
            {
                key: 'last-lead-activity-date',
                type: 'date-time',
                label: 'Last Contact Activity',
                property: 'lastLeadActivityDate',
                width: 200,
                sortable: true,
                sortProperty: 'LastLeadActivityDate',
                editable: true,
                filterable: false,
            },
            {
                key: 'last-user-activity-date',
                type: 'date-time',
                label: 'Last Sales Activity',
                property: 'lastUserActivityDate',
                width: 200,
                sortable: true,
                sortProperty: 'LastUserActivityDate',
                editable: true,
                filterable: false,
            },
            {
                key: 'social-media',
                type: 'social-media',
                label: 'Social',
                property: 'socialMedia',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'assigned-salesperson',
                type: 'vendor-contact-salesperson',
                label: 'Salesperson',
                property: 'salesperson',
                width: 250,
                sortable: true,
                sortProperty: 'SalesPerson/FirstName',
                editable: true,
                filterable: false,
            },
            {
                key: 'partner-assigned-users',
                type: 'assigned-users',
                label: 'Assigned Users',
                property: 'assignedUsers',
                width: 250,
                sortable: false,
                sortProperty: null,
                editable: true,
                filterable: true,
            },
        ];
    },

    getVerticalDefinitions() {
        return [
            {
                key: 'name',
                type: 'vertical-name',
                label: 'Name',
                property: 'vertical',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
        ];
    },

    getRegisteredDealHeaderDefinitions() {
        return [
            {
                key: 'client',
                type: 'client-name',
                label: 'Partner',
                property: 'client',
                width: 250,
                sortable: true,
                sortProperty: 'Deal/Contact/Client/Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'company',
                type: 'company-name',
                label: 'Company',
                property: 'company',
                width: 250,
                sortable: true,
                sortProperty: 'Deal/Contact/Company/Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'primaryContact',
                type: 'contact', 
                label: 'Primary Contact',
                property: 'contact',
                width: 250,
                sortable: true,
                sortProperty: 'Deal/Contact/LastName',
                editable: false,
                filterable: false,
            },
            {
                key: 'name',
                type: 'string',
                label: 'Registered Deal Name',
                property: 'name',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'RegistrationNumber',
                type: 'string',
                label: 'Registration Number',
                property: 'registrationNumber',
                width: 200,
                sortable: true,
                sortProperty: 'RegistrationNumber',
                editable: true,
                filterable: false,
            },
            {
                key: 'value',
                type: 'registered-deal-value',
                label: 'Registered Deal Amount',
                property: 'registeredDeal',
                width: 200,
                sortable: true,
                sortProperty: 'Value',
                editable: true,
                filterable: false,
            },
            {
                key: 'solutions',
                type: 'global-category',
                label: 'Solutions',
                property: 'solution',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'approvalStatus',
                type: 'registered-deal-status',
                label: 'Registered Deal Status',
                property: 'status',
                width: 200,
                sortable: true,
                sortProperty: 'IsApproved',
                editable: false,
                filterable: false,
            },
            {
                key: 'projectedClosingDate',
                type: 'full-date-time-due', 
                label: 'Projected Closing Date',
                property: 'closingDate',
                width: 250,
                sortable: true,
                sortProperty: 'ProjectedClosingDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'details',
                type: 'registered-deal-details',
                label: 'Details',
                property: 'registeredDeal',
                width: 200,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'opportunityName',
                type: 'string', 
                label: 'Opportunity Name',
                property: 'opportunityName',
                width: 250,
                sortable: true,
                sortProperty: 'Deal/Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'oppStatus',
                type: 'opportunity-win',
                label: 'Opportunity Status',
                property: 'opportunityStatus',
                width: 200,
                sortable: true,
                sortProperty: 'Deal/IsWon',
                editable: false,
                filterable: false,
            },
        ];
    },

    getRegisteredDealReportHeaderDefinitions() {
        return [
            {
                key: 'client',
                type: 'client-name',
                label: 'Partner',
                property: 'client',
                width: 250,
                sortable: false,
                sortProperty: 'Deal/Contact/Client/Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'company',
                type: 'company-name',
                label: 'Company',
                property: 'company',
                width: 250,
                sortable: false,
                sortProperty: 'Deal/Contact/Company/Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'contact',
                type: 'contact',
                label: 'Primary Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                sortProperty: 'Deal/Contact',
                editable: false,
                filterable: false,
            },
            {
                key: 'name',
                type: 'string',
                label: 'Registered Deal Name',
                property: 'registeredDealName',
                width: 250,
                sortable: false,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'registrationNumber',
                type: 'registered-deal-registration-number',
                label: 'Registration Number',
                property: 'registeredDeal',
                width: 200,
                sortable: false,
                sortProperty: 'RegistrationNumber',
                editable: false,
                filterable: false,
            },
            {
                key: 'value',
                type: 'registered-deal-value',
                label: 'Registered Deal Amount',
                property: 'registeredDeal',
                width: 200,
                sortable: false,
                sortProperty: 'Value',
                editable: false,
                filterable: false,
            },
            {
                key: 'registered-deal-solutions',
                type: 'global-category',
                label: 'Solutions',
                property: 'registeredDealSolutions',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'registeredDealStatus',
                type: 'registered-deal-status',
                label: 'Registered Deal Status',
                property: 'registeredDealStatus',
                width: 200,
                sortable: false,
                sortProperty: 'IsApproved',
                editable: false,
                filterable: false,
            },
            {
                key: 'projectedClosingDate',
                type: 'day-date',
                label: 'Projected Closing Date',
                property: 'projectedClosingDate',
                width: 200,
                sortable: false,
                sortProperty: 'ProjectedClosingDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'dealName',
                type: 'opportunity-name',
                label: 'Opportunity Name',
                property: 'deal',
                width: 250,
                sortable: false,
                sortProperty: 'Deal/Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'oppStatus',
                type: 'opportunity-win',
                label: 'Opportunity Status',
                property: 'opportunityStatus',
                width: 200,
                sortable: false,
                sortProperty: 'Deal/IsWon',
                editable: false,
                filterable: false,
            },
        ];
    },

    getTemplateHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'template',
                label: 'Name',
                property: 'template',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            
            {
                key: 'createdDate',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 250,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ];
    },

    getLandingPageTemplateHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'landing-page-template-name',
                label: 'Landing Page',
                property: 'template',
                width: 280,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: true,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 300,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'createdDate',
                type: 'full-date-time-template',
                label: 'Created Date',
                property: 'createdAt',
                width: 280,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time-template',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 280,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ]
    },

    getLandingPageTemplateSubscriptionHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'landing-page-shared-template-name',
                label: 'Landing Page',
                property: 'template',
                width: 280,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 300,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'createdDate',
                type: 'full-date-time-template',
                label: 'Created Date',
                property: 'createdAt',
                width: 280,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time-template',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 280,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ]
    },

    getLandingPageTemplateSharedHeaderDefinitions() { 
        return [
            {
                key: 'name',
                type: 'landing-page-shared-template-name',
                label: 'Landing Page',
                property: 'template',
                width: 280,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'vendor',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'vendor',
                width: 280,
                sortable: true,
                sortProperty: 'Account/Agency/Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 300,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'createdDate',
                type: 'full-date-time-template',
                label: 'Created Date',
                property: 'createdAt',
                width: 280,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time-template',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 280,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ]
    },

    getLandingPageTemplatePublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'landing-page-template-name',
                label: 'Landing Page',
                property: 'template',
                width: 280,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'autoPublished',
                width: 160,
                sortable: true,
                sortProperty: 'IsAutoPublished',
                editable: false,
                filterable: false,
            },
            {
                key: 'clientsPublished',
                type: 'client-published',
                label: 'Partners Published To',
                property: 'asset',
                width: 120,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 300,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'publishedDate',
                type: 'full-date-time-template',
                label: 'Published Date',
                property: 'publishedAt',
                width: 280,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time-template',
                label: 'Created Date',
                property: 'createdAt',
                width: 280,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
        ]
    },

    getLandingPageTemplateUnpublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'landing-page-template-name',
                label: 'Landing Page',
                property: 'template',
                width: 280,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'autoPublished',
                width: 180,
                sortable: true,
                sortProperty: 'IsAutoPublished',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 300,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'createdDate',
                type: 'full-date-time-template',
                label: 'Created Date',
                property: 'createdAt',
                width: 280,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
        ]
    },

    getLandingPageTemplateOrganizationPublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'landing-page-template-name',
                label: 'Name',
                property: 'template',
                width: 280,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'plans-published',
                type: 'number',
                label: 'Plans Published To',
                property: 'published',
                width: 180,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 300,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time-template',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 280,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time-template',
                label: 'Created Date',
                property: 'createdAt',
                width: 280,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
        ]
    },

    getLandingPageTemplateOrganizationUnpublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'landing-page-template-name',
                label: 'Name',
                property: 'template',
                width: 280,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 300,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time-template',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 280,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time-template',
                label: 'Created Date',
                property: 'createdAt',
                width: 280,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
        ]
    },

    getDocumentHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'document-name',
                label: 'Title',
                property: 'document',
                width: 280,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'recipients',
                type: 'document-recipients',
                label: 'Recipients',
                property: 'recipients',
                width: '280',
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'status',
                type: 'document-status',
                label: 'Status',
                property: 'status',
                width: '240',
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Updated',
                property: 'updatedAt',
                width: '280',
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'expiringDate',
                type: 'full-date-time',
                label: 'Expiring',
                property: 'expiringDate',
                width: '280',
                sortable: false,
                sortProperty: 'ExpiringDate',
                editable: false,
                filterable: false,
            }
        ]
    },

    getDocumentTemplateHeaderDefinitions(){
        return [
            {
                key: 'name',
                type: 'document-template-name',
                label: 'Title',
                property: 'template',
                width: 280,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: '280',
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: '280',
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ]
    },

    getDocumentTemplateSubscriptionHeaderDefinitions(){
        return [
            {
                key: 'name',
                type: 'document-shared-template-name',
                label: 'Title',
                property: 'template',
                width: 280,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: '280',
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: '280',
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ]
    },

    getDocumentTemplateSharedHeaderDefinitions(){
        return [
            {
                key: 'name',
                type: 'document-shared-template-name',
                label: 'Title',
                property: 'template',
                width: 280,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'vendor',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'vendor',
                width: 280,
                sortable: true,
                sortProperty: 'Account/Agency/Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: '280',
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: '280',
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ]
    },

    getDocumentTemplateAgencyPublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'document-template-name',
                label: 'Document Template',
                property: 'template',
                width: 280,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'autoPublished',
                width: 160,
                sortable: true,
                sortProperty: 'IsAutoPublished',
                editable: false,
                filterable: false,
            },
            {
                key: 'clientsPublished',
                type: 'client-published',
                label: 'Partners Published To',
                property: 'asset',
                width: 120,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'publishedDate',
                type: 'full-date-time',
                label: 'Published Date',
                property: 'publishedAt',
                width: 280,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 280,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
        ]
    },

    getDocumentTemplateAgencyUnpublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'document-template-name',
                label: 'Document Template',
                property: 'template',
                width: 280,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'autoPublished',
                width: 180,
                sortable: true,
                sortProperty: 'IsAutoPublished',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 280,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
        ]
    },

    getDocumentTemplateOrganizationPublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'document-template-name',
                label: 'Name',
                property: 'template',
                width: 280,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'plans-published',
                type: 'number',
                label: 'Plans Published To',
                property: 'published',
                width: 180,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time-template',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 280,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time-template',
                label: 'Created Date',
                property: 'createdAt',
                width: 280,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
        ]
    },

    getDocumentTemplateOrganizationUnpublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'document-template-name',
                label: 'Name',
                property: 'template',
                width: 280,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time-template',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 280,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time-template',
                label: 'Created Date',
                property: 'createdAt',
                width: 280,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
        ]
    },

    getNonGraphicalTemplateHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'non-graphical-template',
                label: 'Name',
                property: 'template',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'createdDate',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 250,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ];
    },

    getEmailTemplateSubscriptionHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'non-graphical-template',
                label: 'Name',
                property: 'template',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 250,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ];
    },

    getEmailTemplateSharedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'non-graphical-template',
                label: 'Name',
                property: 'template',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 250,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ];
    },

    getTemplateSubscriptionHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'template',
                label: 'Name',
                property: 'template',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 250,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ];
    },

    getSharedTemplateHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'template',
                label: 'Name',
                property: 'template',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Category',
                property: 'category',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'vendor',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'vendor',
                width: 300,
                sortable: true,
                sortProperty: 'Agency/Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'createdDate',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 250,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ];
    },

    getJourneyActiveHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'link',
                label: 'Name',
                property: 'journey',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'createdDate',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: true,
            },
            {
                key: 'modified',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'journey-trigger',
                type: 'string',
                label: 'Trigger',
                property: 'journeyTriggerName',
                width: 200,
                sortable: true,
                sortProperty: 'Trigger',
                editable: false,
                filterable: false,
            },
            {
                key: 'total-steps',
                type: 'number',
                label: 'Total Steps',
                property: 'totalSteps',
                width: 150,
                sortable: true,
                sortProperty: 'Steps',
                editable: false,
                filterable: false,
            },
            {
                key: 'email-steps',
                type: 'number',
                label: 'Email Steps',
                property: 'emailSteps',
                width: 150,
                sortable: true,
                sortProperty: 'EmailSteps',
                editable: false,
                filterable: true,
            },
            {
                key: 'task-steps',
                type: 'number',
                label: 'Task Steps',
                property: 'taskSteps',
                width: 150,
                sortable: true,
                sortProperty: 'TaskSteps',
                editable: false,
                filterable: false,
            },
            {
                key: 'emails-sent',
                type: 'number',
                label: 'Emails Sent',
                property: 'emailsSent',
                width: 150,
                sortable: true,
                sortProperty: 'EmailsSent',
                editable: false,
                filterable: false,
            },
            {
                key: 'opened',
                type: 'completion',
                label: 'Opened',
                property: 'openRate',
                width: 200,
                sortable: true,
                sortProperty: 'OpenRate',
                editable: false,
                filterable: true,
            },
            {
                key: 'clicked',
                type: 'completion',
                label: 'Clicked',
                property: 'clickRate',
                width: 200,
                sortable: true,
                sortProperty: 'ClickRate',
                editable: false,
                filterable: true,
            },
        ];
    },

    getJourneyInctiveHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'link',
                label: 'Name',
                property: 'journey',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'createdDate',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: true,
            },
            {
                key: 'modified',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'trigger',
                type: 'string',
                label: 'Trigger',
                property: 'journeyTriggerName',
                width: 200,
                sortable: true,
                sortProperty: 'Trigger',
                editable: false,
                filterable: false,
            },
            {
                key: 'scheduled',
                type: 'date-time',
                label: 'Scheduled',
                property: 'triggerDate',
                width: 200,
                sortable: true,
                sortProperty: 'TriggerDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'total-steps',
                type: 'number',
                label: 'Total Steps',
                property: 'totalSteps',
                width: 150,
                sortable: true,
                sortProperty: 'Steps',
                editable: false,
                filterable: false,
            },
            {
                key: 'email-steps',
                type: 'number',
                label: 'Email Steps',
                property: 'emailSteps',
                width: 150,
                sortable: true,
                sortProperty: 'EmailSteps',
                editable: false,
                filterable: true,
            },
            {
                key: 'task-steps',
                type: 'number',
                label: 'Task Steps',
                property: 'taskSteps',
                width: 150,
                sortable: true,
                sortProperty: 'TaskSteps',
                editable: false,
                filterable: false,
            },
            {
                key: 'emails-sent',
                type: 'number',
                label: 'Emails Sent',
                property: 'emailsSent',
                width: 150,
                sortable: true,
                sortProperty: 'EmailsSent',
                editable: false,
                filterable: false,
            },
            {
                key: 'opened',
                type: 'completion',
                label: 'Opened',
                property: 'openRate',
                width: 200,
                sortable: true,
                sortProperty: 'OpenRate',
                editable: false,
                filterable: true,
            },
            {
                key: 'clicked',
                type: 'completion',
                label: 'Clicked',
                property: 'clickRate',
                width: 200,
                sortable: true,
                sortProperty: 'ClickRate',
                editable: false,
                filterable: true,
            },
        ];
    },

    getJourneyTemplateHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'link',
                label: 'Name',
                property: 'journey',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },

            {
                key: 'createdDate',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: true,
            },
            {
                key: 'modified',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'trigger',
                type: 'string',
                label: 'Trigger',
                property: 'journeyTriggerName',
                width: 200,
                sortable: true,
                sortProperty: 'JourneyTrigger/Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'total-steps',
                type: 'number',
                label: 'Total Steps',
                property: 'totalSteps',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'email-steps',
                type: 'number',
                label: 'Email Steps',
                property: 'emailSteps',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'task-steps',
                type: 'number',
                label: 'Task Steps',
                property: 'taskSteps',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ];
    },

    getJourneyTemplatePublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'link',
                label: 'Name',
                property: 'journey',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'autoPublished',
                width: 200,
                sortable: true,
                sortProperty: 'IsAutoPublished',
                editable: false,
                filterable: false,
            },
            {
                key: 'clientsPublished',
                type: 'client-published',
                label: 'Partners Published To',
                property: 'asset',
                width: 120,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'createdDate',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: true,
            },
            {
                key: 'modified',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'trigger',
                type: 'string',
                label: 'Trigger',
                property: 'journeyTriggerName',
                width: 200,
                sortable: true,
                sortProperty: 'JourneyTrigger/Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'total-steps',
                type: 'number',
                label: 'Total Steps',
                property: 'totalSteps',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'email-steps',
                type: 'number',
                label: 'Email Steps',
                property: 'emailSteps',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'task-steps',
                type: 'number',
                label: 'Task Steps',
                property: 'taskSteps',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ];
    },

    getJourneyTemplateUnpublishedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'link',
                label: 'Name',
                property: 'journey',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'autoPublished',
                width: 200,
                sortable: true,
                sortProperty: 'IsAutoPublished',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'createdDate',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: true,
            },
            {
                key: 'modified',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'trigger',
                type: 'string',
                label: 'Trigger',
                property: 'journeyTriggerName',
                width: 200,
                sortable: true,
                sortProperty: 'JourneyTrigger/Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'total-steps',
                type: 'number',
                label: 'Total Steps',
                property: 'totalSteps',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'email-steps',
                type: 'number',
                label: 'Email Steps',
                property: 'emailSteps',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'task-steps',
                type: 'number',
                label: 'Task Steps',
                property: 'taskSteps',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ];
    },

    getJourneyTemplateSubscriptionHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'journey-shared-name',
                label: 'Name',
                property: 'journey',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modified',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'total-steps',
                type: 'number',
                label: 'Total Steps',
                property: 'totalSteps',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'email-steps',
                type: 'number',
                label: 'Email Steps',
                property: 'emailSteps',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'task-steps',
                type: 'number',
                label: 'Task Steps',
                property: 'taskSteps',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ];
    },

    getJourneyTemplateSharedHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'journey-shared-name',
                label: 'Name',
                property: 'journey',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'agency',
                type: 'vendor-name',
                label: 'Agency',
                property: 'agency',
                width: 250,
                sortable: true,
                sortProperty: 'Agency/Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'createdDate',
                type: 'date-time',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modified',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 200,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'total-steps',
                type: 'number',
                label: 'Total Steps',
                property: 'totalSteps',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'email-steps',
                type: 'number',
                label: 'Email Steps',
                property: 'emailSteps',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'task-steps',
                type: 'number',
                label: 'Task Steps',
                property: 'taskSteps',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ]
    },

    getJourneyStepContactHeaderDefinitions() {
        return [
            {
                key: 'contact',
                type: 'contact',
                label: 'Name',
                property: 'contact',
                width: 300,
                sortable: true,
                sortProperty: 'Contact/LastName',
                editable: false,
                filterable: false,
            },
            {
                key: 'action-date',
                type: 'full-date-time',
                label: 'Action Date',
                property: 'actionDate',
                width: 300,
                sortable: true,
                sortProperty: 'ActionDate',
                editable: false,
                filterable: false,
            },
        ];
    },

    getJourneyEmailStepContactHeaderDefinitions() {
        return [
            {
                key: 'contact',
                type: 'contact',
                label: 'Name',
                property: 'contact',
                width: 300,
                sortable: true,
                sortProperty: 'Contact/LastName',
                editable: false,
                filterable: false,
            },
            {
                key: 'opens',
                type: 'email-opens-widget',
                label: 'Opens',
                property: 'widget',
                width: 150,
                sortable: true,
                sortProperty: 'Message/Opens',
                editable: false,
                filterable: false,
            },
            {
                key: 'clicks',
                type: 'email-clicks-widget',
                label: 'Clicks',
                property: 'widget',
                width: 150,
                sortable: true,
                sortProperty: 'Message/Clicks',
                editable: false,
                filterable: false,
            },
        ];
    },

    getCustomContactFieldsHeaderDefinitions() {
        return [
            {
                key: 'order',
                type: 'number',
                label: 'Order',
                property: 'order',
                width: 100,
                sortable: false,
                sortProperty: 'Order',
                editable: false,
                filterable: false,
            },
            {
                key: 'name',
                type: 'string',
                label: 'Name',
                property: 'name',
                width: 250,
                sortable: false,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'description',
                type: 'string',
                label: 'Description',
                property: 'description',
                width: 320,
                sortable: false,
                sortProperty: 'description',
                editable: false,
                filterable: true,
            },
            {
                key: 'inputType',
                type: 'string',
                label: 'Input Type',
                property: 'inputType',
                width: 320,
                sortable: false,
                sortProperty: 'inputType',
                editable: false,
                filterable: false,
            },
        ];
    },

    getCustomCompanyFieldsHeaderDefinitions() {
        return [
            {
                key: 'order',
                type: 'number',
                label: 'Order',
                property: 'order',
                width: 100,
                sortable: false,
                sortProperty: 'Order',
                editable: false,
                filterable: false,
            },
            {
                key: 'name',
                type: 'string',
                label: 'Name',
                property: 'name',
                width: 250,
                sortable: false,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'description',
                type: 'string',
                label: 'Description',
                property: 'description',
                width: 320,
                sortable: false,
                sortProperty: 'description',
                editable: false,
                filterable: true,
            },
            {
                key: 'inputType',
                type: 'string',
                label: 'Input Type',
                property: 'inputType',
                width: 320,
                sortable: false,
                sortProperty: 'inputType',
                editable: false,
                filterable: false,
            },
        ];
    },

    getCustomLogActivitiesHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'string',
                label: 'Name',
                property: 'name',
                width: 250,
                sortable: false,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'icon',
                type: 'custom-activity-icon',
                label: 'Icon',
                property: 'icon',
                width: 150,
                sortable: false,
                sortProperty: 'Icon',
                editable: false,
                filterable: false,
            },
            {
                key: 'in_use',
                type: 'yes-no-indicator',
                label: 'In Use?',
                property: 'inUse',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'is_disabled',
                type: 'custom-activity-switch',
                label: 'Enable/Disable?',
                property: 'isDisabled',
                width: 250,
                sortable: false,
                sortProperty: 'IsDisabled',
                editable: false,
                filterable: false,
            }
        ]
    },

    getCustomOpportunityFieldsHeaderDefinitions() {
        return [
            {
                key: 'order',
                type: 'number',
                label: 'Order',
                property: 'order',
                width: 100,
                sortable: false,
                sortProperty: 'Order',
                editable: false,
                filterable: false,
            },
            {
                key: 'name',
                type: 'string',
                label: 'Name',
                property: 'name',
                width: 250,
                sortable: false,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'description',
                type: 'string',
                label: 'Description',
                property: 'description',
                width: 320,
                sortable: false,
                sortProperty: 'description',
                editable: false,
                filterable: true,
            },
            {
                key: 'inputType',
                type: 'string',
                label: 'Input Type',
                property: 'inputType',
                width: 320,
                sortable: false,
                sortProperty: 'inputType',
                editable: false,
                filterable: false,
            },
        ];
    },

    getCustomPartnerFieldsHeaderDefinitions() {
        return [
            {
                key: 'order',
                type: 'number',
                label: 'Order',
                property: 'order',
                width: 100,
                sortable: false,
                sortProperty: 'Order',
                editable: false,
                filterable: false,
            },
            {
                key: 'name',
                type: 'string',
                label: 'Name',
                property: 'name',
                width: 250,
                sortable: false,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'description',
                type: 'string',
                label: 'Description',
                property: 'description',
                width: 320,
                sortable: false,
                sortProperty: 'description',
                editable: false,
                filterable: true,
            },
            {
                key: 'inputType',
                type: 'string',
                label: 'Input Type',
                property: 'inputType',
                width: 320,
                sortable: false,
                sortProperty: 'inputType',
                editable: false,
                filterable: false,
            },
        ];
    },

    getSocialMediaManagedPostsHeaderDefinitions() {
        return [
            {
                key: 'postName',
                type: 'preview-name',
                label: 'Post name',
                property: 'post',
                width: 300,
                sortable: true,
                sortProperty: 'PostName',
                editable: true,
                filterable: true,
            },
            {
                key: 'status',
                type: 'status',
                label: 'Status',
                property: 'status',
                width: 200,
                sortable: true,
                sortProperty: 'Status',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Date',
                property: 'createdDate',
                width: 300,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            /*{
                key: 'marketingPlan',
                type: 'string',
                label: 'Marketing Plan',
                property: 'marketingPlan',
                width: 300,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },*/
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 300,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
            {
                key: 'publishedTo',
                type: 'social-media-posts',
                label: 'Published To',
                property: 'publishedTo',
                width: 200,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'stepsCompleted',
                type: 'steps-completed',
                label: 'Steps Completed',
                property: 'steps',
                width: 200,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'clicks',
                type: 'string',
                label: 'Clicks',
                property: 'clicks',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'impressions',
                type: 'string',
                label: 'Impressions',
                property: 'impressions',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'reach',
                type: 'string',
                label: 'Reach',
                property: 'reach',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'shares',
                type: 'string',
                label: 'Shares',
                property: 'shares',
                width: 150,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'engagement',
                type: 'completion',
                label: 'Engagement',
                property: 'engagement',
                width: 200,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            /*{
                key: 'isBoosted',
                type: 'checkmark',
                label: 'boosted',
                property: 'isBoosted',
                width: 200,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },*/
        ];
    },

    getPostTemplateHeaderDefinitions(){
        return [
            {
                key: 'name',
                type: 'preview-name',
                label: 'Post Name',
                property: 'postTemplate',
                width: 300,
                sortable: true,
                sortProperty: 'TemplateName',
                editable: true,
                filterable: true,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created',
                property: 'createdAt',
                width: 300,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 300,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 300,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
        ]
    },

    getPostTemplateSubscriptionHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'preview-name',
                label: 'Post Name',
                property: 'postTemplate',
                width: 300,
                sortable: true,
                sortProperty: 'TemplateName',
                editable: false,
                filterable: true,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created',
                property: 'createdAt',
                width: 300,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 300,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 300,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
        ]
    },

    getPostTemplateSharedHeaderDefinitions(){
        return [
            {
                key: 'name',
                type: 'preview-name',
                label: 'Post Name',
                property: 'postTemplate',
                width: 300,
                sortable: true,
                sortProperty: 'TemplateName',
                editable: false,
                filterable: true,
            },
            {
                key: 'vendor',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'vendor',
                width: 300,
                sortable: true,
                sortProperty: '"SharingVendorName"',
                editable: false,
                filterable: true,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created',
                property: 'createdAt',
                width: 300,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 300,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 300,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
        ]
    },

    getPostTemplatePublishedHeaderDefinitions(){
        return [
            {
                key: 'name',
                type: 'preview-name',
                label: 'Post Name',
                property: 'postTemplate',
                width: 300,
                sortable: true,
                sortProperty: 'TemplateName',
                editable: true,
                filterable: true,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'autoPublished',
                width: 160,
                sortable: true,
                sortProperty: 'IsAutoPublished',
                editable: false,
                filterable: false,
            },
            {
                key: 'clientsPublished',
                type: 'client-published',
                label: 'Partners Published To',
                property: 'publishedTo',
                width: 120,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'publishedDate',
                type: 'full-date-time-template',
                label: 'Published Date',
                property: 'publishedAt',
                width: 280,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created',
                property: 'createdAt',
                width: 300,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 300,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 300,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
        ]
    },

    getPostTemplateUnpublishedHeaderDefinitions(){
        return [
            {
                key: 'name',
                type: 'preview-name',
                label: 'Post Name',
                property: 'postTemplate',
                width: 300,
                sortable: true,
                sortProperty: 'TemplateName',
                editable: true,
                filterable: true,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'autoPublished',
                width: 160,
                sortable: true,
                sortProperty: 'IsAutoPublished',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created',
                property: 'createdAt',
                width: 300,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 300,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 300,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
        ]
    },

    getPostTemplateOrganizationPublishedHeaderDefinitions(){
        return [
            {
                key: 'name',
                type: 'preview-name',
                label: 'Post Name',
                property: 'postTemplate',
                width: 300,
                sortable: true,
                sortProperty: 'TemplateName',
                editable: true,
                filterable: true,
            },
            {
                key: 'plansPublished',
                type: 'number',
                label: 'Plans Published To',
                property: 'plansPublishedTo',
                width: 120,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created',
                property: 'createdAt',
                width: 300,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 300,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 300,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
        ]
    },

    getPostTemplateOrganizationUnpublishedHeaderDefinitions(){
        return [
            {
                key: 'name',
                type: 'preview-name',
                label: 'Post Name',
                property: 'postTemplate',
                width: 300,
                sortable: true,
                sortProperty: 'TemplateName',
                editable: true,
                filterable: true,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created',
                property: 'createdAt',
                width: 300,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 300,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'categories',
                type: 'global-category',
                label: 'Category',
                property: 'categories',
                width: 300,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: true,
            },
        ]
    },

    getUpdatesHeaderDefinitions() {
        return [
            {
                key: 'title',
                type: 'string',
                label: 'Title',
                property: 'updateName',
                width: 400,
                sortable: true,
                sortProperty: 'Title',
                editable: false,
                filterable: true,
            },
            {
                key: 'status',
                type: 'status',
                label: 'Status',
                property: 'status',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'created',
                type: 'full-date-time',
                label: 'Created',
                property: 'createDate',
                width: 300,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'recipients',
                type: 'string',
                label: 'Recipients',
                property: 'recipients',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'scheduled',
                type: 'full-date-time',
                label: 'Scheduled Date/Time',
                property: 'sentDate',
                width: 300,
                sortable: true,
                sortProperty: 'ScheduledAt',
                editable: false,
                filterable: false,
            },
        ];
    },

    getAgencyAccessHeaderDefinitions() {
        return [
            {
                key: 'agency',
                type: 'agency-image-name',
                label: 'Vendor',
                property: 'agency',
                width: 300,
                sortable: true,
                sortProperty: 'agency',
                editable: false,
                filterable: true,
            },
            {
                key: 'status',
                type: 'status',
                label: 'Status',
                property: 'status',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'action',
                type: 'action',
                label: 'Action',
                property: 'actions',
                width: 300,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'dateSent',
                type: 'full-date-time',
                label: 'Date Sent',
                property: 'dateSent',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'dateDenied',
                type: 'full-date-time',
                label: 'Date Denied',
                property: 'dateDenied',
                width: 250,
                sortable: true,
                sortProperty: 'DateDenied',
                editable: false,
                filterable: false,
            },
        ];
    },

    getPartnerRequestsHeaderDefinitions() {
        return [
            {
                key: 'agency-name',
                type: 'client-image-name',
                label: 'Company Name',
                property: 'client',
                width: 300,
                sortable: true,
                sortProperty: 'CompanyName',
                editable: false,
                filterable: true,
            },
            {
                key: 'website',
                type: 'string-website',
                label: 'Website',
                property: 'website',
                width: 200,
                sortProperty: 'Website',
                sortable: true,
                editable: false,
                filterable: true,
            },
            {
                key: 'contact',
                type: 'string',
                label: 'contact',
                property: 'contact',
                sortProperty: 'Contact',
                width: 200,
                sortable: true,
                editable: false,
                filterable: true,
            },
            {
                key: 'email',
                type: 'string-email',
                label: 'Email',
                property: 'email',
                width: 250,
                sortProperty: 'ContactEmail',
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'phoneNumber',
                type: 'string-phone',
                label: 'Phone Number',
                property: 'phoneNumber',
                width: 150,
                sortProperty: 'ContactPhoneNumber',
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'origin',
                type: 'string',
                label: 'Type of Request',
                property: 'origin',
                width: 130,
                sortable: true,
                sortProperty: 'Origin',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestReason',
                type: 'string',
                label: 'Reason For Request',
                property: 'requestReason',
                width: 300,
                sortable: false,
                sortProperty: 'ReasonForRequest',
                editable: false,
                filterable: false,
            },
            {
                key: 'dateSent',
                type: 'full-date-time',
                label: 'Date Sent',
                property: 'dateSent',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            }
        ];
    },

    getReportsScheduledHeaderDefinitions() {
        return [
            {
                key: 'report',
                type: 'string',
                label: 'Report',
                property: 'reportType',
                width: 250,
                sortable: true,
                sortProperty: 'ReportType/Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'frequency',
                type: 'string',
                label: 'Frequency',
                property: 'frequency',
                width: 123,
                sortable: true,
                sortProperty: 'ReportFrequencyType/Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'sent',
                type: 'string',
                label: 'Send Date',
                property: 'sentAt',
                width: 352,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'format',
                type: 'string',
                label: 'Format',
                property: 'format',
                width: 172,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ];
    },

    getInvoicesHeaderDefinitions() {
        return [
            {
                key: 'invoice-number',
                type: 'invoice-number',
                label: 'Invoice Number',
                property: 'invoiceNumber',
                width: 150,
                sortable: false,
                sortProperty: 'InvoiceNumber',
                editable: false,
                filterable: false,
            },
            {
                key: 'payableTo',
                type: 'vendor-name',
                label: 'Payable To',
                property: 'payableTo',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'createdAt',
                type: 'full-date-time-due',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'due-time',
                type: 'full-date-time-due',
                label: 'Due Date',
                property: 'dueDate',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'invoice-total',
                type: 'currency-two-decimals',
                label: 'Invoice Total',
                property: 'amount',
                width: 150,
                sortable: false,
                sortProperty: 'Amount',
                editable: false,
                filterable: true,
            },
            {
                key: 'status',
                type: 'status',
                label: 'Status',
                property: 'status',
                width: 200,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'pay',
                type: 'pay-now',
                label: 'Pay',
                property: 'shouldPay',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'paymentDate',
                type: 'full-date-time-due',
                label: 'Paid On',
                property: 'paymentDate',
                width: 200,
                sortable: true,
                sortProperty: 'PaymentDate',
                editable: false,
                filterable: false,
            },
        ];
    },

    getMDFInvoicesHeaderDefinitions() {
        return [
            {
                key: 'invoice-number',
                type: 'invoice-number',
                label: 'Invoice Number',
                property: 'invoiceNumber',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'payableTo',
                type: 'client-name',
                label: 'Payable To',
                property: 'payableTo',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'createdAt',
                type: 'full-date-time-due',
                label: 'Created',
                property: 'createdAt',
                width: 200,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'invoice-total',
                type: 'currency-two-decimals',
                label: 'Invoice Total',
                property: 'amount',
                width: 150,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'fund-type',
                type: 'global-category',
                label: 'Fund Type',
                property: 'fundType',
                width: 250,
                className: 'centered',
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'status',
                type: 'status',
                label: 'Status',
                property: 'status',
                width: 200,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'pay',
                type: 'pay-now',
                label: 'Pay',
                property: 'shouldPay',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'paymentProcessing',
                type: 'string',
                label: 'Payment Processing',
                property: 'paymentProcessing',
                width: 200,
                className: 'centered',
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'paymentDate',
                type: 'full-date-time-due',
                label: 'Paid On',
                property: 'paymentDate',
                width: 200,
                sortable: true,
                sortProperty: 'PaymentDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'proofOfPayment',
                type: 'vendor-proof-of-payment',
                label: 'Proof of Payment',
                property: 'proofOfPayment',
                width: 230,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ];
    },

    getMyCreationsHeaderDefinitions() {
        return [
            {
                key: 'name',
                type: 'design-studio-name',
                label: 'Name',
                property: 'asset',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
                multiSelectChip: true,
                filterOptions:[],
                getFilterOptions: () => {},
            },
            {
                key: 'type',
                type: 'string',
                label: 'Type',
                property: 'nameType',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
                multiSelectChip: true,
                secondMethodVersion:true,
                filterOptions:[],
                getFilterOptions: () => {},
            },
            {
                key: 'categories',
                type: 'global-category',
                multiSelectChip: true,
                label: 'Category',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
                filterOptions:[],
                getFilterOptions: () => {},
            },
            {
                key: 'created-date',
                type: 'full-date-time',
                label: 'Created',
                property: 'createdAt',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modified-date',
                type: 'full-date-time',
                label: 'Date Modified',
                property: 'updatedAt',
                width: 250,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'created-by',
                type: 'user',
                label: 'Created By',
                property: 'createdByUser',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'last-modified-by',
                type: 'user',
                label: 'Last Modified by',
                property: 'updatedByUser',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ];
    },

    getStorefrontRequestHeaderDefinitions(){
        return [
            {
                key: 'company',
                type: 'storefront-name',
                label: 'Storefront',
                property: 'company',
                width: 400,
                sortable: true,
                sortProperty: 'AgencyStorefrontName',
                editable: false,
                filterable: true,
            },
            {
                key: 'status',
                type: 'status',
                label: 'Status',
                property: 'status',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'applicationDate',
                type: 'full-date-time',
                label: 'Application Date',
                property: 'applicationDate',
                width: 300,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: true,
            },
        ]

    },

    getMarketplaceApplicationHeaderDefinitions(){
        return [
            {
                key: 'company',
                type: 'company-name',
                label: 'Name',
                property: 'company',
                width: 400,
                sortable: true,
                sortProperty: 'Name',
                editable: true,
                filterable: true,
            },
            {
                key: 'status',
                type: 'status',
                label: 'Status',
                property: 'status',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },

            {
                key: 'applicationDate',
                type: 'full-date-time-due',
                label: 'Application Date',
                property: 'applicationDate',
                width: 200,
                sortable: true,
                sortProperty: 'applicationDate',
                editable: false,
                filterable: true,
            },
        ]
    },

    getMarketplacePartnerRequestHeaderDefinitions(){
        return [
            {
                key: 'company',
                type: 'company-name',
                label: 'Name',
                property: 'company',
                width: 300,
                sortable: true,
                sortProperty: 'Company Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'website',
                type: 'company-website',
                label: 'Website',
                property: 'company',
                width: 200,
                sortable: true,
                sortProperty: 'Website',
                editable: false,
                filterable: true,
            },
            {
                key: 'contact',
                type: 'contact',
                label: 'Contact',
                property: 'contact',
                width: 300,
                sortable: true,
                sortProperty: 'Contact/LastName',
                editable: false,
                filterable: true,
            },
            {
                key: 'email',
                type: 'contact-email',
                label: 'Email',
                property: 'contact',
                width: 200,
                sortable: true,
                sortProperty: 'Contact/Email',
                editable: false,
                filterable: false,
            },
            {
                key: 'phone',
                type: 'contact-phone',
                label: 'Phone',
                property: 'contact',
                width: 200,
                sortable: true,
                sortProperty: 'Contact/Phone',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestReason',
                type: 'string',
                label: 'Reason for Request',
                property: 'reason',
                width: 300,
                sortable: false,
                editable: false,
                filterable: true,
            },

            {
                key: 'applicationDate',
                type: 'full-date-time-due',
                label: 'Application Date',
                property: 'applicationDate',
                width: 200,
                sortable: true,
                sortProperty: 'applicationDate',
                editable: false,
                filterable: true,
            },
        ]
    },

    getMDFManagementHeaderDefinitions() {
        return [
            {
                key: 'funds',
                type: 'mdf-pool-fund',
                label: 'Budgets Used',
                property: 'fundPoolName',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,

            },
            {
                key: 'partner',
                type: 'client-account-name',
                label: 'Partner',
                property: 'client',
                width: 200,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'mdf-assign-user',
                label: 'Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'start',
            },
            {
                key: 'status',
                type: 'mdf-status',
                label: 'Status',
                property: 'status',
                width: 200,
                sortable: true,
                sortProperty: 'Status',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'preapprovedFunds',
                type: 'mdf-amount',
                label: 'Preallocated Funds',
                property: 'preapprovedFunds',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApproved',
                type: 'mdf-amount',
                label: 'Funds Approved',
                property: 'fundsApproved',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsPaid',
                type: 'mdf-amount',
                label: 'Funds Paid',
                property: 'fundsPaid',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundAllocationDate',
                type: 'full-date-time-due',
                label: 'Fund Allocation Date',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'dateDenied',
                type: 'full-date-time-due',
                label: 'Date Denied',
                property: 'dateDenied',
                width: 250,
                sortable: true,
                sortProperty: 'DeniedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundExpirationDate',
                type: 'full-date-time-due',
                label: 'Fund Expiration Date',
                property: 'fundExpirationDate',
                width: 250,
                sortable: true,
                sortProperty: 'ExpirationDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'popSubmittedDate',
                type: 'full-date-time-due',
                label: 'Pop Submitted Date',
                property: 'popSubmittedDate',
                width: 250,
                sortable: true,
                sortProperty: 'PopSubmittedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprovedDate',
                type: 'full-date-time-due',
                label: 'Funds Approved Date',
                property: 'fundsApprovedDate',
                width: 250,
                sortable: true,
                sortProperty: 'ApprovedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsPaidDate',
                type: 'full-date-time-due',
                label: 'Funds Paid Date',
                property: 'fundsPaidDate',
                width: 250,
                sortable: true,
                sortProperty: 'PaidDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'registeredDeals',
                type: 'mdf-registered-deals',
                label: 'Registered Deals',
                property: 'registeredDeals',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'wonDeals',
                type: 'mdf-registered-deals',
                label: 'Won Deals',
                property: 'wonDeals',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'generatedRevenue',
                type: 'mdf-amount',
                label: 'Generated Revenue',
                property: 'generatedRevenue',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'roi',
                type: 'string',
                label: 'ROI',
                property: 'roi',
                width: 100,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'centered',
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'payFunds',
                type: 'mdf-pay-funds',
                label: 'Pay Funds',
                property: 'id',
                width: 200,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'stripeStatus',
                type: 'mdf-stripe-status',
                label: 'Stripe Status',
                property: 'connectedAccountStatus', 
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ]
    },

    getMDFManagementPendingHeaderDefinitions() {
        return [
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'partner',
                type: 'client-account-name',
                label: 'Partner',
                property: 'client',
                width: 200,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'mdf-assign-user',
                label: 'Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'start',
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'stripeStatus',
                type: 'mdf-stripe-status',
                label: 'Stripe Status',
                property: 'connectedAccountStatus',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ]
    },

    getMDFManagementFundsAllocatedHeaderDefinitions() {
        return [
            {
                key: 'funds',
                type: 'mdf-pool-fund',
                label: 'Budgets Used',
                property: 'fundPoolName',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,

            },
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'partner',
                type: 'client-account-name',
                label: 'Partner',
                property: 'client',
                width: 200,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'mdf-assign-user',
                label: 'Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'start',
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundAllocationDate',
                type: 'full-date-time-due',
                label: 'Fund Allocation Date',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundExpirationDate',
                type: 'full-date-time-due',
                label: 'Fund Expiration Date',
                property: 'fundExpirationDate',
                width: 250,
                sortable: true,
                sortProperty: 'ExpirationDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'stripeStatus',
                type: 'mdf-stripe-status',
                label: 'Stripe Status',
                property: 'connectedAccountStatus',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ]
    },

    getMDFManagementPopSubmittedHeaderDefinitions() {
        return [
            {
                key: 'funds',
                type: 'mdf-pool-fund',
                label: 'Budgets Used',
                property: 'fundPoolName',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,

            },
            {
                key: 'requestDate',
                type: 'full-date-time-due',           
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'popSubmittedDate',
                type: 'full-date-time-due',
                label: 'Date Pop Submitted',
                property: 'popSubmittedDate',
                width: 250,
                sortable: true,
                sortProperty: 'PopSubmittedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'partner',
                type: 'client-account-name',
                label: 'Partner',
                property: 'client',
                width: 200,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'mdf-assign-user',
                label: 'Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'start',
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'dateAllocated',
                type: 'full-date-time-due',
                label: 'Date Allocated',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundExpirationDate',
                type: 'full-date-time-due',
                label: 'Fund Expiration Date',
                property: 'fundExpirationDate',
                width: 250,
                sortable: true,
                sortProperty: 'ExpirationDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'stripeStatus',
                type: 'mdf-stripe-status',
                label: 'Stripe Status',
                property: 'connectedAccountStatus',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ]
    },

    getMDFManagementFundsPendingPaymentHeaderDefinitions() {
        return [
            {
                key: 'funds',
                type: 'mdf-pool-fund',
                label: 'Budgets Used',
                property: 'fundPoolName',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,

            },
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'popSubmittedDate',
                type: 'full-date-time-due',
                label: 'Date Pop Submitted',
                property: 'popSubmittedDate',
                width: 250,
                sortable: true,
                sortProperty: 'PopSubmittedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'partner',
                type: 'client-account-name',
                label: 'Partner',
                property: 'client',
                width: 200,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'mdf-assign-user',
                label: 'Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'start',
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApproved',
                type: 'mdf-amount',
                label: 'Funds Approved',
                property: 'fundsApproved',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'payFunds',
                type: 'mdf-pay-funds',
                label: 'Pay Funds',
                property: 'id',
                width: 200,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsAllocationDate',
                type: 'full-date-time-due',
                label: 'Funds Allocation Date',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprovedDate',
                type: 'full-date-time-due',
                label: 'Funds Approved Date',
                property: 'fundsApprovedDate',
                width: 250,
                sortable: true,
                sortProperty: 'ApprovedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'stripeStatus',
                type: 'mdf-stripe-status',
                label: 'Stripe Status',
                property: 'connectedAccountStatus',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ]
    },

    getMDFManagementFundsInTransitHeaderDefinitions() {
        return [
            {
                key: 'funds',
                type: 'mdf-pool-fund',
                label: 'Budgets Used',
                property: 'fundPoolName',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,

            },
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'popSubmittedDate',
                type: 'full-date-time-due',
                label: 'Date Pop Submitted',
                property: 'popSubmittedDate',
                width: 250,
                sortable: true,
                sortProperty: 'PopSubmittedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'partner',
                type: 'client-account-name',
                label: 'Partner',
                property: 'client',
                width: 200,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'mdf-assign-user',
                label: 'Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'start',
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApproved',
                type: 'mdf-amount',
                label: 'Funds Approved',
                property: 'fundsApproved',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsAllocationDate',
                type: 'full-date-time-due',
                label: 'Funds Allocation Date',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprovedDate',
                type: 'full-date-time-due',
                label: 'Funds Approved Date',
                property: 'fundsApprovedDate',
                width: 250,
                sortable: true,
                sortProperty: 'ApprovedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'stripeStatus',
                type: 'mdf-stripe-status',
                label: 'Stripe Status',
                property: 'connectedAccountStatus',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ]
    },

    getMDFManagementFundsPaidHeaderDefinitions() {
        return [
            {
                key: 'funds',
                type: 'mdf-pool-fund',
                label: 'Budgets Used',
                property: 'fundPoolName',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,

            },
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'popSubmittedDate',
                type: 'full-date-time-due',
                label: 'Date Pop Submitted',
                property: 'popSubmittedDate',
                width: 250,
                sortable: true,
                sortProperty: 'PopSubmittedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'partner',
                type: 'client-account-name',
                label: 'Partner',
                property: 'client',
                width: 200,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'mdf-assign-user',
                label: 'Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'start',
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'paymentProcessing',
                type: 'string',
                label: 'Payment Processing',
                property: 'paymentProcessing',
                className: 'centered',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsPaid',
                type: 'mdf-amount',
                label: 'Funds Paid',
                property: 'fundsPaid',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'payFunds',
                type: 'mdf-pay-funds',
                label: 'Pay Funds',
                property: 'id',
                width: 200,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundAllocationDate',
                type: 'full-date-time-due',
                label: 'Fund Allocation Date',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'FundAllocationDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprovedDate',
                type: 'full-date-time-due',
                label: 'Funds Approved Date',
                property: 'fundsApprovedDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsPaidDate',
                type: 'full-date-time-due',
                label: 'Funds Paid Date',
                property: 'fundsPaidDate',
                width: 250,
                sortable: true,
                sortProperty: 'PaidDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'registeredDeals',
                type: 'mdf-registered-deals',
                label: 'Registered Deals',
                property: 'registeredDeals',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'wonDeals',
                type: 'mdf-registered-deals',
                label: 'Won Deals',
                property: 'wonDeals',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'generatedRevenue',
                type: 'mdf-amount',
                label: 'Generated Revenue',
                property: 'generatedRevenue',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'roi',
                type: 'string',
                label: 'ROI',
                property: 'roi',
                width: 100,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'centered',
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'stripeStatus',
                type: 'mdf-stripe-status',
                label: 'Stripe Status',
                property: 'connectedAccountStatus',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ]
    },

    getMDFManagementExpiredHeaderDefinitions() {
        return [
            {
                key: 'funds',
                type: 'mdf-pool-fund',
                label: 'Budgets Used',
                property: 'fundPoolName',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,

            },
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'partner',
                type: 'client-account-name',
                label: 'Partner',
                property: 'client',
                width: 200,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'mdf-assign-user',
                label: 'Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'start',
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundAllocationDate',
                type: 'full-date-time-due',
                label: 'Fund Allocation Date',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'expirationDate',
                type: 'full-date-time-due',
                label: 'Expiration Date',
                property: 'fundExpirationDate',
                width: 250,
                sortable: true,
                sortProperty: 'ExpirationDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'stripeStatus',
                type: 'mdf-stripe-status',
                label: 'Stripe Status',
                property: 'connectedAccountStatus',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ]
    },

    getMDFManagementDeniedHeaderDefinitions() {
        return [
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'partner',
                type: 'client-account-name',
                label: 'Partner',
                property: 'client',
                width: 200,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'mdf-assign-user',
                label: 'Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'start',
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfRequestDenial',
                type: 'full-date-time-due',
                label: 'Date Of Request Denial',
                property: 'dateDenied',
                width: 250,
                sortable: true,
                sortProperty: 'DeniedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'stripeStatus',
                type: 'mdf-stripe-status',
                label: 'Stripe Status',
                property: 'connectedAccountStatus',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ]
    },

    getMDFManagementPopDeniedHeaderDefinitions() {
        return [
            {
                key: 'funds',
                type: 'mdf-pool-fund',
                label: 'Budgets Used',
                property: 'fundPoolName',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,

            },
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'popSubmittedDate',
                type: 'full-date-time-due',
                label: 'Date Pop Submitted',
                property: 'popSubmittedDate',
                width: 250,
                sortable: true,
                sortProperty: 'PopSubmittedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'partner',
                type: 'client-account-name',
                label: 'Partner',
                property: 'client',
                width: 200,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'mdf-assign-user',
                label: 'Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'start',
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundAllocationDate',
                type: 'full-date-time-due',
                label: 'Fund Allocation Date',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundExpirationDate',
                type: 'full-date-time-due',
                label: 'Fund Expiration Date',
                property: 'fundExpirationDate',
                width: 250,
                sortable: true,
                sortProperty: 'ExpirationDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'popDeniedDate',
                type: 'full-date-time-due',
                label: 'Pop Denied Date',
                property: 'popDeniedDate',
                width: 250,
                sortable: true,
                sortProperty: 'PopDeniedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'stripeStatus',
                type: 'mdf-stripe-status',
                label: 'Stripe Status',
                property: 'connectedAccountStatus',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ]
    },

    getMDFReportManagementHeaderDefinitions() {
        return [
            {
                key: 'partner',
                type: 'client-account-name',
                label: 'Partner',
                property: 'client',
                width: 200,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'mdf-assign-user',
                label: 'Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'start',
            },
            {
                key: 'status',
                type: 'mdf-status',
                label: 'Status',
                property: 'status',
                width: 200,
                sortable: true,
                sortProperty: 'Status',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'preapprovedFunds',
                type: 'mdf-amount',
                label: 'Preallocated Funds',
                property: 'preapprovedFunds',
                width: 250,
                sortable: true,
                sortProperty: 'PreapprovedFundsSelectedCurrency',
                editable: false,
                filterable: false,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: true,
                sortProperty: 'AllocatedAmountUSDHistorical',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApproved',
                type: 'mdf-amount',
                label: 'Funds Approved',
                property: 'fundsApproved',
                width: 250,
                sortable: true,
                sortProperty: 'ApprovedFundsUSD',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsPaid',
                type: 'mdf-amount',
                label: 'Funds Paid',
                property: 'fundsPaid',
                width: 250,
                sortable: true,
                sortProperty: 'PaidAmountUSD',
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundAllocationDate',
                type: 'full-date-time-due',
                label: 'Fund Allocation Date',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'dateDenied',
                type: 'full-date-time-due',
                label: 'Date Denied',
                property: 'dateDenied',
                width: 250,
                sortable: true,
                sortProperty: 'DeniedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundExpirationDate',
                type: 'full-date-time-due',
                label: 'Fund Expiration Date',
                property: 'fundExpirationDate',
                width: 250,
                sortable: true,
                sortProperty: 'ExpirationDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'popSubmittedDate',
                type: 'full-date-time-due',
                label: 'Pop Submitted Date',
                property: 'popSubmittedDate',
                width: 250,
                sortable: true,
                sortProperty: 'PopSubmittedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprovedDate',
                type: 'full-date-time-due',
                label: 'Funds Approved Date',
                property: 'fundsApprovedDate',
                width: 250,
                sortable: true,
                sortProperty: 'ApprovedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsPaidDate',
                type: 'full-date-time-due',
                label: 'Funds Paid Date',
                property: 'fundsPaidDate',
                width: 250,
                sortable: true,
                sortProperty: 'PaidDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'registeredDeals',
                type: 'mdf-registered-deals',
                label: 'Registered Deals',
                property: 'registeredDeals',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'wonDeals',
                type: 'mdf-registered-deals',
                label: 'Won Deals',
                property: 'wonDeals',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'generatedRevenue',
                type: 'mdf-amount',
                label: 'Generated Revenue',
                property: 'generatedRevenue',
                width: 250,
                sortable: true,
                sortProperty: 'GeneratedRevenue',
                editable: false,
                filterable: false,
            },
            {
                key: 'roi',
                type: 'string',
                label: 'ROI',
                property: 'roi',
                width: 100,
                sortable: true,
                sortProperty: 'Roi',
                editable: false,
                filterable: false,
                className: 'centered',
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'payFunds',
                type: 'mdf-pay-funds',
                label: 'Pay Funds',
                property: 'id',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'stripeStatus',
                type: 'mdf-stripe-status',
                label: 'Stripe Status',
                property: 'connectedAccountStatus',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ]
    },

    getMDFReportManagementPendingHeaderDefinitions() {
        return [
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'partner',
                type: 'client-account-name',
                label: 'Partner',
                property: 'client',
                width: 200,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'mdf-assign-user',
                label: 'Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'start',
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'stripeStatus',
                type: 'mdf-stripe-status',
                label: 'Stripe Status',
                property: 'connectedAccountStatus',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ]
    },

    getMDFReportManagementFundsAllocatedHeaderDefinitions() {
        return [
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'partner',
                type: 'client-account-name',
                label: 'Partner',
                property: 'client',
                width: 200,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'mdf-assign-user',
                label: 'Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'start',
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'preapprovedFunds',
                type: 'mdf-amount',
                label: 'Preallocated Funds',
                property: 'preapprovedFunds',
                width: 250,
                sortable: true,
                sortProperty: 'PreapprovedFundsSelectedCurrency',
                editable: false,
                filterable: false,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: true,
                sortProperty: 'AllocatedAmountUSDHistorical',
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundAllocationDate',
                type: 'full-date-time-due',
                label: 'Fund Allocation Date',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundExpirationDate',
                type: 'full-date-time-due',
                label: 'Fund Expiration Date',
                property: 'fundExpirationDate',
                width: 250,
                sortable: true,
                sortProperty: 'ExpirationDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'stripeStatus',
                type: 'mdf-stripe-status',
                label: 'Stripe Status',
                property: 'connectedAccountStatus',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ]
    },

    getMDFReportManagementPopSubmittedHeaderDefinitions() {
        return [
            {
                key: 'requestDate',
                type: 'full-date-time-due',           
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'popSubmittedDate',
                type: 'full-date-time-due',
                label: 'Date Pop Submitted',
                property: 'popSubmittedDate',
                width: 250,
                sortable: true,
                sortProperty: 'PopSubmittedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'partner',
                type: 'client-account-name',
                label: 'Partner',
                property: 'client',
                width: 200,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'mdf-assign-user',
                label: 'Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'start',
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'preapprovedFunds',
                type: 'mdf-amount',
                label: 'Preallocated Funds',
                property: 'preapprovedFunds',
                width: 250,
                sortable: true,
                sortProperty: 'PreapprovedFundsSelectedCurrency',
                editable: false,
                filterable: false,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: true,
                sortProperty: 'AllocatedAmountUSDHistorical',
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'dateAllocated',
                type: 'full-date-time-due',
                label: 'Date Allocated',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundExpirationDate',
                type: 'full-date-time-due',
                label: 'Fund Expiration Date',
                property: 'fundExpirationDate',
                width: 250,
                sortable: true,
                sortProperty: 'ExpirationDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'stripeStatus',
                type: 'mdf-stripe-status',
                label: 'Stripe Status',
                property: 'connectedAccountStatus',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ]
    },

    getMDFReportManagementFundsPendingPaymentHeaderDefinitions() {
        return [
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'popSubmittedDate',
                type: 'full-date-time-due',
                label: 'Date Pop Submitted',
                property: 'popSubmittedDate',
                width: 250,
                sortable: true,
                sortProperty: 'PopSubmittedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'partner',
                type: 'client-account-name',
                label: 'Partner',
                property: 'client',
                width: 200,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'mdf-assign-user',
                label: 'Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'start',
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'preapprovedFunds',
                type: 'mdf-amount',
                label: 'Preallocated Funds',
                property: 'preapprovedFunds',
                width: 250,
                sortable: true,
                sortProperty: 'PreapprovedFundsSelectedCurrency',
                editable: false,
                filterable: false,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: true,
                sortProperty: 'AllocatedAmountUSDHistorical',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApproved',
                type: 'mdf-amount',
                label: 'Funds Approved',
                property: 'fundsApproved',
                width: 250,
                sortable: true,
                sortProperty: 'ApprovedFundsUSD',
                editable: false,
                filterable: false,
            },
            {
                key: 'payFunds',
                type: 'mdf-pay-funds',
                label: 'Pay Funds',
                property: 'id',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsAllocationDate',
                type: 'full-date-time-due',
                label: 'Funds Allocation Date',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprovedDate',
                type: 'full-date-time-due',
                label: 'Funds Approved Date',
                property: 'fundsApprovedDate',
                width: 250,
                sortable: true,
                sortProperty: 'ApprovedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'stripeStatus',
                type: 'mdf-stripe-status',
                label: 'Stripe Status',
                property: 'connectedAccountStatus',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ]
    },

    getMDFReportManagementFundsInTransitHeaderDefinitions() {
        return [
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'popSubmittedDate',
                type: 'full-date-time-due',
                label: 'Date Pop Submitted',
                property: 'popSubmittedDate',
                width: 250,
                sortable: true,
                sortProperty: 'PopSubmittedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'partner',
                type: 'client-account-name',
                label: 'Partner',
                property: 'client',
                width: 200,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'mdf-assign-user',
                label: 'Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'start',
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'preapprovedFunds',
                type: 'mdf-amount',
                label: 'Preallocated Funds',
                property: 'preapprovedFunds',
                width: 250,
                sortable: true,
                sortProperty: 'PreapprovedFundsSelectedCurrency',
                editable: false,
                filterable: false,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: true,
                sortProperty: 'AllocatedAmountUSDHistorical',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApproved',
                type: 'mdf-amount',
                label: 'Funds Approved',
                property: 'fundsApproved',
                width: 250,
                sortable: true,
                sortProperty: 'ApprovedFundsUSD',
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsAllocationDate',
                type: 'full-date-time-due',
                label: 'Funds Allocation Date',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprovedDate',
                type: 'full-date-time-due',
                label: 'Funds Approved Date',
                property: 'fundsApprovedDate',
                width: 250,
                sortable: true,
                sortProperty: 'ApprovedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'stripeStatus',
                type: 'mdf-stripe-status',
                label: 'Stripe Status',
                property: 'connectedAccountStatus',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ]
    },

    getMDFReportManagementFundsPaidHeaderDefinitions() {
        return [
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'popSubmittedDate',
                type: 'full-date-time-due',
                label: 'Date Pop Submitted',
                property: 'popSubmittedDate',
                width: 250,
                sortable: true,
                sortProperty: 'PopSubmittedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'partner',
                type: 'client-account-name',
                label: 'Partner',
                property: 'client',
                width: 200,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'mdf-assign-user',
                label: 'Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'start',
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: true,
                sortProperty: 'AllocatedAmountUSDHistorical',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsPaid',
                type: 'mdf-amount',
                label: 'Funds Paid',
                property: 'fundsPaid',
                width: 250,
                sortable: true,
                sortProperty: 'PaidAmountUSD',
                editable: false,
                filterable: false,
            },
            {
                key: 'payFunds',
                type: 'mdf-pay-funds',
                label: 'Pay Funds',
                property: 'id',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundAllocationDate',
                type: 'full-date-time-due',
                label: 'Fund Allocation Date',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'FundAllocationDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprovedDate',
                type: 'full-date-time-due',
                label: 'Funds Approved Date',
                property: 'fundsApprovedDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsPaidDate',
                type: 'full-date-time-due',
                label: 'Funds Paid Date',
                property: 'fundsPaidDate',
                width: 250,
                sortable: true,
                sortProperty: 'PaidDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'registeredDeals',
                type: 'mdf-registered-deals',
                label: 'Registered Deals',
                property: 'registeredDeals',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'wonDeals',
                type: 'mdf-registered-deals',
                label: 'Won Deals',
                property: 'wonDeals',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'generatedRevenue',
                type: 'mdf-amount',
                label: 'Generated Revenue',
                property: 'generatedRevenue',
                width: 250,
                sortable: true,
                sortProperty: 'GeneratedRevenue',
                editable: false,
                filterable: false,
            },
            {
                key: 'roi',
                type: 'string',
                label: 'ROI',
                property: 'roi',
                width: 100,
                sortable: true,
                sortProperty: 'Roi',
                editable: false,
                filterable: false,
                className: 'centered',
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'stripeStatus',
                type: 'mdf-stripe-status',
                label: 'Stripe Status',
                property: 'connectedAccountStatus',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ]
    },

    getMDFReportManagementExpiredHeaderDefinitions() {
        return [
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'partner',
                type: 'client-account-name',
                label: 'Partner',
                property: 'client',
                width: 200,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'mdf-assign-user',
                label: 'Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'start',
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'preapprovedFunds',
                type: 'mdf-amount',
                label: 'Preallocated Funds',
                property: 'preapprovedFunds',
                width: 250,
                sortable: true,
                sortProperty: 'PreapprovedFundsSelectedCurrency',
                editable: false,
                filterable: false,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: true,
                sortProperty: 'AllocatedAmountUSDHistorical',
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundAllocationDate',
                type: 'full-date-time-due',
                label: 'Fund Allocation Date',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'expirationDate',
                type: 'full-date-time-due',
                label: 'Expiration Date',
                property: 'fundExpirationDate',
                width: 250,
                sortable: true,
                sortProperty: 'ExpirationDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'stripeStatus',
                type: 'mdf-stripe-status',
                label: 'Stripe Status',
                property: 'connectedAccountStatus',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ]
    },

    getMDFReportManagementDeniedHeaderDefinitions() {
        return [
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'partner',
                type: 'client-account-name',
                label: 'Partner',
                property: 'client',
                width: 200,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'mdf-assign-user',
                label: 'Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'start',
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfRequestDenial',
                type: 'full-date-time-due',
                label: 'Date Of Request Denial',
                property: 'dateDenied',
                width: 250,
                sortable: true,
                sortProperty: 'DeniedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'stripeStatus',
                type: 'mdf-stripe-status',
                label: 'Stripe Status',
                property: 'connectedAccountStatus',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ]
    },

    getMDFReportManagementPopDeniedHeaderDefinitions() {
        return [
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'popSubmittedDate',
                type: 'full-date-time-due',
                label: 'Date Pop Submitted',
                property: 'popSubmittedDate',
                width: 250,
                sortable: true,
                sortProperty: 'PopSubmittedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'partner',
                type: 'client-account-name',
                label: 'Partner',
                property: 'client',
                width: 200,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'mdf-assign-user',
                label: 'Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'start',
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'preapprovedFunds',
                type: 'mdf-amount',
                label: 'Preallocated Funds',
                property: 'preapprovedFunds',
                width: 250,
                sortable: true,
                sortProperty: 'PreapprovedFundsSelectedCurrency',
                editable: false,
                filterable: false,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: true,
                sortProperty: 'AllocatedAmountUSDHistorical',
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundAllocationDate',
                type: 'full-date-time-due',
                label: 'Fund Allocation Date',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundExpirationDate',
                type: 'full-date-time-due',
                label: 'Fund Expiration Date',
                property: 'fundExpirationDate',
                width: 250,
                sortable: true,
                sortProperty: 'ExpirationDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'popDeniedDate',
                type: 'full-date-time-due',
                label: 'Pop Denied Date',
                property: 'popDeniedDate',
                width: 250,
                sortable: true,
                sortProperty: 'PopDeniedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'stripeStatus',
                type: 'mdf-stripe-status',
                label: 'Stripe Status',
                property: 'connectedAccountStatus',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ]
    },

    getMDFAgencyBudgetHeaderDefinitions(){
        return [
            {
                key: 'title',
                type: 'string',
                label: 'Title',
                property: 'title',
                width: 300,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'budget',
                type: 'mdf-amount',
                label: 'Budget',
                property: 'budget',
                width: 200,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'fund-type',
                type: 'string',
                label: 'Fund Type',
                property: 'type',
                width: 150,
                className: 'centered',
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'visibility',
                type: 'switch',
                label: 'Budget Visible To Partners',
                property: 'visibility',
                width: 230,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'availability',
                type: 'full-date-time-due',
                label: 'Budget Availability Date',
                property: 'availability',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'expiration',
                type: 'full-date-time-due',
                label: 'Budget Expiration Date',
                property: 'expiration',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'created',
                type: 'full-date-time',
                label: 'Created',
                property: 'createdAt',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'last-modified',
                type: 'full-date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ]
    },

    getMDFAgencyActivityPOPHeaderDefinitions() {
        return [
            {
                key: 'activity',
                type: 'string',
                label: 'Activity Type',
                property: 'activity',
                width: 350,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'pop',
                type: 'mdf-pop-collection',
                label: 'Proof of Performance Requirements',
                property: 'pop',
                width: 350,
                sortable: false,
                editable: false,
            },
            {
                key: 'created',
                type: 'full-date-time',
                label: 'Created',
                property: 'createdAt',
                width: 350,
                sortable: false,
                editable: false,
            },
            {
                key: 'last-modified',
                type: 'full-date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 350,
                sortable: false,
                editable: false,
            },
        ]
    },

    getAgencyMDFPartnersHeaderDefinitions(){
        return [
            {
                key: 'agencyMdfPartnerName',
                type: 'agency-mdf-partner-name',
                label: 'Partner',
                property: 'partnerCompany',
                width: 300,
                sortable: true,
                sortProperty: 'PartnerName',
                editable: false,
                filterable: true,
            },
            {
                key: 'mdfActivities',
                type: 'mdf-activities',
                label: 'Mdf Activities',
                property: 'activities',
                width: 300,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'mdfEvents',
                type: 'mdf-amount',
                label: 'Mdf Events',
                property: 'mdfEvents',
                width: 300,
                sortable: true,
                sortProperty: 'MdfEvents',
                editable: false,
                filterable: false,
            },
            {
                key: 'preapprovedFunds',
                type: 'mdf-amount',
                label: 'Preapproved Amount',
                property: 'preapprovedFunds',
                width: 200,
                sortable: true,
                sortProperty: 'preapprovedFunds',
                editable: false,
                filterable: false,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested amount',
                property: 'requestedAmount',
                width: 200,
                sortable: true,
                sortProperty: 'RequestedAmount',
                editable: false,
                filterable: false,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocated',
                width: 200,
                sortable: true,
                sortProperty: 'AllocatedAmount',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsPaid',
                type: 'mdf-amount',
                label: 'Funds Paid',
                property: 'fundsPaid',
                width: 300,
                sortable: true,
                sortProperty: 'FundsPaid',
                editable: false,
                filterable: false,
            },

            {
                key: 'registeredDeals',
                type: 'mdf-partner-registered-deals',
                label: 'Registered Deals',
                property: 'registeredDeals',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },

            {
                key: 'wonDeals',
                type: 'mdf-partner-registered-deals',
                label: 'Won Deals',
                property: 'wonDeals',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },

            {
                key: 'generatedRevenue',
                type: 'mdf-amount',
                label: 'Generated Revenue',
                property: 'generatedRevenue',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },

            {
                key: 'roiMdf',
                type: 'string',
                label: 'Roi',
                property: 'roi',
                width: 200,
                sortable: true,
                sortProperty: 'Roi',
                editable: false,
                filterable: false,
                className: 'centered',
            },

            {
                key: 'accountManager',
                type: 'partners-assigned-users',
                label: 'Account Manager',
                property: 'accountManagers',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: true,
                filterable: false,
            },
        ]
    },

    getMDFClientPendingRequestDefinitions() {
        return [
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'vendor',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'vendor',
                width: 200,
                sortable: true,
                sortProperty: 'AgencyName',
                editable: false,
                filterable: false,
                className: 'overflow-name',
            },
            
            {
                key: 'contact',
                type: 'user',
                label: 'Request made By',
                property: 'requestMadeBy',
                width: 250,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: false,
                className:'centered',
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountSelectedCurrency',
                editable: false,
                filterable: false,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountSelectedCurrency',
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Event Date',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ]
    },

    getMDFDashboardPartnersHeaderDefinitions(){
        return [
            {
                key: 'agencyMdfPartnerName',
                type: 'agency-mdf-partner-name',
                label: 'Partner',
                property: 'partnerCompany',
                width: 300,
                sortable: true,
                sortProperty: 'PartnerName',
                editable: false,
                filterable: true,
            },
            {
                key: 'rank',
                type: 'ranking',
                label: 'Rank',
                property: 'rank',
                width: 150,
                sortable: true,
                sortProperty: 'Rank',
                editable: false,
                filterable: false,
            },
            {
                key: 'mdfActivities',
                type: 'mdf-activities',
                label: 'Mdf Activities',
                property: 'activities',
                width: 300,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested amount',
                property: 'requestedAmount',
                width: 200,
                sortable: true,
                sortProperty: 'RequestedAmount',
                editable: false,
                filterable: false,
            },
            {
                key: 'preapprovedFunds',
                type: 'mdf-amount',
                label: 'Preapproved Amount',
                property: 'preapprovedFunds',
                width: 200,
                sortable: true,
                sortProperty: 'PreapprovedAmount',
                editable: false,
                filterable: false,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocated',
                width: 200,
                sortable: true,
                sortProperty: 'AllocatedAmount',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsPaid',
                type: 'mdf-amount',
                label: 'Funds Paid',
                property: 'fundsPaid',
                width: 300,
                sortable: true,
                sortProperty: 'FundsPaid',
                editable: false,
                filterable: false,
            },
            {
                key: 'registeredDeals',
                type: 'mdf-partner-registered-deals',
                label: 'Registered Deals',
                property: 'registeredDeals',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'wonDeals',
                type: 'mdf-partner-registered-deals',
                label: 'Won Deals',
                property: 'wonDeals',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'generatedRevenue',
                type: 'mdf-amount',
                label: 'Generated Revenue',
                property: 'generatedRevenue',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'roiMdf',
                type: 'string',
                label: 'Roi',
                property: 'roi',
                width: 200,
                sortable: true,
                sortProperty: 'Roi',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'partners-assigned-users',
                label: 'Account Manager',
                property: 'accountManagers',
                width: 250,
                sortable: false,
                sortProperty: '',
                editable: true,
                filterable: false,
            },
        ]
    },

    getMDFPreapprovedFundsHeaderDefinitions(){
        return [
            {
                key: 'partnerCompany',
                type: 'agency-mdf-partner-name',
                label: 'Partner',
                property: 'partnerCompany',
                width: 300,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: true,
            },
            {
                key: 'preapprovedFundsTitle',
                type: 'string',
                label: 'Preallocated Funds Title',
                property: 'preapprovedFundsTitle',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'preapprovedFunds',
                type: 'mdf-amount',
                label: 'Preallocated Funds',
                property: 'preapprovedFunds',
                width: 200,
                sortable: true,
                sortProperty: 'PreapprovedAmountUSD',
                editable: false,
                filterable: false,
            },
            {
                key: 'remainingBalance',
                type: 'mdf-amount',
                label: 'Remaining Balance',
                property: 'remainingBalance',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'budget',
                type: 'string',
                label: 'Budget',
                property: 'budget',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundExpirationDate',
                type: 'full-date-time-due',
                label: 'Fund Expiration Date',
                property: 'fundExpirationDate',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'mdfActivities',
                type: 'mdf-activities',
                label: 'Mdf Activities',
                property: 'activities',
                width: 300,
                sortable: false,
                editable: false,
                filterable: false,
                description: 'View MDF requests made using preallocated funds'
            },
        ]
    },

    getMDFDashboardAllocationsHeaderDefinitions(){
        return [
            {
                key: 'agencyMdfPartnerName',
                type: 'agency-mdf-partner-name',
                label: 'Partner',
                property: 'partnerCompany',
                width: 300,
                sortable: true,
                sortProperty: 'PartnerName',
                editable: false,
                filterable: true,
            },
            {
                key: 'contact',
                type: 'mdf-assign-user',
                label: 'Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'start',
            },
            {
                key: 'status',
                type: 'mdf-status',
                label: 'Status',
                property: 'status',
                width: 200,
                sortable: true,
                sortProperty: 'Status',
                editable: false,
                filterable: true,
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'FundTitle',
                editable: false,
                filterable: true,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocated',
                width: 200,
                sortable: true,
                sortProperty: 'AllocatedAmount',
                editable: false,
                filterable: false,
            },
            {
                key: 'budgetName',
                type: 'string',
                label: 'Budget Name',
                property: 'budgetName',
                width: 250,
                sortable: true,
                sortProperty: 'BudgetName',
                editable: false,
                filterable: true,
            },
            {
                key: 'fundType',
                type: 'string',
                label: 'Fund Type',
                property: 'fundType',
                className:'centered',
                width: 250,
                sortable: true,
                sortProperty: 'FundType',
                editable: false,
                filterable: true,
            },
 
            {
                key: 'allocatedFundsFor',
                type: 'string',
                label: 'Allocated Funds For',
                property: 'allocatedFundsFor',
                width: 250,
                sortable: true,
                sortProperty: 'AllocatedFundsFor',
                editable: false,
                filterable: true,
            },
            {
                key: 'fundExpirationDate',
                type: 'full-date-time-due',
                label: 'Fund Expiration Date',
                property: 'fundExpirationDate',
                width: 250,
                sortable: true,
                sortProperty: 'ExpirationDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ]
    },

    getMDFAvailableVendorsHeaderDefinitions() {
        return [
            {
                key: 'vendor',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'Vendor',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'preapprovedFunds',
                type: 'mdf-amount',
                label: 'Preallocated Funds Available',
                property: 'PreapprovedFunds',
                width: 400,
                sortable: false,
                editable: false,
                filterable: false,
            },

            {
                key: 'isMdfAvailable',
                type: 'mdf-is-mdf-available',
                label: 'MDF Available?',
                property: 'MdfAvailable',
                width: 400,
                sortable: false,
                editable: false,
                filterable: false,
            },

            {
                key: 'isMarketingContentAvailable',
                type: 'mdf-is-mdf-available',
                label: 'Marketing Content Available',
                property: 'McAvailable',
                width: 400,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'action',
                type: 'mdf-apply',
                label: 'Action',
                property: 'Id',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ]
    },

    getMDFPartnerManagementHeaderDefinitions() {
        return [
            {
                key: 'vendor',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'vendor',
                width: 200,
                sortable: true,
                sortProperty: 'AgencyName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'user',
                label: 'Request made By',
                property: 'requestMadeBy',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'status',
                type: 'mdf-status',
                label: 'Status',
                property: 'status',
                width: 200,
                sortable: true,
                sortProperty: 'Status',
                editable: false,
                filterable: true,
            },
            {
                key: 'funds',
                type: 'global-category',
                label: 'Budgets Used',
                property: 'fundPools',
                width: 220,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'preapprovedFunds',
                type: 'mdf-amount',
                label: 'Preallocated Funds',
                property: 'preapprovedFunds',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountSelectedCurrency',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountSelectedCurrency',
                editable: false,
                filterable: true,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApproved',
                type: 'mdf-amount',
                label: 'Funds Approved',
                property: 'fundsApproved',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsPaid',
                type: 'mdf-amount',
                label: 'Funds Paid',
                property: 'fundsPaid',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundAllocationDate',
                type: 'full-date-time-due',
                label: 'Fund Allocation Date',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'dateDenied',
                type: 'full-date-time-due',
                label: 'Date Denied',
                property: 'dateDenied',
                width: 250,
                sortable: true,
                sortProperty: 'DeniedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundExpirationDate',
                type: 'full-date-time-due',
                label: 'Fund Expiration Date',
                property: 'fundExpirationDate',
                width: 250,
                sortable: true,
                sortProperty: 'ExpirationDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'popSubmittedDate',
                type: 'full-date-time-due',
                label: 'Pop Submitted Date',
                property: 'popSubmittedDate',
                width: 250,
                sortable: true,
                sortProperty: 'PopSubmittedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprovedDate',
                type: 'full-date-time-due',
                label: 'Funds Approved Date',
                property: 'fundsApprovedDate',
                width: 250,
                sortable: true,
                sortProperty: 'ApprovedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsPaidDate',
                type: 'full-date-time-due',
                label: 'Funds Paid Date',
                property: 'fundsPaidDate',
                width: 250,
                sortable: true,
                sortProperty: 'PaidDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'registeredDeals',
                type: 'mdf-registered-deals',
                label: 'Registered Deals',
                property: 'registeredDeals',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'wonDeals',
                type: 'mdf-registered-deals',
                label: 'Won Deals',
                property: 'wonDeals',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'generatedRevenue',
                type: 'mdf-amount',
                label: 'Generated Revenue',
                property: 'generatedRevenue',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'roi',
                type: 'string',
                label: 'ROI',
                property: 'roi',
                width: 100,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'centered',
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'paymentStatus',
                type: 'status',
                label: 'Payment Status',
                property: 'paymentStatus',
                width: 220,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'proofOfPayment',
                type: 'proof-of-payment',
                label: 'Proof of Payment',
                property: 'proofOfPayment',
                width: 220,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ]
    },

    getMDFPartnerManagementPendingHeaderDefinitions() {
        return [
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'vendor',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'vendor',
                width: 200,
                sortable: true,
                sortProperty: 'AgencyName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'funds',
                type: 'global-category',
                label: 'Budgets Used',
                property: 'fundPools',
                width: 220,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'contact',
                type: 'user',
                label: 'Request made By',
                property: 'requestMadeBy',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountSelectedCurrency',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountSelectedCurrency',
                editable: false,
                filterable: true,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ]
    },

    getMDFPartnerManagementFundsAllocatedHeaderDefinitions() {
        return [
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'vendor',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'vendor',
                width: 200,
                sortable: true,
                sortProperty: 'AgencyName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'funds',
                type: 'global-category',
                label: 'Budgets Used',
                property: 'fundPools',
                width: 220,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'contact',
                type: 'user',
                label: 'Request made By',
                property: 'requestMadeBy',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountSelectedCurrency',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountSelectedCurrency',
                editable: false,
                filterable: true,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundAllocationDate',
                type: 'full-date-time-due',
                label: 'Fund Allocation Date',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundExpirationDate',
                type: 'full-date-time-due',
                label: 'Fund Expiration Date',
                property: 'fundExpirationDate',
                width: 250,
                sortable: true,
                sortProperty: 'ExpirationDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Salesperson',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ]
    },

    getMDFPartnerManagementPopSubmittedHeaderDefinitions() {
        return [
            {
                key: 'requestDate',
                type: 'full-date-time-due',           
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'popSubmittedDate',
                type: 'full-date-time-due',
                label: 'Date Pop Submitted',
                property: 'popSubmittedDate',
                width: 250,
                sortable: true,
                sortProperty: 'PopSubmittedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'funds',
                type: 'global-category',
                label: 'Budgets Used',
                property: 'fundPools',
                width: 220,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'vendor',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'vendor',
                width: 200,
                sortable: true,
                sortProperty: 'AgencyName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'user',
                label: 'Request made By',
                property: 'requestMadeBy',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountSelectedCurrency',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountSelectedCurrency',
                editable: false,
                filterable: true,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Event Date',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'dateAllocated',
                type: 'full-date-time-due',
                label: 'Fund Allocation Date',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundExpirationDate',
                type: 'full-date-time-due',
                label: 'Fund Expiration Date',
                property: 'fundExpirationDate',
                width: 250,
                sortable: true,
                sortProperty: 'ExpirationDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ]
    },

    getMDFPartnerManagementFundsPendingPaymentHeaderDefinitions() {
        return [
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'popSubmittedDate',
                type: 'full-date-time-due',
                label: 'Date Pop Submitted',
                property: 'popSubmittedDate',
                width: 250,
                sortable: true,
                sortProperty: 'PopSubmittedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'funds',
                type: 'global-category',
                label: 'Budgets Used',
                property: 'fundPools',
                width: 220,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'vendor',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'vendor',
                width: 200,
                sortable: true,
                sortProperty: 'AgencyName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'user',
                label: 'Request made By',
                property: 'requestMadeBy',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountSelectedCurrency',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountSelectedCurrency',
                editable: false,
                filterable: true,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApproved',
                type: 'mdf-amount',
                label: 'Funds Approved',
                property: 'fundsApproved',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Event Date',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsAllocationDate',
                type: 'full-date-time-due',
                label: 'Fund Allocation Date',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprovedDate',
                type: 'full-date-time-due',
                label: 'Funds Approved Date',
                property: 'fundsApprovedDate',
                width: 250,
                sortable: true,
                sortProperty: 'ApprovedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ]
    },

    getMDFPartnerManagementFundsInTransitHeaderDefinitions() {
        return [
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'popSubmittedDate',
                type: 'full-date-time-due',
                label: 'Date Pop Submitted',
                property: 'popSubmittedDate',
                width: 250,
                sortable: true,
                sortProperty: 'PopSubmittedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'funds',
                type: 'global-category',
                label: 'Budgets Used',
                property: 'fundPools',
                width: 220,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'partner',
                type: 'client-account-name',
                label: 'Partner',
                property: 'client',
                width: 200,
                sortable: true,
                sortProperty: 'ClientName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'mdf-assign-user',
                label: 'Contact',
                property: 'contact',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'start',
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountUSD',
                editable: false,
                filterable: true,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: true,
                sortProperty: 'AllocatedAmountUSDHistorical',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsPaid',
                type: 'mdf-amount',
                label: 'Funds Paid',
                property: 'fundsPaid',
                width: 250,
                sortable: true,
                sortProperty: 'PaidAmountUSD',
                editable: false,
                filterable: false,
            },
            {
                key: 'paymentProcessing',
                type: 'string',
                label: 'Payment Processing',
                property: 'paymentProcessing',
                className: 'centered',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'paymentStatus',
                type: 'status',
                label: 'Payment Status',
                property: 'paymentStatus',
                width: 220,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'proofOfPayment',
                type: 'proof-of-payment',
                label: 'Proof of Payment',
                property: 'proofOfPayment',
                width: 220,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Date Of Activity',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundAllocationDate',
                type: 'full-date-time-due',
                label: 'Fund Allocation Date',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'FundAllocationDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprovedDate',
                type: 'full-date-time-due',
                label: 'Funds Approved Date',
                property: 'fundsApprovedDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsPaidDate',
                type: 'full-date-time-due',
                label: 'Funds Paid Date',
                property: 'fundsPaidDate',
                width: 250,
                sortable: true,
                sortProperty: 'PaidDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'registeredDeals',
                type: 'mdf-registered-deals',
                label: 'Registered Deals',
                property: 'registeredDeals',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'wonDeals',
                type: 'mdf-registered-deals',
                label: 'Won Deals',
                property: 'wonDeals',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'generatedRevenue',
                type: 'mdf-amount',
                label: 'Generated Revenue',
                property: 'generatedRevenue',
                width: 250,
                sortable: true,
                sortProperty: 'GeneratedRevenue',
                editable: false,
                filterable: false,
            },
            {
                key: 'roi',
                type: 'string',
                label: 'ROI',
                property: 'roi',
                width: 100,
                sortable: true,
                sortProperty: 'Roi',
                editable: false,
                filterable: false,
                className: 'centered',
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: true,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ]
    },

    getMDFPartnerManagementFundsPaidHeaderDefinitions() {
        return [
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'popSubmittedDate',
                type: 'full-date-time-due',
                label: 'Date Pop Submitted',
                property: 'popSubmittedDate',
                width: 250,
                sortable: true,
                sortProperty: 'PopSubmittedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'funds',
                type: 'global-category',
                label: 'Budgets Used',
                property: 'fundPools',
                width: 220,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'vendor',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'vendor',
                width: 200,
                sortable: true,
                sortProperty: 'AgencyName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'user',
                label: 'Request made By',
                property: 'requestMadeBy',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountSelectedCurrency',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountSelectedCurrency',
                editable: false,
                filterable: true,
            },
            {
                key: 'approvedAmount',
                type: 'mdf-amount',
                label: 'Approved Amount',
                property: 'fundsApproved',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsPaid',
                type: 'mdf-amount',
                label: 'Funds Paid',
                property: 'fundsPaid',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'paymentProcessing',
                type: 'string',
                label: 'Payment Processing',
                property: 'paymentProcessing',
                className: 'centered',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Event Date',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundAllocationDate',
                type: 'full-date-time-due',
                label: 'Fund Allocation Date',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsPaidDate',
                type: 'full-date-time-due',
                label: 'Funds Given Date',
                property: 'fundsPaidDate',
                width: 250,
                sortable: true,
                sortProperty: 'PaidDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'registeredDeals',
                type: 'mdf-registered-deals',
                label: 'Registered Deals',
                property: 'registeredDeals',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'wonDeals',
                type: 'mdf-registered-deals',
                label: 'Won Deals',
                property: 'wonDeals',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'generatedRevenue',
                type: 'mdf-amount',
                label: 'Generated Revenue',
                property: 'generatedRevenue',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'roi',
                type: 'string',
                label: 'ROI',
                property: 'roi',
                width: 100,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'centered',
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'paymentStatus',
                type: 'status',
                label: 'Payment Status',
                property: 'paymentStatus',
                width: 220,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'proofOfPayment',
                type: 'proof-of-payment',
                label: 'Proof of Payment',
                property: 'proofOfPayment',
                width: 220,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ]
    },

    getMDFPartnerManagementExpiredHeaderDefinitions() {
        return [
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'vendor',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'vendor',
                width: 200,
                sortable: true,
                sortProperty: 'AgencyName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'funds',
                type: 'global-category',
                label: 'Budgets Used',
                property: 'fundPools',
                width: 220,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'contact',
                type: 'user',
                label: 'Request made By',
                property: 'requestMadeBy',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountSelectedCurrency',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountSelectedCurrency',
                editable: false,
                filterable: true,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Event Date',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundAllocationDate',
                type: 'full-date-time-due',
                label: 'Fund Allocation Date',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'expirationDate',
                type: 'full-date-time-due',
                label: 'Fund Expiration Date',
                property: 'fundExpirationDate',
                width: 250,
                sortable: true,
                sortProperty: 'ExpirationDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ]
    },

    getMDFPartnerManagementDeniedHeaderDefinitions() {
        return [
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'vendor',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'vendor',
                width: 200,
                sortable: true,
                sortProperty: 'AgencyName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'funds',
                type: 'global-category',
                label: 'Budgets Used',
                property: 'fundPools',
                width: 220,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'contact',
                type: 'user',
                label: 'Request made By',
                property: 'requestMadeBy',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountSelectedCurrency',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountSelectedCurrency',
                editable: false,
                filterable: true,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Event Date',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfRequestDenial',
                type: 'full-date-time-due',
                label: 'Date Denied',
                property: 'dateDenied',
                width: 250,
                sortable: true,
                sortProperty: 'DeniedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Salesperson',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ]
    },

    getMDFPartnerManagementPopDeniedHeaderDefinitions() {
        return [
            {
                key: 'requestDate',
                type: 'full-date-time-due',
                label: 'Request Date',
                property: 'requestDate',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'popSubmittedDate',
                type: 'full-date-time-due',
                label: 'Date Pop Submitted',
                property: 'popSubmittedDate',
                width: 250,
                sortable: true,
                sortProperty: 'PopSubmittedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'funds',
                type: 'global-category',
                label: 'Budgets Used',
                property: 'fundPools',
                width: 220,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'vendor',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'vendor',
                width: 200,
                sortable: true,
                sortProperty: 'AgencyName',
                editable: false,
                filterable: true,
                className: 'overflow-name',
            },
            {
                key: 'contact',
                type: 'user',
                label: 'Request made By',
                property: 'requestMadeBy',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'activityType',
                type: 'string',
                label: 'Activity Type',
                property: 'activityType',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityType',
                editable: false,
                filterable: true,
            },
            {
                key: 'totalCostOfActivity',
                type: 'mdf-amount',
                label: 'Total Cost Of Activity',
                property: 'totalCostOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'TotalAmountSelectedCurrency',
                editable: false,
                filterable: true,
            },
            {
                key: 'requestedAmount',
                type: 'mdf-amount',
                label: 'Requested Amount',
                property: 'requestedAmount',
                width: 250,
                sortable: true,
                sortProperty: 'RequestedAmountSelectedCurrency',
                editable: false,
                filterable: true,
            },
            {
                key: 'amountAllocated',
                type: 'mdf-amount',
                label: 'Amount Allocated',
                property: 'amountAllocatedHistorical',
                width: 250,
                sortable: false,
                sortProperty: 'AllocatedAmountSelectedCurrencyHistorical',
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time-due',
                label: 'Event Date',
                property: 'dateOfActivity',
                width: 250,
                sortable: true,
                sortProperty: 'ActivityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundAllocationDate',
                type: 'full-date-time-due',
                label: 'Fund Allocation Date',
                property: 'fundAllocationDate',
                width: 250,
                sortable: true,
                sortProperty: 'AvailabilityDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'fundExpirationDate',
                type: 'full-date-time-due',
                label: 'Fund Expiration Date',
                property: 'fundExpirationDate',
                width: 250,
                sortable: true,
                sortProperty: 'ExpirationDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'popDeniedDate',
                type: 'full-date-time-due',
                label: 'Pop Denied Date',
                property: 'popDeniedDate',
                width: 250,
                sortable: true,
                sortProperty: 'PopDeniedDate',
                editable: false,
                filterable: false,
            },
            {
                key: 'accountManager',
                type: 'mdf-assign-user',
                label: 'Account Manager',
                property: 'accountManager',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'fundsApprover',
                type: 'mdf-assign-user',
                label: 'Funds Approver',
                property: 'fundsApprover',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'viewDetails',
                type: 'mdf-details',
                label: 'View Details',
                property: 'id',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ]
    },

    getCustomInsertTagsHeaderDefinitions(){
        return [
            {
                key: 'custom-tag',
                type: 'string',
                label: 'Custom Tags',
                property: 'name',
                width: 900,
                sortable: true,
                sortProperty: 'name',
                editable: false,
                filterable: false
            }
        ]
    },

    getHeadersPageHeaderDefinitions() {
        return [
            {
                key: 'header-name',
                type: 'header-footer-name',
                label: 'Header Name',
                property: 'header',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'more-details',
                type: 'header-footer-details',
                label: 'More Details',
                property: 'header',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'created-date',
                type: 'date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'updated-date',
                type: 'date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 250,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
        ];
    },

    getHeadersSharedHeaderDefinitions() {
        return [
            {
                key: 'header-name',
                type: 'header-footer-shared-name',
                label: 'Header Name',
                property: 'header',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'more-details',
                type: 'header-footer-details',
                label: 'More Details',
                property: 'header',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'agency',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'vendor',
                width: 250,
                sortable: true,
                sortProperty: 'Agency/Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'created-date',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 270,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'updated-date',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 270,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
        ];
    },

    getHeadersSubscriptionHeaderDefinitions() {
        return [
            {
                key: 'header-name',
                type: 'header-footer-shared-name',
                label: 'Header Name',
                property: 'header',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'more-details',
                type: 'header-footer-details',
                label: 'More Details',
                property: 'header',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'created-date',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 270,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'updated-date',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 270,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
        ];
    },

    getHeadersAgencyPublishedHeaderDefinitions() {
        return [
            {
                key: 'form-name',
                type: 'header-footer-name',
                label: 'Header Template Name',
                property: 'header',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'more-details',
                type: 'header-footer-details',
                label: 'More Details',
                property: 'header',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'autoPublished',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'clientsPublished',
                type: 'client-published',
                label: 'Partners Published To',
                property: 'asset',
                width: 120,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'publishedDate',
                type: 'full-date-time',
                label: 'Published Date',
                property: 'publishedAt',
                width: 270,
                sortable: true,
                sortProperty: 'PublishedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 270,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 270,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'landing-pages-using-it',
                type: 'number',
                label: 'Landing Pages Using It',
                property: 'landingPagesUsingIt',
                width: 120,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ];
    },

    getHeadersAgencyUnpublishedHeaderDefinitions(){
        return [
            {
                key: 'form-name',
                type: 'header-footer-name',
                label: 'Header Template Name',
                property: 'header',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'more-details',
                type: 'header-footer-details',
                label: 'More Details',
                property: 'header',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'autoPublished',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 270,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 270,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
        ];
    },

    getHeadersOrganizationPublishedPageHeaderDefinitions(){
        return [
            {
                key: 'form-name',
                type: 'header-footer-name',
                label: 'Header Template Name',
                property: 'header',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'more-details',
                type: 'header-footer-details',
                label: 'More Details',
                property: 'header',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'plans-published',
                type: 'number',
                label: 'Plans Published To',
                property: 'plansPublishedTo',
                width: 120,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 270,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 270,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'landing-pages-using-it',
                type: 'number',
                label: 'Landing Pages Using It',
                property: 'landingPagesUsingIt',
                width: 120,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ];
    },

    getHeadersOrganizationUnpublishedPageHeaderDefinitions(){
        return [
            {
                key: 'form-name',
                type: 'header-footer-name',
                label: 'Header Template Name',
                property: 'header',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'more-details',
                type: 'header-footer-details',
                label: 'More Details',
                property: 'header',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 270,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 270,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
        ];
    },

    getFootersPageHeaderDefinitions() {
        return [
            {
                key: 'footer-name',
                type: 'header-footer-name',
                label: 'Footer Name',
                property: 'footer',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'more-details',
                type: 'header-footer-details',
                label: 'More Details',
                property: 'footer',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'created-date',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 250,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'updated-date',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 250,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
        ];
    },

    getFootersSharedPageHeaderDefinitions() {
        return [
            {
                key: 'footer-name',
                type: 'header-footer-shared-name',
                label: 'Footer Name',
                property: 'footer',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'more-details',
                type: 'header-footer-details',
                label: 'More Details',
                property: 'footer',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'agency',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'vendor',
                width: 250,
                sortable: true,
                sortProperty: 'Agency/Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'created-date',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 270,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'updated-date',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 270,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
        ];
    },

    getFootersSubscriptionPageHeaderDefinitions() {
        return [
            {
                key: 'footer-name',
                type: 'header-footer-shared-name',
                label: 'Footer Name',
                property: 'footer',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'more-details',
                type: 'header-footer-details',
                label: 'More Details',
                property: 'footer',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'created-date',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 270,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'updated-date',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 270,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
        ];
    },

    getFootersAgencyPublishedHeaderDefinitions(){
        return [
            {
                key: 'form-name',
                type: 'header-footer-name',
                label: 'Footer Template Name',
                property: 'footer',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'more-details',
                type: 'header-footer-details',
                label: 'More Details',
                property: 'footer',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'autoPublished',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'clientsPublished',
                type: 'client-published',
                label: 'Partners Published To',
                property: 'asset',
                width: 120,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'publishedDate',
                type: 'full-date-time',
                label: 'Published Date',
                property: 'publishedAt',
                width: 270,
                sortable: true,
                sortProperty: 'PublishedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 270,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 270,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'landing-pages-using-it',
                type: 'number',
                label: 'Landing Pages Using It',
                property: 'landingPagesUsingIt',
                width: 120,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ];
    },

    getFootersAgencyUnpublishedHeaderDefinitions(){
        return [
            {
                key: 'form-name',
                type: 'header-footer-name',
                label: 'Footer Template Name',
                property: 'footer',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'more-details',
                type: 'header-footer-details',
                label: 'More Details',
                property: 'footer',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'auto-publish',
                type: 'auto-publish-button',
                label: 'Auto Publish',
                property: 'autoPublished',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 270,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 270,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
        ];
    },

    getFootersOrganizationPublishedPageHeaderDefinitions(){
        return [
            {
                key: 'form-name',
                type: 'header-footer-name',
                label: 'Footer Template Name',
                property: 'footer',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'more-details',
                type: 'header-footer-details',
                label: 'More Details',
                property: 'footer',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'plans-published',
                type: 'number',
                label: 'Plans Published To',
                property: 'plansPublishedTo',
                width: 120,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 270,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 270,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'landing-pages-using-it',
                type: 'number',
                label: 'Landing Pages Using It',
                property: 'landingPagesUsingIt',
                width: 120,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ];
    },

    getFootersOrganizationUnpublishedPageHeaderDefinitions(){
        return [
            {
                key: 'form-name',
                type: 'header-footer-name',
                label: 'Footer Template Name',
                property: 'footer',
                width: 300,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'more-details',
                type: 'header-footer-details',
                label: 'More Details',
                property: 'footer',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'full-date-time',
                label: 'Created Date',
                property: 'createdAt',
                width: 270,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'modifiedDate',
                type: 'full-date-time',
                label: 'Last Modified Date',
                property: 'updatedAt',
                width: 270,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'category',
                type: 'global-category',
                label: 'Categories',
                property: 'categories',
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
        ];
    },

    getPartnerSurveyPublishedHeaderDefinitions() {
        return [
            {
                key: 'title',
                type: 'partner-survey-name',
                label: 'Title',
                property: 'partnerSurvey',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'autoPublish',
                type: 'auto-publish-button',
                label: 'Status',
                property: 'autoPublished',
                width: 160,
                sortable: true,
                sortProperty: 'IsAutoPublished',
                editable: false,
                filterable: false,
            },
            {
                key: 'completionRate',
                type: 'completion',
                label: 'Completion Rate',
                property: 'completionRate',
                width: 150,
                sortable: true,
                sortProperty: 'CompletionRate',
                editable: false,
                filterable: false,
            },
            {
                key: 'avgTime',
                type: 'timer',
                label: 'Avg Time',
                property: 'avgTime',
                width: 100,
                sortable: true,
                sortProperty: 'AvgTime',
                editable: false,
                filterable: false,
            },
            {
                key: 'clientsPublished',
                type: 'client-published',
                label: 'Partners Published To',
                property: 'asset',
                width: 200,
                sortable: false,
                sortProperty: '',
                editable: false,
                filterable: false,
            },
            {
                key: 'lastModified',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 280,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'date-time',
                label: 'Creation Date',
                property: 'createdAt',
                width: 280,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
        ]
    },

    getPartnerSurveyUnpublishedHeaderDefinitions() {
        return [
            {
                key: 'title',
                type: 'partner-survey-name',
                label: 'Title',
                property: 'partnerSurvey',
                width: 250,
                sortable: true,
                sortProperty: 'Name',
                editable: false,
                filterable: true,
            },
            {
                key: 'autoPublish',
                type: 'auto-publish-button',
                label: 'Status',
                property: 'autoPublished',
                width: 160,
                sortable: true,
                sortProperty: 'IsAutoPublished',
                editable: false,
                filterable: false,
            },
            {
                key: 'completionRate',
                type: 'completion',
                label: 'Completion Rate',
                property: 'completionRate',
                width: 150,
                sortable: true,
                sortProperty: 'CompletionRate',
                editable: false,
                filterable: false,
            },
            {
                key: 'avgTime',
                type: 'timer',
                label: 'Avg Time',
                property: 'avgTime',
                width: 100,
                sortable: true,
                sortProperty: 'AvgTime',
                editable: false,
                filterable: false,
            },
            {
                key: 'lastModified',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 280,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'createdDate',
                type: 'date-time',
                label: 'Creation Date',
                property: 'createdAt',
                width: 280,
                sortable: true,
                sortProperty: 'CreatedAt',
                editable: false,
                filterable: false,
            },
        ]
    },

    getPartnerSurveyHeaderDefinitions() {
        return [
            {
                key: 'title',
                type: 'partner-survey-name-client',
                label: 'Title',
                property: 'partnerSurvey',
                width: 250,
                sortable: true,
                sortProperty: 'Title',
                editable: false,
                filterable: false,
            },
            {
                key: 'vendor',
                type: 'vendor-name',
                label: 'Vendor',
                property: 'vendor',
                width: 250,
                sortable: false,
                sortProperty: 'AgencyName',
                editable: false,
                filterable: false,
            },            
            {
                key: 'status',
                type: 'status',
                label: 'Status',
                property: 'status',
                width: 200,
                sortable: false,
                sortProperty: 'Status',
                editable: false,
                filterable: false,
            },            
            {
                key: 'completionRate',
                type: 'completion',
                label: 'Completion Rate',
                property: 'completionRate',
                width: 150,
                sortable: true,
                sortProperty: 'CompletionRate',
                editable: false,
                filterable: false,
            },
            {
                key: 'lastModified',
                type: 'date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 280,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
        ]
    },

    getPartnerSurveysHeaderDefinition() {
        return [
            {
                key: 'partnerName',
                type: 'client-name',
                label: 'Name',
                property: 'partnerName', 
                width: 250,
                sortable: true,
                sortProperty: 'Partner,Name',
                editable: false,
                filterable: false,
            },
            {
                key: 'details',
                type: 'details',
                label: 'Survey Responses',
                property: 'id',
                width: 250,
                sortable: false,
                editable: false,
                filterable: false,
                cellLabel: 'Survey Response',
            },
            {
                key: 'survey-status',
                type: 'status',
                label: 'Status',
                property: 'status',
                width: 180,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'completion-rate',
                type: 'completion',
                label: 'Completion Rate',
                property: 'completionRate',
                width: 170,
                sortable: true,
                sortProperty: 'CompletionRate',
                editable: false,
                filterable: false,
            },
            {
                key: 'time-spent',
                type: 'string',
                label: 'Time Spent',
                property: 'timeSpent',
                width: 130,
                sortable: true,
                sortProperty: 'AVGTime',
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time',
                label: 'Last Modified',
                property: 'updatedAt',
                width: 250,
                sortable: true,
                sortProperty: 'UpdatedAt',
                editable: false,
                filterable: false,
            },
            {
                key: 'partner-assigned-users',
                type: 'partners-assigned-users',
                label: 'Assigned Users',
                property: 'assignedUsers',
                width: 250,
                sortable: false,
                sortProperty: null,
                editable: true,
                filterable: true,
            },
        ]    
    },

    getVendorEmailTemplateBuildHeaderDefinitions() {
        return [
          {
            key: 'name',
            type: 'email-template-name',
            label: 'Name',
            property: 'template',
            width: 400,
            sortable: true,
            sortProperty: 'Name',
            editable: true,
            filterable: false,
          },
          {
            key: 'auto-publish',
            type: 'auto-publish-button',
            label: 'Auto Publish',
            property: 'autoPublished',
            width: 200,
            sortable: true,
            sortProperty: 'IsAutoPublished',
            editable: false,
            filterable: false,
          },
          {
            key: 'categories',
            type: 'global-category',
            label: 'Category',
            property: 'categories',
            width: 250,
            sortable: false,
            editable: false,
            filterable: true,
          },
          {
            key: 'created',
            type: 'date-time',
            label: 'Created',
            property: 'createdAt',
            width: 200,
            sortable: true,
            sortProperty: 'CreatedAt',
            editable: false,
            filterable: false,
          },
          {
            key: 'emails-sent',
            type: 'string',
            label: 'Emails Sent',
            property: 'timesUsed',
            width: 200,
            sortable: true,
            sortProperty: 'TimesUsed',
            editable: false,
            filterable: false,
          },
          {
            key: 'opens',
            type: 'completion',
            label: 'Avg Open',
            property: 'openRate',
            width: 200,
            sortable: true,
            sortProperty: 'OpenRate',
            editable: false,
            filterable: false,
          },
          {
            key: 'clicks',
            type: 'completion',
            label: 'Avg Click',
            property: 'clickRate',
            width: 200,
            sortable: true,
            sortProperty: 'ClickRate',
            editable: false,
            filterable: false,
          },
          {
            key: 'clientsPublished',
            type: 'client-published',
            label: 'Clients Published To',
            property: 'asset',
            width: 120,
            sortable: false,
            editable: false,
            filterable: false,
          },
        ];
      },

      getVendorEmailTemplateUnpublishedBuildHeaderDefinitions() {
        return [
          {
            key: 'name',
            type: 'email-template-name',
            label: 'Name',
            property: 'template',
            width: 400,
            sortable: true,
            sortProperty: 'Name',
            editable: true,
            filterable: false,
          },
          {
            key: 'auto-publish',
            type: 'auto-publish-button',
            label: 'Auto Publish',
            property: 'autoPublished',
            width: 200,
            sortable: true,
            sortProperty: 'IsAutoPublished',
            editable: false,
            filterable: false,
          },
          {
            key: 'categories',
            type: 'global-category',
            label: 'Category',
            property: 'categories',
            width: 250,
            sortable: false,
            editable: false,
            filterable: true,
          },
          {
            key: 'created',
            type: 'date-time',
            label: 'Created',
            property: 'createdAt',
            width: 200,
            sortable: true,
            sortProperty: 'CreatedAt',
            editable: false,
            filterable: false,
          },
          {
            key: 'emails-sent',
            type: 'string',
            label: 'Emails Sent',
            property: 'timesUsed',
            width: 200,
            sortable: true,
            sortProperty: 'TimesUsed',
            editable: false,
            filterable: false,
          },
          {
            key: 'opens',
            type: 'completion',
            label: 'Avg Open',
            property: 'openRate',
            width: 200,
            sortable: true,
            sortProperty: 'OpenRate',
            editable: false,
            filterable: false,
          },
          {
            key: 'clicks',
            type: 'completion',
            label: 'Avg Click',
            property: 'clickRate',
            width: 200,
            sortable: true,
            sortProperty: 'ClickRate',
            editable: false,
            filterable: false,
          },
        ];
      },

    getSimpleBoardHeaderDefinition() {
        return [
            {
                key: 'partnerName',
                type: 'client-name',
                label: 'Company Name',
                property: 'company', 
                width: 244,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'answers',
                type: 'string',
                label: 'Answers',
                property: 'answer',
                width: 600,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time',
                label: 'Date',
                property: 'date',
                width: 300,
                sortable: false,
                editable: false,
                filterable: false,
            },
           
        ]    
    },

    getReportSolutionHeaders() {
        return [
            {
                key: 'name',
                type: 'client-solutions-name',
                label: 'Name',
                property: 'solution',
                sortProperty: 'Name',
                width: 300,
                sortable: true,
                editable: false,
                filterable: false,
            },
            {
                key: 'soldMrr',
                type: 'currency',
                label: 'Current MRR',
                property: 'soldMrr',
                sortProperty: 'SoldMRR',
                width: 300,
                sortable: true,
                editable: false,
                filterable: false,
            },
            {
                key: 'potentialMrr',
                type: 'currency-pink',
                label: 'Potential MRR',
                property: 'potentialMrr', 
                sortProperty: 'PotentialMRR',
                width: 244,
                sortable: true,
                editable: false,
                filterable: false,
            },  
            {
                key: 'soldCompanies',
                type: 'number',
                label: 'Companies w/ Solutions',
                property: 'soldCompanies', 
                sortProperty: 'SoldCompanies',
                width: 244,
                sortable: true,
                editable: false,
                filterable: false,
            }, 
            {
                key: 'potentialCompanies',
                type: 'number',
                label: 'Companies w/o Solutions',
                property: 'potentialCompanies',
                sortProperty: 'PotentialCompanies',
                width: 244,
                sortable: true,
                editable: false,
                filterable: false,
            }, 
            {
                key: 'soldCompaniesPercent',
                type: 'donut-chart',
                label: '% Companies w/ Solutions',
                property: 'soldCompaniesPercent', 
                sortProperty: 'SoldCompaniesPercent',
                width: 244,
                sortable: true,
                editable: false,
                filterable: false,
            },                
        ]    
    },

    getReportCompanyHeaders() {
        return [
            {
                key: 'Name',
                type: 'client-solutions-name',
                label: 'Name',
                property: 'company',
                sortProperty: 'Name',
                width: 300,
                sortable: true,
                editable: false,
                filterable: true,
            },
            {
                key: 'SoldMRR',
                type: 'currency',
                label: 'Current MRR',
                property: 'SoldMRR',
                sortProperty: 'SoldMRR',
                width: 300,
                sortable: true,
                editable: false,
                filterable: true,
            },
            {
                key: 'PotentialMRR',
                type: 'currency-pink',
                label: 'Potential MRR',
                property: 'PotentialMRR', 
                sortProperty: 'PotentialMRR',
                width: 244,
                sortable: true,
                editable: false,
                filterable: true,
            },  
            {
                key: 'SoldSolutions',
                type: 'number',
                label: 'Sold Solutions',
                property: 'SoldSolutions', 
                sortProperty: 'SoldSolutions',
                width: 244,
                sortable: true,
                editable: false,
                filterable: true,
            }, 
            {
                key: 'PotentialSolutions',
                type: 'number',
                label: 'Unsold Solutions',
                property: 'PotentialSolutions', 
                sortProperty: 'PotentialSolutions',
                width: 244,
                sortable: true,
                editable: false,
                filterable: true,
            }, 
            {
                key: 'SoldSolutionsPercent',
                type: 'donut-chart',
                label: 'Percent of Solutions Sold',
                property: 'SoldSolutionsPercent', 
                sortProperty: 'SoldSolutionsPercent',
                width: 244,
                sortable: true,
                editable: false,
                filterable: true,
            },                
        ]    
    },

    getAppointmentRequestHeaders() {
        return [
            {
                key: 'RequestId',
                type: 'number',
                label: 'Id',
                property: 'requestId', 
                sortProperty: 'Id',
                width: 150,
                sortable: true,
                editable: false,
                filterable: true,
            },
            {
                key: 'Name',
                type: 'string',
                label: 'Request Name',
                property: 'name',
                sortProperty: 'Name',
                width: 300,
                sortable: true,
                editable: false,
                filterable: false,
            },
            {
                key: 'CreatedAt',
                type: 'full-date-time-due',
                label: 'Date Created',
                property: 'createdAt',
                sortProperty: 'CreatedAt',
                width: 200,
                sortable: true,
                editable: false,
                filterable: true,
            },
            {
                key: 'AppointmentsRequested',
                type: 'number',
                label: 'Appointments Requested',
                property: 'quantity', 
                sortProperty: 'quantity',
                width: 244,
                sortable: true,
                editable: false,
                filterable: true,
            }, 
            {
                key: 'AudienceExpansion',
                type: 'completion-indicator',
                label: 'Audience Expansion',
                property: 'audienceExpansion', 
                sortProperty: 'AudienceExpansion',
                width: 244,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'excludedContactLists',
                type: 'contact-lists',
                label: 'Do Not Call',
                property: 'excludedContactLists',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
            }, 
            {
                key: 'SubtotalUSD',
                type: 'currency',
                label: 'Subtotal',
                property: 'subtotalUSD',
                sortProperty: 'PaymentSubtotalUSD',
                width: 200,
                sortable: true,
                editable: false,
                filterable: true,
            },
            {
                key: 'TotalUSD',
                type: 'currency',
                label: 'Total Payment',
                property: 'totalUSD',
                sortProperty: 'PaymentTotalUSD',
                width: 200,
                sortable: true,
                editable: false,
                filterable: true,
            },
            {
                key: 'more-details',
                type: 'appointment-request-details',
                label: 'Details',
                property: 'header',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ]  
    },

    getExitSurveyHeaders() {
        return [
            {
                key: 'Name',
                type: 'client-name',
                label: 'Name',
                property: 'accountName',
                sortProperty: 'AccountName',
                width: 300,
                sortable: true,
                editable: false,
                filterable: false,
            },
            {
                key: 'VendorSubscription',
                type: 'completion-indicator',
                label: 'Active Billing',
                property: 'vendorSubscription', 
                sortProperty: 'VendorSubscription',
                width: 150,
                sortable: true,
                editable: false,
                filterable: false,
                description: 'Billing is taken care of by a vendor',
            },
            {
                key: 'AccountUserCount',
                type: 'number',
                label: 'Number of Users',
                property: 'accountUserCount', 
                sortProperty: 'AccountUserCount',
                width: 100,
                sortable: true,
                editable: false,
                filterable: true,
            },
            {
                key: 'AccountTotalPaid',
                type: 'currency',
                label: 'Total Paid',
                property: 'accountTotalPaid',
                sortProperty: 'AccountTotalPaid',
                width: 175,
                sortable: true,
                editable: false,
                filterable: true,
            },
            {
                key: 'AccountCreatedAt',
                type: 'day-date',
                label: 'Account Created',
                property: 'accountCreatedAt',
                sortProperty: 'AccountCreatedAt',
                width: 200,
                sortable: true,
                editable: false,
                filterable: true,
            },
            {
                key: 'AccountCancelledAt',
                type: 'day-date',
                label: 'Cancelation Date',
                property: 'accountCancelledAt',
                sortProperty: 'AccountCancelledAt',
                width: 200,
                sortable: true,
                editable: false,
                filterable: true,
            },
            {
                key: 'SubscriptionActive',
                type: 'completion-indicator',
                label: 'Subscription Active',
                property: 'subscriptionActive', 
                sortProperty: 'SubscriptionActive',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'Location',
                type: 'string',
                label: 'Location',
                property: 'location', 
                sortProperty: 'Location',
                width: 244,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'AccountWebsite',
                type: 'company-website',
                label: 'Website',
                property: 'accountWebsite', 
                sortProperty: 'AccountWebsite',
                width: 244,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'more-details',
                type: 'exit-survey-details',
                label: 'Details',
                property: 'header',
                width: 180,
                sortable: false,
                editable: false,
                filterable: false,
            },
        ]  
    },

    getSimpleBoardFileHeaderDefinition() {
        return [
            {
                key: 'partnerName',
                type: 'client-name',
                label: 'Company Name',
                property: 'company', 
                width: 244,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'files',
                type: 'file',
                label: 'Answers',
                property: 'files',
                width: 600,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'dateOfActivity',
                type: 'full-date-time',
                label: 'Date',
                property: 'date',
                width: 300,
                sortable: false,
                editable: false,
                filterable: false,
            },
           
        ]    
    },

    getTransactionsHeaderDefinition() {
        return [
            {
                key: 'partner',
                type: 'client-name',
                label: 'Partner',
                property: 'partner', 
                width: 250,
                sortable: false,
                editable: false,
                filterable: true,
            },
            {
                key: 'fundType',
                type: 'global-category',
                label: 'Type',
                property: 'fundType', 
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'centered'
            },
            {
                key: 'totalAmount',
                type: 'currency-two-decimals',
                label: 'Total',
                property: 'totalAmount',
                sortProperty: 'TotalAmount',
                width: 150,
                sortable: true,
                editable: false,
                filterable: true,
            },
            {
                key: 'paymentToPartner',
                type: 'currency-two-decimals',
                label: 'Payment to Partner',
                property: 'paymentToPartner',
                sortProperty: 'paymentToPartner',
                width: 150,
                sortable: true,
                editable: false,
                filterable: true,
            },
            {
                key: 'serviceFee',
                type: 'currency-two-decimals',
                label: 'Service Fee',
                property: 'serviceFee',
                sortProperty: 'serviceFee',
                width: 150,
                sortable: true,
                editable: false,
                filterable: true,
            },
            {
                key: 'processingFee',
                type: 'currency-two-decimals',
                label: 'Processing Fee',
                property: 'processingFee',
                sortProperty: 'processingFee',
                width: 150,
                sortable: true,
                editable: false,
                filterable: true,
            },
            {
                key: 'confirmationId',
                type: 'string',
                label: 'Confirmation Id',
                property: 'confirmationId',
                width: 150,
                sortable: false,
                editable: false,
                filterable: false,
                className: 'centered'
            },
            {
                key: 'transactionDate',
                type: 'full-date-time-due',
                label: 'Transaction Date',
                property: 'transactionDate',
                sortProperty: 'TransactionDate',
                width: 300,
                sortable: true,
                editable: false,
                filterable: false,
            },
           
        ]    
    },

    getPaymentsReceivedHeaderDefinitions(){
        return [
            {
                key: 'fundTitle',
                type: 'string',
                label: 'Fund Title',
                property: 'fundTitle',
                width: 250,
                sortable: true,
                sortProperty: 'FundTitle',
                editable: false,
                filterable: true,
            },
            {
                key: 'receivedFrom',
                type: 'vendor-name',
                label: 'Received From',
                property: 'receivedFrom',
                sortProperty: 'AgencyName',
                width: 300,
                sortable: true,
                editable: false,
                filterable: false,
            },
            {
                key: 'transactionDate',
                type: 'full-date-time-due',
                label: 'Transaction Date',
                property: 'transactionDate',
                sortProperty: 'CreatedAt',
                width: 200,
                sortable: true,
                editable: false,
                filterable: false,
            },
            {
                key: 'transactionTotal',
                type: 'currency-two-decimals',
                label: 'Transaction Total',
                property: 'transactionTotal',
                sortProperty: 'BaseFee',
                width: 180,
                sortable: true,
                editable: false,
                filterable: true,
            },
            {
                key: 'fundType',
                type: 'global-category',
                label: 'Fund Type',
                property: 'fundType',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
                className:'centered'
            },
            {
                key: 'paymentMethod',
                type: 'string',
                label: 'Payment Method',
                property: 'paymentMethod',
                width: 200,
                sortable: false,
                editable: false,
                filterable: false,
                className:'centered'
            },
            {
                key: 'paymentStatus',
                type: 'status',
                label: 'Payment Status',
                property: 'paymentStatus',
                width: 220,
                sortable: false,
                editable: false,
                filterable: false,
            },
            {
                key: 'proofOfPayment',
                type: 'proof-of-payment',
                label: 'Proof of Payment',
                property: 'proofOfPayment',
                width: 220,
                sortable: false,
                editable: false,
                filterable: false,
            }
        ]
    },

    getDefaultViewHeaders(headerDefinitions) {
        return headerDefinitions.map((h) => {
            return {
                key: h.key,
                pinned: false,
                visible: true,
            };
        });
    },

    getBoardIconByName(name) {
        return this.getBoardIcons().find((icon) => icon.name === name);
    },

    getBoardIcons() {
        return [
            { group: 1, name: 'home', svg: 'g24-home-outline-svg' },
            { group: 1, name: 'hot', svg: 'a18-hot-outline-svg' },
            { group: 1, name: 'warm', svg: 'b18-warm-outline-svg' },
            { group: 1, name: 'cold', svg: 'c18-cold-outline-svg' },
            { group: 1, name: 'star', svg: 'h5-activity-outline-svg' },
            { group: 1, name: 'stars', svg: 'j5-leads-outline-svg' },
            { group: 2, name: 'sales', svg: 'u2-sales-outline-svg' },
            { group: 2, name: 'win', svg: 'd2-sales-team-outline-svg' },
            { group: 2, name: 'deal', svg: 'b5-opportunities-outline-svg' },
            { group: 2, name: 'client', svg: 'b2-clients-outline-svg' },
            { group: 2, name: 'meeting', svg: 'c5-meetings-outline-svg' },
            { group: 2, name: 'contact', svg: 'j2-contacts-outline-svg' },
            { group: 2, name: 'money', svg: 'f2-sales-outline-svg' },
            { group: 3, name: 'marketing', svg: 'a2-marketing-outline-svg' },
            { group: 3, name: 'funnel', svg: 's2-open-opportunities-outline-svg' },
            { group: 3, name: 'report', svg: 'e2-reports-outline-svg' },
            { group: 3, name: 'company', svg: 'g2-companies-outline-svg' },
            { group: 3, name: 'gauge', svg: 'h2-dashboard-outline-svg' },
            { group: 3, name: 'announcement', svg: 'm18-announcements-outline-svg' },
            { group: 4, name: 'email', svg: 'k5-email-outline-svg' },
            { group: 4, name: 'conversation', svg: 'p21-conversations-outline-svg' },
            { group: 4, name: 'message', svg: 'f5-notes-outline-svg' },
            { group: 4, name: 'sms', svg: 'l5-sms-outline-svg' },
            { group: 4, name: 'call', svg: 'g5-call-outline-svg' },
            { group: 4, name: 'task', svg: 't2-tasks-outline-svg' },
            { group: 4, name: 'stop', svg: 'n13-pan-tool-gray-svg' },
            { group: 4, name: 'schedule', svg: 'o2-schedule-outline-svg' },
            { group: 5, name: 'training', svg: 'n21-training-outline-svg' },
            { group: 5, name: 'search', svg: 'm5-search-outline-svg' },
            { group: 5, name: 'library', svg: 'r21-library-outline-svg' },
            { group: 5, name: 'form', svg: 'l2-form-submissions-outline-svg' },
            { group: 6, name: 'revenue', svg: 'c6-lifetime-revenue-won-outline-svg' },
            { group: 6, name: 'leads', svg: 'b6-company-leads-outline-svg' },
            { group: 6, name: 'cycle', svg: 'a6-avg-sales-cycle-days-svg' },
            { group: 6, name: 'lock', svg: 'q2-lock-outline-svg' },
            { group: 6, name: 'integration', svg: 'c2-integrations-outline-svg' },
        ];
    },

    getCustomFieldTypeByBoardType(type){
        var boardType = type.toLowerCase();

        var contactBoardTypes = ['contact-company', 'contact-assigned', 'leads', 'lead', 'list-details', 'contact'];
        var isContactBoard = contactBoardTypes.includes(boardType);
        if(isContactBoard){
            return 'Contact';
        }

        var agencyPartnerBoardTypes = ['agency-partner', 'agencyclient'];
        var isAgencyPartnerBoard = agencyPartnerBoardTypes.includes(boardType);   
        if(isAgencyPartnerBoard){
            return 'AgencyClient';
        }

        var companyBoardTypes = ['company'];
        var isCompanyBoard = companyBoardTypes.includes(boardType); 
        if(isCompanyBoard){
            return 'Company';
        }
    },

    buyerRole() {
        if (!this.contact || this.contact.buyerRoleId === undefined) {
            return null;
        }

        switch (this.contact.buyerRoleId) {
            case 0:
                return null;
            case 1:
                return 'Advocate';
            case 2:
                return 'Decision Maker';
            default:
                return null;
        }
    },
};
